(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory(require("axios"), require("@angular/core"), require("rxjs"), require("@angular/common"));else if (typeof define === 'function' && define.amd) define(["axios", "@angular/core", "rxjs", "@angular/common"], factory);else if (typeof exports === 'object') exports["@bytel/prisme-logger"] = factory(require("axios"), require("@angular/core"), require("rxjs"), require("@angular/common"));else root["@bytel/prisme-logger"] = factory(root["axios"], root["@angular/core"], root["rxjs"], root["@angular/common"]);
})(this, function (__WEBPACK_EXTERNAL_MODULE_axios__, __WEBPACK_EXTERNAL_MODULE__angular_core__, __WEBPACK_EXTERNAL_MODULE_rxjs__, __WEBPACK_EXTERNAL_MODULE__angular_common__) {
  return /******/function () {
    // webpackBootstrap
    /******/
    var __webpack_modules__ = {
      /***/"./node_modules/@angular/common/fesm2015/http.js": (
      /*!*******************************************************!*\
        !*** ./node_modules/@angular/common/fesm2015/http.js ***!
        \*******************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"HTTP_INTERCEPTORS": function () {
            return /* binding */HTTP_INTERCEPTORS;
          },
          /* harmony export */"HttpBackend": function () {
            return /* binding */HttpBackend;
          },
          /* harmony export */"HttpClient": function () {
            return /* binding */HttpClient;
          },
          /* harmony export */"HttpClientJsonpModule": function () {
            return /* binding */HttpClientJsonpModule;
          },
          /* harmony export */"HttpClientModule": function () {
            return /* binding */HttpClientModule;
          },
          /* harmony export */"HttpClientXsrfModule": function () {
            return /* binding */HttpClientXsrfModule;
          },
          /* harmony export */"HttpErrorResponse": function () {
            return /* binding */HttpErrorResponse;
          },
          /* harmony export */"HttpEventType": function () {
            return /* binding */HttpEventType;
          },
          /* harmony export */"HttpHandler": function () {
            return /* binding */HttpHandler;
          },
          /* harmony export */"HttpHeaderResponse": function () {
            return /* binding */HttpHeaderResponse;
          },
          /* harmony export */"HttpHeaders": function () {
            return /* binding */HttpHeaders;
          },
          /* harmony export */"HttpParams": function () {
            return /* binding */HttpParams;
          },
          /* harmony export */"HttpRequest": function () {
            return /* binding */HttpRequest;
          },
          /* harmony export */"HttpResponse": function () {
            return /* binding */HttpResponse;
          },
          /* harmony export */"HttpResponseBase": function () {
            return /* binding */HttpResponseBase;
          },
          /* harmony export */"HttpUrlEncodingCodec": function () {
            return /* binding */HttpUrlEncodingCodec;
          },
          /* harmony export */"HttpXhrBackend": function () {
            return /* binding */HttpXhrBackend;
          },
          /* harmony export */"HttpXsrfTokenExtractor": function () {
            return /* binding */HttpXsrfTokenExtractor;
          },
          /* harmony export */"JsonpClientBackend": function () {
            return /* binding */JsonpClientBackend;
          },
          /* harmony export */"JsonpInterceptor": function () {
            return /* binding */JsonpInterceptor;
          },
          /* harmony export */"XhrFactory": function () {
            return /* binding */XhrFactory;
          },
          /* harmony export */"ɵHttpInterceptingHandler": function () {
            return /* binding */HttpInterceptingHandler;
          },
          /* harmony export */"ɵangular_packages_common_http_http_a": function () {
            return /* binding */NoopInterceptor;
          },
          /* harmony export */"ɵangular_packages_common_http_http_b": function () {
            return /* binding */JsonpCallbackContext;
          },
          /* harmony export */"ɵangular_packages_common_http_http_c": function () {
            return /* binding */jsonpCallbackContext;
          },
          /* harmony export */"ɵangular_packages_common_http_http_d": function () {
            return /* binding */BrowserXhr;
          },
          /* harmony export */"ɵangular_packages_common_http_http_e": function () {
            return /* binding */XSRF_COOKIE_NAME;
          },
          /* harmony export */"ɵangular_packages_common_http_http_f": function () {
            return /* binding */XSRF_HEADER_NAME;
          },
          /* harmony export */"ɵangular_packages_common_http_http_g": function () {
            return /* binding */HttpXsrfCookieExtractor;
          },
          /* harmony export */"ɵangular_packages_common_http_http_h": function () {
            return /* binding */HttpXsrfInterceptor;
          }
          /* harmony export */
        });
        /* harmony import */
        var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */"@angular/core");
        /* harmony import */
        var _angular_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_angular_core__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */
        var rxjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! rxjs */"rxjs");
        /* harmony import */
        var rxjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(rxjs__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */
        var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */"./node_modules/rxjs/_esm5/internal/operators/concatMap.js");
        /* harmony import */
        var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */"./node_modules/rxjs/_esm5/internal/operators/filter.js");
        /* harmony import */
        var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */"./node_modules/rxjs/_esm5/internal/operators/map.js");
        /* harmony import */
        var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */"@angular/common");
        /* harmony import */
        var _angular_common__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_angular_common__WEBPACK_IMPORTED_MODULE_2__);
        /**
         * @license Angular v11.0.2
         * (c) 2010-2020 Google LLC. https://angular.io/
         * License: MIT
         */

        /**
         * @license
         * Copyright Google LLC All Rights Reserved.
         *
         * Use of this source code is governed by an MIT-style license that can be
         * found in the LICENSE file at https://angular.io/license
         */
        /**
         * Transforms an `HttpRequest` into a stream of `HttpEvent`s, one of which will likely be a
         * `HttpResponse`.
         *
         * `HttpHandler` is injectable. When injected, the handler instance dispatches requests to the
         * first interceptor in the chain, which dispatches to the second, etc, eventually reaching the
         * `HttpBackend`.
         *
         * In an `HttpInterceptor`, the `HttpHandler` parameter is the next interceptor in the chain.
         *
         * @publicApi
         */
        class HttpHandler {}
        /**
         * A final `HttpHandler` which will dispatch the request via browser HTTP APIs to a backend.
         *
         * Interceptors sit between the `HttpClient` interface and the `HttpBackend`.
         *
         * When injected, `HttpBackend` dispatches requests directly to the backend, without going
         * through the interceptor chain.
         *
         * @publicApi
         */
        class HttpBackend {}

        /**
         * @license
         * Copyright Google LLC All Rights Reserved.
         *
         * Use of this source code is governed by an MIT-style license that can be
         * found in the LICENSE file at https://angular.io/license
         */
        /**
         * Represents the header configuration options for an HTTP request.
         * Instances are immutable. Modifying methods return a cloned
         * instance with the change. The original object is never changed.
         *
         * @publicApi
         */
        class HttpHeaders {
          /**  Constructs a new HTTP header object with the given values.*/
          constructor(headers) {
            /**
             * Internal map of lowercased header names to the normalized
             * form of the name (the form seen first).
             */
            this.normalizedNames = new Map();
            /**
             * Queued updates to be materialized the next initialization.
             */
            this.lazyUpdate = null;
            if (!headers) {
              this.headers = new Map();
            } else if (typeof headers === 'string') {
              this.lazyInit = () => {
                this.headers = new Map();
                headers.split('\n').forEach(line => {
                  const index = line.indexOf(':');
                  if (index > 0) {
                    const name = line.slice(0, index);
                    const key = name.toLowerCase();
                    const value = line.slice(index + 1).trim();
                    this.maybeSetNormalizedName(name, key);
                    if (this.headers.has(key)) {
                      this.headers.get(key).push(value);
                    } else {
                      this.headers.set(key, [value]);
                    }
                  }
                });
              };
            } else {
              this.lazyInit = () => {
                this.headers = new Map();
                Object.keys(headers).forEach(name => {
                  let values = headers[name];
                  const key = name.toLowerCase();
                  if (typeof values === 'string') {
                    values = [values];
                  }
                  if (values.length > 0) {
                    this.headers.set(key, values);
                    this.maybeSetNormalizedName(name, key);
                  }
                });
              };
            }
          }
          /**
           * Checks for existence of a given header.
           *
           * @param name The header name to check for existence.
           *
           * @returns True if the header exists, false otherwise.
           */
          has(name) {
            this.init();
            return this.headers.has(name.toLowerCase());
          }
          /**
           * Retrieves the first value of a given header.
           *
           * @param name The header name.
           *
           * @returns The value string if the header exists, null otherwise
           */
          get(name) {
            this.init();
            const values = this.headers.get(name.toLowerCase());
            return values && values.length > 0 ? values[0] : null;
          }
          /**
           * Retrieves the names of the headers.
           *
           * @returns A list of header names.
           */
          keys() {
            this.init();
            return Array.from(this.normalizedNames.values());
          }
          /**
           * Retrieves a list of values for a given header.
           *
           * @param name The header name from which to retrieve values.
           *
           * @returns A string of values if the header exists, null otherwise.
           */
          getAll(name) {
            this.init();
            return this.headers.get(name.toLowerCase()) || null;
          }
          /**
           * Appends a new value to the existing set of values for a header
           * and returns them in a clone of the original instance.
           *
           * @param name The header name for which to append the values.
           * @param value The value to append.
           *
           * @returns A clone of the HTTP headers object with the value appended to the given header.
           */
          append(name, value) {
            return this.clone({
              name,
              value,
              op: 'a'
            });
          }
          /**
           * Sets or modifies a value for a given header in a clone of the original instance.
           * If the header already exists, its value is replaced with the given value
           * in the returned object.
           *
           * @param name The header name.
           * @param value The value or values to set or overide for the given header.
           *
           * @returns A clone of the HTTP headers object with the newly set header value.
           */
          set(name, value) {
            return this.clone({
              name,
              value,
              op: 's'
            });
          }
          /**
           * Deletes values for a given header in a clone of the original instance.
           *
           * @param name The header name.
           * @param value The value or values to delete for the given header.
           *
           * @returns A clone of the HTTP headers object with the given value deleted.
           */
          delete(name, value) {
            return this.clone({
              name,
              value,
              op: 'd'
            });
          }
          maybeSetNormalizedName(name, lcName) {
            if (!this.normalizedNames.has(lcName)) {
              this.normalizedNames.set(lcName, name);
            }
          }
          init() {
            if (!!this.lazyInit) {
              if (this.lazyInit instanceof HttpHeaders) {
                this.copyFrom(this.lazyInit);
              } else {
                this.lazyInit();
              }
              this.lazyInit = null;
              if (!!this.lazyUpdate) {
                this.lazyUpdate.forEach(update => this.applyUpdate(update));
                this.lazyUpdate = null;
              }
            }
          }
          copyFrom(other) {
            other.init();
            Array.from(other.headers.keys()).forEach(key => {
              this.headers.set(key, other.headers.get(key));
              this.normalizedNames.set(key, other.normalizedNames.get(key));
            });
          }
          clone(update) {
            const clone = new HttpHeaders();
            clone.lazyInit = !!this.lazyInit && this.lazyInit instanceof HttpHeaders ? this.lazyInit : this;
            clone.lazyUpdate = (this.lazyUpdate || []).concat([update]);
            return clone;
          }
          applyUpdate(update) {
            const key = update.name.toLowerCase();
            switch (update.op) {
              case 'a':
              case 's':
                let value = update.value;
                if (typeof value === 'string') {
                  value = [value];
                }
                if (value.length === 0) {
                  return;
                }
                this.maybeSetNormalizedName(update.name, key);
                const base = (update.op === 'a' ? this.headers.get(key) : undefined) || [];
                base.push(...value);
                this.headers.set(key, base);
                break;
              case 'd':
                const toDelete = update.value;
                if (!toDelete) {
                  this.headers.delete(key);
                  this.normalizedNames.delete(key);
                } else {
                  let existing = this.headers.get(key);
                  if (!existing) {
                    return;
                  }
                  existing = existing.filter(value => toDelete.indexOf(value) === -1);
                  if (existing.length === 0) {
                    this.headers.delete(key);
                    this.normalizedNames.delete(key);
                  } else {
                    this.headers.set(key, existing);
                  }
                }
                break;
            }
          }
          /**
           * @internal
           */
          forEach(fn) {
            this.init();
            Array.from(this.normalizedNames.keys()).forEach(key => fn(this.normalizedNames.get(key), this.headers.get(key)));
          }
        }

        /**
         * @license
         * Copyright Google LLC All Rights Reserved.
         *
         * Use of this source code is governed by an MIT-style license that can be
         * found in the LICENSE file at https://angular.io/license
         */
        /**
         * Provides encoding and decoding of URL parameter and query-string values.
         *
         * Serializes and parses URL parameter keys and values to encode and decode them.
         * If you pass URL query parameters without encoding,
         * the query parameters can be misinterpreted at the receiving end.
         *
         *
         * @publicApi
         */
        class HttpUrlEncodingCodec {
          /**
           * Encodes a key name for a URL parameter or query-string.
           * @param key The key name.
           * @returns The encoded key name.
           */
          encodeKey(key) {
            return standardEncoding(key);
          }
          /**
           * Encodes the value of a URL parameter or query-string.
           * @param value The value.
           * @returns The encoded value.
           */
          encodeValue(value) {
            return standardEncoding(value);
          }
          /**
           * Decodes an encoded URL parameter or query-string key.
           * @param key The encoded key name.
           * @returns The decoded key name.
           */
          decodeKey(key) {
            return decodeURIComponent(key);
          }
          /**
           * Decodes an encoded URL parameter or query-string value.
           * @param value The encoded value.
           * @returns The decoded value.
           */
          decodeValue(value) {
            return decodeURIComponent(value);
          }
        }
        function paramParser(rawParams, codec) {
          const map = new Map();
          if (rawParams.length > 0) {
            const params = rawParams.split('&');
            params.forEach(param => {
              const eqIdx = param.indexOf('=');
              const [key, val] = eqIdx == -1 ? [codec.decodeKey(param), ''] : [codec.decodeKey(param.slice(0, eqIdx)), codec.decodeValue(param.slice(eqIdx + 1))];
              const list = map.get(key) || [];
              list.push(val);
              map.set(key, list);
            });
          }
          return map;
        }
        function standardEncoding(v) {
          return encodeURIComponent(v).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/gi, '$').replace(/%2C/gi, ',').replace(/%3B/gi, ';').replace(/%2B/gi, '+').replace(/%3D/gi, '=').replace(/%3F/gi, '?').replace(/%2F/gi, '/');
        }
        /**
         * An HTTP request/response body that represents serialized parameters,
         * per the MIME type `application/x-www-form-urlencoded`.
         *
         * This class is immutable; all mutation operations return a new instance.
         *
         * @publicApi
         */
        class HttpParams {
          constructor(options = {}) {
            this.updates = null;
            this.cloneFrom = null;
            this.encoder = options.encoder || new HttpUrlEncodingCodec();
            if (!!options.fromString) {
              if (!!options.fromObject) {
                throw new Error(`Cannot specify both fromString and fromObject.`);
              }
              this.map = paramParser(options.fromString, this.encoder);
            } else if (!!options.fromObject) {
              this.map = new Map();
              Object.keys(options.fromObject).forEach(key => {
                const value = options.fromObject[key];
                this.map.set(key, Array.isArray(value) ? value : [value]);
              });
            } else {
              this.map = null;
            }
          }
          /**
           * Reports whether the body includes one or more values for a given parameter.
           * @param param The parameter name.
           * @returns True if the parameter has one or more values,
           * false if it has no value or is not present.
           */
          has(param) {
            this.init();
            return this.map.has(param);
          }
          /**
           * Retrieves the first value for a parameter.
           * @param param The parameter name.
           * @returns The first value of the given parameter,
           * or `null` if the parameter is not present.
           */
          get(param) {
            this.init();
            const res = this.map.get(param);
            return !!res ? res[0] : null;
          }
          /**
           * Retrieves all values for a  parameter.
           * @param param The parameter name.
           * @returns All values in a string array,
           * or `null` if the parameter not present.
           */
          getAll(param) {
            this.init();
            return this.map.get(param) || null;
          }
          /**
           * Retrieves all the parameters for this body.
           * @returns The parameter names in a string array.
           */
          keys() {
            this.init();
            return Array.from(this.map.keys());
          }
          /**
           * Appends a new value to existing values for a parameter.
           * @param param The parameter name.
           * @param value The new value to add.
           * @return A new body with the appended value.
           */
          append(param, value) {
            return this.clone({
              param,
              value,
              op: 'a'
            });
          }
          /**
           * Replaces the value for a parameter.
           * @param param The parameter name.
           * @param value The new value.
           * @return A new body with the new value.
           */
          set(param, value) {
            return this.clone({
              param,
              value,
              op: 's'
            });
          }
          /**
           * Removes a given value or all values from a parameter.
           * @param param The parameter name.
           * @param value The value to remove, if provided.
           * @return A new body with the given value removed, or with all values
           * removed if no value is specified.
           */
          delete(param, value) {
            return this.clone({
              param,
              value,
              op: 'd'
            });
          }
          /**
           * Serializes the body to an encoded string, where key-value pairs (separated by `=`) are
           * separated by `&`s.
           */
          toString() {
            this.init();
            return this.keys().map(key => {
              const eKey = this.encoder.encodeKey(key);
              // `a: ['1']` produces `'a=1'`
              // `b: []` produces `''`
              // `c: ['1', '2']` produces `'c=1&c=2'`
              return this.map.get(key).map(value => eKey + '=' + this.encoder.encodeValue(value)).join('&');
            })
            // filter out empty values because `b: []` produces `''`
            // which results in `a=1&&c=1&c=2` instead of `a=1&c=1&c=2` if we don't
            .filter(param => param !== '').join('&');
          }
          clone(update) {
            const clone = new HttpParams({
              encoder: this.encoder
            });
            clone.cloneFrom = this.cloneFrom || this;
            clone.updates = (this.updates || []).concat([update]);
            return clone;
          }
          init() {
            if (this.map === null) {
              this.map = new Map();
            }
            if (this.cloneFrom !== null) {
              this.cloneFrom.init();
              this.cloneFrom.keys().forEach(key => this.map.set(key, this.cloneFrom.map.get(key)));
              this.updates.forEach(update => {
                switch (update.op) {
                  case 'a':
                  case 's':
                    const base = (update.op === 'a' ? this.map.get(update.param) : undefined) || [];
                    base.push(update.value);
                    this.map.set(update.param, base);
                    break;
                  case 'd':
                    if (update.value !== undefined) {
                      let base = this.map.get(update.param) || [];
                      const idx = base.indexOf(update.value);
                      if (idx !== -1) {
                        base.splice(idx, 1);
                      }
                      if (base.length > 0) {
                        this.map.set(update.param, base);
                      } else {
                        this.map.delete(update.param);
                      }
                    } else {
                      this.map.delete(update.param);
                      break;
                    }
                }
              });
              this.cloneFrom = this.updates = null;
            }
          }
        }

        /**
         * @license
         * Copyright Google LLC All Rights Reserved.
         *
         * Use of this source code is governed by an MIT-style license that can be
         * found in the LICENSE file at https://angular.io/license
         */
        /**
         * Determine whether the given HTTP method may include a body.
         */
        function mightHaveBody(method) {
          switch (method) {
            case 'DELETE':
            case 'GET':
            case 'HEAD':
            case 'OPTIONS':
            case 'JSONP':
              return false;
            default:
              return true;
          }
        }
        /**
         * Safely assert whether the given value is an ArrayBuffer.
         *
         * In some execution environments ArrayBuffer is not defined.
         */
        function isArrayBuffer(value) {
          return typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer;
        }
        /**
         * Safely assert whether the given value is a Blob.
         *
         * In some execution environments Blob is not defined.
         */
        function isBlob(value) {
          return typeof Blob !== 'undefined' && value instanceof Blob;
        }
        /**
         * Safely assert whether the given value is a FormData instance.
         *
         * In some execution environments FormData is not defined.
         */
        function isFormData(value) {
          return typeof FormData !== 'undefined' && value instanceof FormData;
        }
        /**
         * An outgoing HTTP request with an optional typed body.
         *
         * `HttpRequest` represents an outgoing request, including URL, method,
         * headers, body, and other request configuration options. Instances should be
         * assumed to be immutable. To modify a `HttpRequest`, the `clone`
         * method should be used.
         *
         * @publicApi
         */
        class HttpRequest {
          constructor(method, url, third, fourth) {
            this.url = url;
            /**
             * The request body, or `null` if one isn't set.
             *
             * Bodies are not enforced to be immutable, as they can include a reference to any
             * user-defined data type. However, interceptors should take care to preserve
             * idempotence by treating them as such.
             */
            this.body = null;
            /**
             * Whether this request should be made in a way that exposes progress events.
             *
             * Progress events are expensive (change detection runs on each event) and so
             * they should only be requested if the consumer intends to monitor them.
             */
            this.reportProgress = false;
            /**
             * Whether this request should be sent with outgoing credentials (cookies).
             */
            this.withCredentials = false;
            /**
             * The expected response type of the server.
             *
             * This is used to parse the response appropriately before returning it to
             * the requestee.
             */
            this.responseType = 'json';
            this.method = method.toUpperCase();
            // Next, need to figure out which argument holds the HttpRequestInit
            // options, if any.
            let options;
            // Check whether a body argument is expected. The only valid way to omit
            // the body argument is to use a known no-body method like GET.
            if (mightHaveBody(this.method) || !!fourth) {
              // Body is the third argument, options are the fourth.
              this.body = third !== undefined ? third : null;
              options = fourth;
            } else {
              // No body required, options are the third argument. The body stays null.
              options = third;
            }
            // If options have been passed, interpret them.
            if (options) {
              // Normalize reportProgress and withCredentials.
              this.reportProgress = !!options.reportProgress;
              this.withCredentials = !!options.withCredentials;
              // Override default response type of 'json' if one is provided.
              if (!!options.responseType) {
                this.responseType = options.responseType;
              }
              // Override headers if they're provided.
              if (!!options.headers) {
                this.headers = options.headers;
              }
              if (!!options.params) {
                this.params = options.params;
              }
            }
            // If no headers have been passed in, construct a new HttpHeaders instance.
            if (!this.headers) {
              this.headers = new HttpHeaders();
            }
            // If no parameters have been passed in, construct a new HttpUrlEncodedParams instance.
            if (!this.params) {
              this.params = new HttpParams();
              this.urlWithParams = url;
            } else {
              // Encode the parameters to a string in preparation for inclusion in the URL.
              const params = this.params.toString();
              if (params.length === 0) {
                // No parameters, the visible URL is just the URL given at creation time.
                this.urlWithParams = url;
              } else {
                // Does the URL already have query parameters? Look for '?'.
                const qIdx = url.indexOf('?');
                // There are 3 cases to handle:
                // 1) No existing parameters -> append '?' followed by params.
                // 2) '?' exists and is followed by existing query string ->
                //    append '&' followed by params.
                // 3) '?' exists at the end of the url -> append params directly.
                // This basically amounts to determining the character, if any, with
                // which to join the URL and parameters.
                const sep = qIdx === -1 ? '?' : qIdx < url.length - 1 ? '&' : '';
                this.urlWithParams = url + sep + params;
              }
            }
          }
          /**
           * Transform the free-form body into a serialized format suitable for
           * transmission to the server.
           */
          serializeBody() {
            // If no body is present, no need to serialize it.
            if (this.body === null) {
              return null;
            }
            // Check whether the body is already in a serialized form. If so,
            // it can just be returned directly.
            if (isArrayBuffer(this.body) || isBlob(this.body) || isFormData(this.body) || typeof this.body === 'string') {
              return this.body;
            }
            // Check whether the body is an instance of HttpUrlEncodedParams.
            if (this.body instanceof HttpParams) {
              return this.body.toString();
            }
            // Check whether the body is an object or array, and serialize with JSON if so.
            if (typeof this.body === 'object' || typeof this.body === 'boolean' || Array.isArray(this.body)) {
              return JSON.stringify(this.body);
            }
            // Fall back on toString() for everything else.
            return this.body.toString();
          }
          /**
           * Examine the body and attempt to infer an appropriate MIME type
           * for it.
           *
           * If no such type can be inferred, this method will return `null`.
           */
          detectContentTypeHeader() {
            // An empty body has no content type.
            if (this.body === null) {
              return null;
            }
            // FormData bodies rely on the browser's content type assignment.
            if (isFormData(this.body)) {
              return null;
            }
            // Blobs usually have their own content type. If it doesn't, then
            // no type can be inferred.
            if (isBlob(this.body)) {
              return this.body.type || null;
            }
            // Array buffers have unknown contents and thus no type can be inferred.
            if (isArrayBuffer(this.body)) {
              return null;
            }
            // Technically, strings could be a form of JSON data, but it's safe enough
            // to assume they're plain strings.
            if (typeof this.body === 'string') {
              return 'text/plain';
            }
            // `HttpUrlEncodedParams` has its own content-type.
            if (this.body instanceof HttpParams) {
              return 'application/x-www-form-urlencoded;charset=UTF-8';
            }
            // Arrays, objects, and numbers will be encoded as JSON.
            if (typeof this.body === 'object' || typeof this.body === 'number' || Array.isArray(this.body)) {
              return 'application/json';
            }
            // No type could be inferred.
            return null;
          }
          clone(update = {}) {
            // For method, url, and responseType, take the current value unless
            // it is overridden in the update hash.
            const method = update.method || this.method;
            const url = update.url || this.url;
            const responseType = update.responseType || this.responseType;
            // The body is somewhat special - a `null` value in update.body means
            // whatever current body is present is being overridden with an empty
            // body, whereas an `undefined` value in update.body implies no
            // override.
            const body = update.body !== undefined ? update.body : this.body;
            // Carefully handle the boolean options to differentiate between
            // `false` and `undefined` in the update args.
            const withCredentials = update.withCredentials !== undefined ? update.withCredentials : this.withCredentials;
            const reportProgress = update.reportProgress !== undefined ? update.reportProgress : this.reportProgress;
            // Headers and params may be appended to if `setHeaders` or
            // `setParams` are used.
            let headers = update.headers || this.headers;
            let params = update.params || this.params;
            // Check whether the caller has asked to add headers.
            if (update.setHeaders !== undefined) {
              // Set every requested header.
              headers = Object.keys(update.setHeaders).reduce((headers, name) => headers.set(name, update.setHeaders[name]), headers);
            }
            // Check whether the caller has asked to set params.
            if (update.setParams) {
              // Set every requested param.
              params = Object.keys(update.setParams).reduce((params, param) => params.set(param, update.setParams[param]), params);
            }
            // Finally, construct the new HttpRequest using the pieces from above.
            return new HttpRequest(method, url, body, {
              params,
              headers,
              reportProgress,
              responseType,
              withCredentials
            });
          }
        }

        /**
         * @license
         * Copyright Google LLC All Rights Reserved.
         *
         * Use of this source code is governed by an MIT-style license that can be
         * found in the LICENSE file at https://angular.io/license
         */
        /**
         * Type enumeration for the different kinds of `HttpEvent`.
         *
         * @publicApi
         */
        var HttpEventType = /*#__PURE__*/function (HttpEventType) {
          /**
           * The request was sent out over the wire.
           */
          HttpEventType[HttpEventType["Sent"] = 0] = "Sent";
          /**
           * An upload progress event was received.
           */
          HttpEventType[HttpEventType["UploadProgress"] = 1] = "UploadProgress";
          /**
           * The response status code and headers were received.
           */
          HttpEventType[HttpEventType["ResponseHeader"] = 2] = "ResponseHeader";
          /**
           * A download progress event was received.
           */
          HttpEventType[HttpEventType["DownloadProgress"] = 3] = "DownloadProgress";
          /**
           * The full response including the body was received.
           */
          HttpEventType[HttpEventType["Response"] = 4] = "Response";
          /**
           * A custom event from an interceptor or a backend.
           */
          HttpEventType[HttpEventType["User"] = 5] = "User";
          return HttpEventType;
        }(HttpEventType || {});
        /**
         * Base class for both `HttpResponse` and `HttpHeaderResponse`.
         *
         * @publicApi
         */
        class HttpResponseBase {
          /**
           * Super-constructor for all responses.
           *
           * The single parameter accepted is an initialization hash. Any properties
           * of the response passed there will override the default values.
           */
          constructor(init, defaultStatus = 200, defaultStatusText = 'OK') {
            // If the hash has values passed, use them to initialize the response.
            // Otherwise use the default values.
            this.headers = init.headers || new HttpHeaders();
            this.status = init.status !== undefined ? init.status : defaultStatus;
            this.statusText = init.statusText || defaultStatusText;
            this.url = init.url || null;
            // Cache the ok value to avoid defining a getter.
            this.ok = this.status >= 200 && this.status < 300;
          }
        }
        /**
         * A partial HTTP response which only includes the status and header data,
         * but no response body.
         *
         * `HttpHeaderResponse` is a `HttpEvent` available on the response
         * event stream, only when progress events are requested.
         *
         * @publicApi
         */
        class HttpHeaderResponse extends HttpResponseBase {
          /**
           * Create a new `HttpHeaderResponse` with the given parameters.
           */
          constructor(init = {}) {
            super(init);
            this.type = HttpEventType.ResponseHeader;
          }
          /**
           * Copy this `HttpHeaderResponse`, overriding its contents with the
           * given parameter hash.
           */
          clone(update = {}) {
            // Perform a straightforward initialization of the new HttpHeaderResponse,
            // overriding the current parameters with new ones if given.
            return new HttpHeaderResponse({
              headers: update.headers || this.headers,
              status: update.status !== undefined ? update.status : this.status,
              statusText: update.statusText || this.statusText,
              url: update.url || this.url || undefined
            });
          }
        }
        /**
         * A full HTTP response, including a typed response body (which may be `null`
         * if one was not returned).
         *
         * `HttpResponse` is a `HttpEvent` available on the response event
         * stream.
         *
         * @publicApi
         */
        class HttpResponse extends HttpResponseBase {
          /**
           * Construct a new `HttpResponse`.
           */
          constructor(init = {}) {
            super(init);
            this.type = HttpEventType.Response;
            this.body = init.body !== undefined ? init.body : null;
          }
          clone(update = {}) {
            return new HttpResponse({
              body: update.body !== undefined ? update.body : this.body,
              headers: update.headers || this.headers,
              status: update.status !== undefined ? update.status : this.status,
              statusText: update.statusText || this.statusText,
              url: update.url || this.url || undefined
            });
          }
        }
        /**
         * A response that represents an error or failure, either from a
         * non-successful HTTP status, an error while executing the request,
         * or some other failure which occurred during the parsing of the response.
         *
         * Any error returned on the `Observable` response stream will be
         * wrapped in an `HttpErrorResponse` to provide additional context about
         * the state of the HTTP layer when the error occurred. The error property
         * will contain either a wrapped Error object or the error response returned
         * from the server.
         *
         * @publicApi
         */
        class HttpErrorResponse extends HttpResponseBase {
          constructor(init) {
            // Initialize with a default status of 0 / Unknown Error.
            super(init, 0, 'Unknown Error');
            this.name = 'HttpErrorResponse';
            /**
             * Errors are never okay, even when the status code is in the 2xx success range.
             */
            this.ok = false;
            // If the response was successful, then this was a parse error. Otherwise, it was
            // a protocol-level failure of some sort. Either the request failed in transit
            // or the server returned an unsuccessful status code.
            if (this.status >= 200 && this.status < 300) {
              this.message = `Http failure during parsing for ${init.url || '(unknown url)'}`;
            } else {
              this.message = `Http failure response for ${init.url || '(unknown url)'}: ${init.status} ${init.statusText}`;
            }
            this.error = init.error || null;
          }
        }

        /**
         * @license
         * Copyright Google LLC All Rights Reserved.
         *
         * Use of this source code is governed by an MIT-style license that can be
         * found in the LICENSE file at https://angular.io/license
         */
        /**
         * Constructs an instance of `HttpRequestOptions<T>` from a source `HttpMethodOptions` and
         * the given `body`. This function clones the object and adds the body.
         *
         * Note that the `responseType` *options* value is a String that identifies the
         * single data type of the response.
         * A single overload version of the method handles each response type.
         * The value of `responseType` cannot be a union, as the combined signature could imply.
         *
         */
        function addBody(options, body) {
          return {
            body,
            headers: options.headers,
            observe: options.observe,
            params: options.params,
            reportProgress: options.reportProgress,
            responseType: options.responseType,
            withCredentials: options.withCredentials
          };
        }
        /**
         * Performs HTTP requests.
         * This service is available as an injectable class, with methods to perform HTTP requests.
         * Each request method has multiple signatures, and the return type varies based on
         * the signature that is called (mainly the values of `observe` and `responseType`).
         *
         * Note that the `responseType` *options* value is a String that identifies the
         * single data type of the response.
         * A single overload version of the method handles each response type.
         * The value of `responseType` cannot be a union, as the combined signature could imply.
        
         *
         * @usageNotes
         * Sample HTTP requests for the [Tour of Heroes](/tutorial/toh-pt0) application.
         *
         * ### HTTP Request Example
         *
         * ```
         *  // GET heroes whose name contains search term
         * searchHeroes(term: string): observable<Hero[]>{
         *
         *  const params = new HttpParams({fromString: 'name=term'});
         *    return this.httpClient.request('GET', this.heroesUrl, {responseType:'json', params});
         * }
         * ```
         * ### JSONP Example
         * ```
         * requestJsonp(url, callback = 'callback') {
         *  return this.httpClient.jsonp(this.heroesURL, callback);
         * }
         * ```
         *
         * ### PATCH Example
         * ```
         * // PATCH one of the heroes' name
         * patchHero (id: number, heroName: string): Observable<{}> {
         * const url = `${this.heroesUrl}/${id}`;   // PATCH api/heroes/42
         *  return this.httpClient.patch(url, {name: heroName}, httpOptions)
         *    .pipe(catchError(this.handleError('patchHero')));
         * }
         * ```
         *
         * @see [HTTP Guide](guide/http)
         *
         * @publicApi
         */
        class HttpClient {
          constructor(handler) {
            this.handler = handler;
          }
          /**
           * Constructs an observable for a generic HTTP request that, when subscribed,
           * fires the request through the chain of registered interceptors and on to the
           * server.
           *
           * You can pass an `HttpRequest` directly as the only parameter. In this case,
           * the call returns an observable of the raw `HttpEvent` stream.
           *
           * Alternatively you can pass an HTTP method as the first parameter,
           * a URL string as the second, and an options hash containing the request body as the third.
           * See `addBody()`. In this case, the specified `responseType` and `observe` options determine the
           * type of returned observable.
           *   * The `responseType` value determines how a successful response body is parsed.
           *   * If `responseType` is the default `json`, you can pass a type interface for the resulting
           * object as a type parameter to the call.
           *
           * The `observe` value determines the return type, according to what you are interested in
           * observing.
           *   * An `observe` value of events returns an observable of the raw `HttpEvent` stream, including
           * progress events by default.
           *   * An `observe` value of response returns an observable of `HttpResponse<T>`,
           * where the `T` parameter depends on the `responseType` and any optionally provided type
           * parameter.
           *   * An `observe` value of body returns an observable of `<T>` with the same `T` body type.
           *
           */
          request(first, url, options = {}) {
            let req;
            // First, check whether the primary argument is an instance of `HttpRequest`.
            if (first instanceof HttpRequest) {
              // It is. The other arguments must be undefined (per the signatures) and can be
              // ignored.
              req = first;
            } else {
              // It's a string, so it represents a URL. Construct a request based on it,
              // and incorporate the remaining arguments (assuming `GET` unless a method is
              // provided.
              // Figure out the headers.
              let headers = undefined;
              if (options.headers instanceof HttpHeaders) {
                headers = options.headers;
              } else {
                headers = new HttpHeaders(options.headers);
              }
              // Sort out parameters.
              let params = undefined;
              if (!!options.params) {
                if (options.params instanceof HttpParams) {
                  params = options.params;
                } else {
                  params = new HttpParams({
                    fromObject: options.params
                  });
                }
              }
              // Construct the request.
              req = new HttpRequest(first, url, options.body !== undefined ? options.body : null, {
                headers,
                params,
                reportProgress: options.reportProgress,
                // By default, JSON is assumed to be returned for all calls.
                responseType: options.responseType || 'json',
                withCredentials: options.withCredentials
              });
            }
            // Start with an Observable.of() the initial request, and run the handler (which
            // includes all interceptors) inside a concatMap(). This way, the handler runs
            // inside an Observable chain, which causes interceptors to be re-run on every
            // subscription (this also makes retries re-run the handler, including interceptors).
            const events$ = (0, rxjs__WEBPACK_IMPORTED_MODULE_1__.of)(req).pipe((0, rxjs_operators__WEBPACK_IMPORTED_MODULE_3__.concatMap)(req => this.handler.handle(req)));
            // If coming via the API signature which accepts a previously constructed HttpRequest,
            // the only option is to get the event stream. Otherwise, return the event stream if
            // that is what was requested.
            if (first instanceof HttpRequest || options.observe === 'events') {
              return events$;
            }
            // The requested stream contains either the full response or the body. In either
            // case, the first step is to filter the event stream to extract a stream of
            // responses(s).
            const res$ = events$.pipe((0, rxjs_operators__WEBPACK_IMPORTED_MODULE_4__.filter)(event => event instanceof HttpResponse));
            // Decide which stream to return.
            switch (options.observe || 'body') {
              case 'body':
                // The requested stream is the body. Map the response stream to the response
                // body. This could be done more simply, but a misbehaving interceptor might
                // transform the response body into a different format and ignore the requested
                // responseType. Guard against this by validating that the response is of the
                // requested type.
                switch (req.responseType) {
                  case 'arraybuffer':
                    return res$.pipe((0, rxjs_operators__WEBPACK_IMPORTED_MODULE_5__.map)(res => {
                      // Validate that the body is an ArrayBuffer.
                      if (res.body !== null && !(res.body instanceof ArrayBuffer)) {
                        throw new Error('Response is not an ArrayBuffer.');
                      }
                      return res.body;
                    }));
                  case 'blob':
                    return res$.pipe((0, rxjs_operators__WEBPACK_IMPORTED_MODULE_5__.map)(res => {
                      // Validate that the body is a Blob.
                      if (res.body !== null && !(res.body instanceof Blob)) {
                        throw new Error('Response is not a Blob.');
                      }
                      return res.body;
                    }));
                  case 'text':
                    return res$.pipe((0, rxjs_operators__WEBPACK_IMPORTED_MODULE_5__.map)(res => {
                      // Validate that the body is a string.
                      if (res.body !== null && typeof res.body !== 'string') {
                        throw new Error('Response is not a string.');
                      }
                      return res.body;
                    }));
                  case 'json':
                  default:
                    // No validation needed for JSON responses, as they can be of any type.
                    return res$.pipe((0, rxjs_operators__WEBPACK_IMPORTED_MODULE_5__.map)(res => res.body));
                }
              case 'response':
                // The response stream was requested directly, so return it.
                return res$;
              default:
                // Guard against new future observe types being added.
                throw new Error(`Unreachable: unhandled observe type ${options.observe}}`);
            }
          }
          /**
           * Constructs an observable that, when subscribed, causes the configured
           * `DELETE` request to execute on the server. See the individual overloads for
           * details on the return type.
           *
           * @param url     The endpoint URL.
           * @param options The HTTP options to send with the request.
           *
           */
          delete(url, options = {}) {
            return this.request('DELETE', url, options);
          }
          /**
           * Constructs an observable that, when subscribed, causes the configured
           * `GET` request to execute on the server. See the individual overloads for
           * details on the return type.
           */
          get(url, options = {}) {
            return this.request('GET', url, options);
          }
          /**
           * Constructs an observable that, when subscribed, causes the configured
           * `HEAD` request to execute on the server. The `HEAD` method returns
           * meta information about the resource without transferring the
           * resource itself. See the individual overloads for
           * details on the return type.
           */
          head(url, options = {}) {
            return this.request('HEAD', url, options);
          }
          /**
           * Constructs an `Observable` that, when subscribed, causes a request with the special method
           * `JSONP` to be dispatched via the interceptor pipeline.
           * The [JSONP pattern](https://en.wikipedia.org/wiki/JSONP) works around limitations of certain
           * API endpoints that don't support newer,
           * and preferable [CORS](https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS) protocol.
           * JSONP treats the endpoint API as a JavaScript file and tricks the browser to process the
           * requests even if the API endpoint is not located on the same domain (origin) as the client-side
           * application making the request.
           * The endpoint API must support JSONP callback for JSONP requests to work.
           * The resource API returns the JSON response wrapped in a callback function.
           * You can pass the callback function name as one of the query parameters.
           * Note that JSONP requests can only be used with `GET` requests.
           *
           * @param url The resource URL.
           * @param callbackParam The callback function name.
           *
           */
          jsonp(url, callbackParam) {
            return this.request('JSONP', url, {
              params: new HttpParams().append(callbackParam, 'JSONP_CALLBACK'),
              observe: 'body',
              responseType: 'json'
            });
          }
          /**
           * Constructs an `Observable` that, when subscribed, causes the configured
           * `OPTIONS` request to execute on the server. This method allows the client
           * to determine the supported HTTP methods and other capabilites of an endpoint,
           * without implying a resource action. See the individual overloads for
           * details on the return type.
           */
          options(url, options = {}) {
            return this.request('OPTIONS', url, options);
          }
          /**
           * Constructs an observable that, when subscribed, causes the configured
           * `PATCH` request to execute on the server. See the individual overloads for
           * details on the return type.
           */
          patch(url, body, options = {}) {
            return this.request('PATCH', url, addBody(options, body));
          }
          /**
           * Constructs an observable that, when subscribed, causes the configured
           * `POST` request to execute on the server. The server responds with the location of
           * the replaced resource. See the individual overloads for
           * details on the return type.
           */
          post(url, body, options = {}) {
            return this.request('POST', url, addBody(options, body));
          }
          /**
           * Constructs an observable that, when subscribed, causes the configured
           * `PUT` request to execute on the server. The `PUT` method replaces an existing resource
           * with a new set of values.
           * See the individual overloads for details on the return type.
           */
          put(url, body, options = {}) {
            return this.request('PUT', url, addBody(options, body));
          }
        }
        /**
         * @license
         * Copyright Google LLC All Rights Reserved.
         *
         * Use of this source code is governed by an MIT-style license that can be
         * found in the LICENSE file at https://angular.io/license
         */
        /**
         * `HttpHandler` which applies an `HttpInterceptor` to an `HttpRequest`.
         *
         *
         */
        class HttpInterceptorHandler {
          constructor(next, interceptor) {
            this.next = next;
            this.interceptor = interceptor;
          }
          handle(req) {
            return this.interceptor.intercept(req, this.next);
          }
        }
        /**
         * A multi-provider token that represents the array of registered
         * `HttpInterceptor` objects.
         *
         * @publicApi
         */
        const HTTP_INTERCEPTORS = new _angular_core__WEBPACK_IMPORTED_MODULE_0__.InjectionToken('HTTP_INTERCEPTORS');
        class NoopInterceptor {
          intercept(req, next) {
            return next.handle(req);
          }
        }
        /**
         * @license
         * Copyright Google LLC All Rights Reserved.
         *
         * Use of this source code is governed by an MIT-style license that can be
         * found in the LICENSE file at https://angular.io/license
         */
        // Every request made through JSONP needs a callback name that's unique across the
        // whole page. Each request is assigned an id and the callback name is constructed
        // from that. The next id to be assigned is tracked in a global variable here that
        // is shared among all applications on the page.
        let nextRequestId = 0;
        // Error text given when a JSONP script is injected, but doesn't invoke the callback
        // passed in its URL.
        const JSONP_ERR_NO_CALLBACK = 'JSONP injected script did not invoke callback.';
        // Error text given when a request is passed to the JsonpClientBackend that doesn't
        // have a request method JSONP.
        const JSONP_ERR_WRONG_METHOD = 'JSONP requests must use JSONP request method.';
        const JSONP_ERR_WRONG_RESPONSE_TYPE = 'JSONP requests must use Json response type.';
        /**
         * DI token/abstract type representing a map of JSONP callbacks.
         *
         * In the browser, this should always be the `window` object.
         *
         *
         */
        class JsonpCallbackContext {}
        /**
         * Processes an `HttpRequest` with the JSONP method,
         * by performing JSONP style requests.
         * @see `HttpHandler`
         * @see `HttpXhrBackend`
         *
         * @publicApi
         */
        class JsonpClientBackend {
          constructor(callbackMap, document) {
            this.callbackMap = callbackMap;
            this.document = document;
            /**
             * A resolved promise that can be used to schedule microtasks in the event handlers.
             */
            this.resolvedPromise = Promise.resolve();
          }
          /**
           * Get the name of the next callback method, by incrementing the global `nextRequestId`.
           */
          nextCallback() {
            return `ng_jsonp_callback_${nextRequestId++}`;
          }
          /**
           * Processes a JSONP request and returns an event stream of the results.
           * @param req The request object.
           * @returns An observable of the response events.
           *
           */
          handle(req) {
            // Firstly, check both the method and response type. If either doesn't match
            // then the request was improperly routed here and cannot be handled.
            if (req.method !== 'JSONP') {
              throw new Error(JSONP_ERR_WRONG_METHOD);
            } else if (req.responseType !== 'json') {
              throw new Error(JSONP_ERR_WRONG_RESPONSE_TYPE);
            }
            // Everything else happens inside the Observable boundary.
            return new rxjs__WEBPACK_IMPORTED_MODULE_1__.Observable(observer => {
              // The first step to make a request is to generate the callback name, and replace the
              // callback placeholder in the URL with the name. Care has to be taken here to ensure
              // a trailing &, if matched, gets inserted back into the URL in the correct place.
              const callback = this.nextCallback();
              const url = req.urlWithParams.replace(/=JSONP_CALLBACK(&|$)/, `=${callback}$1`);
              // Construct the <script> tag and point it at the URL.
              const node = this.document.createElement('script');
              node.src = url;
              // A JSONP request requires waiting for multiple callbacks. These variables
              // are closed over and track state across those callbacks.
              // The response object, if one has been received, or null otherwise.
              let body = null;
              // Whether the response callback has been called.
              let finished = false;
              // Whether the request has been cancelled (and thus any other callbacks)
              // should be ignored.
              let cancelled = false;
              // Set the response callback in this.callbackMap (which will be the window
              // object in the browser. The script being loaded via the <script> tag will
              // eventually call this callback.
              this.callbackMap[callback] = data => {
                // Data has been received from the JSONP script. Firstly, delete this callback.
                delete this.callbackMap[callback];
                // Next, make sure the request wasn't cancelled in the meantime.
                if (cancelled) {
                  return;
                }
                // Set state to indicate data was received.
                body = data;
                finished = true;
              };
              // cleanup() is a utility closure that removes the <script> from the page and
              // the response callback from the window. This logic is used in both the
              // success, error, and cancellation paths, so it's extracted out for convenience.
              const cleanup = () => {
                // Remove the <script> tag if it's still on the page.
                if (node.parentNode) {
                  node.parentNode.removeChild(node);
                }
                // Remove the response callback from the callbackMap (window object in the
                // browser).
                delete this.callbackMap[callback];
              };
              // onLoad() is the success callback which runs after the response callback
              // if the JSONP script loads successfully. The event itself is unimportant.
              // If something went wrong, onLoad() may run without the response callback
              // having been invoked.
              const onLoad = event => {
                // Do nothing if the request has been cancelled.
                if (cancelled) {
                  return;
                }
                // We wrap it in an extra Promise, to ensure the microtask
                // is scheduled after the loaded endpoint has executed any potential microtask itself,
                // which is not guaranteed in Internet Explorer and EdgeHTML. See issue #39496
                this.resolvedPromise.then(() => {
                  // Cleanup the page.
                  cleanup();
                  // Check whether the response callback has run.
                  if (!finished) {
                    // It hasn't, something went wrong with the request. Return an error via
                    // the Observable error path. All JSONP errors have status 0.
                    observer.error(new HttpErrorResponse({
                      url,
                      status: 0,
                      statusText: 'JSONP Error',
                      error: new Error(JSONP_ERR_NO_CALLBACK)
                    }));
                    return;
                  }
                  // Success. body either contains the response body or null if none was
                  // returned.
                  observer.next(new HttpResponse({
                    body,
                    status: 200,
                    statusText: 'OK',
                    url
                  }));
                  // Complete the stream, the response is over.
                  observer.complete();
                });
              };
              // onError() is the error callback, which runs if the script returned generates
              // a Javascript error. It emits the error via the Observable error channel as
              // a HttpErrorResponse.
              const onError = error => {
                // If the request was already cancelled, no need to emit anything.
                if (cancelled) {
                  return;
                }
                cleanup();
                // Wrap the error in a HttpErrorResponse.
                observer.error(new HttpErrorResponse({
                  error,
                  status: 0,
                  statusText: 'JSONP Error',
                  url
                }));
              };
              // Subscribe to both the success (load) and error events on the <script> tag,
              // and add it to the page.
              node.addEventListener('load', onLoad);
              node.addEventListener('error', onError);
              this.document.body.appendChild(node);
              // The request has now been successfully sent.
              observer.next({
                type: HttpEventType.Sent
              });
              // Cancellation handler.
              return () => {
                // Track the cancellation so event listeners won't do anything even if already scheduled.
                cancelled = true;
                // Remove the event listeners so they won't run if the events later fire.
                node.removeEventListener('load', onLoad);
                node.removeEventListener('error', onError);
                // And finally, clean up the page.
                cleanup();
              };
            });
          }
        }
        /**
         * Identifies requests with the method JSONP and
         * shifts them to the `JsonpClientBackend`.
         *
         * @see `HttpInterceptor`
         *
         * @publicApi
         */
        class JsonpInterceptor {
          constructor(jsonp) {
            this.jsonp = jsonp;
          }
          /**
           * Identifies and handles a given JSONP request.
           * @param req The outgoing request object to handle.
           * @param next The next interceptor in the chain, or the backend
           * if no interceptors remain in the chain.
           * @returns An observable of the event stream.
           */
          intercept(req, next) {
            if (req.method === 'JSONP') {
              return this.jsonp.handle(req);
            }
            // Fall through for normal HTTP requests.
            return next.handle(req);
          }
        }
        /**
         * @license
         * Copyright Google LLC All Rights Reserved.
         *
         * Use of this source code is governed by an MIT-style license that can be
         * found in the LICENSE file at https://angular.io/license
         */
        const XSSI_PREFIX = /^\)\]\}',?\n/;
        /**
         * Determine an appropriate URL for the response, by checking either
         * XMLHttpRequest.responseURL or the X-Request-URL header.
         */
        function getResponseUrl(xhr) {
          if ('responseURL' in xhr && xhr.responseURL) {
            return xhr.responseURL;
          }
          if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
            return xhr.getResponseHeader('X-Request-URL');
          }
          return null;
        }
        /**
         * A wrapper around the `XMLHttpRequest` constructor.
         *
         * @publicApi
         */
        class XhrFactory {}
        /**
         * A factory for `HttpXhrBackend` that uses the `XMLHttpRequest` browser API.
         *
         */
        class BrowserXhr {
          constructor() {}
          build() {
            return new XMLHttpRequest();
          }
        }
        /**
         * Uses `XMLHttpRequest` to send requests to a backend server.
         * @see `HttpHandler`
         * @see `JsonpClientBackend`
         *
         * @publicApi
         */
        class HttpXhrBackend {
          constructor(xhrFactory) {
            this.xhrFactory = xhrFactory;
          }
          /**
           * Processes a request and returns a stream of response events.
           * @param req The request object.
           * @returns An observable of the response events.
           */
          handle(req) {
            // Quick check to give a better error message when a user attempts to use
            // HttpClient.jsonp() without installing the HttpClientJsonpModule
            if (req.method === 'JSONP') {
              throw new Error(`Attempted to construct Jsonp request without HttpClientJsonpModule installed.`);
            }
            // Everything happens on Observable subscription.
            return new rxjs__WEBPACK_IMPORTED_MODULE_1__.Observable(observer => {
              // Start by setting up the XHR object with request method, URL, and withCredentials flag.
              const xhr = this.xhrFactory.build();
              xhr.open(req.method, req.urlWithParams);
              if (!!req.withCredentials) {
                xhr.withCredentials = true;
              }
              // Add all the requested headers.
              req.headers.forEach((name, values) => xhr.setRequestHeader(name, values.join(',')));
              // Add an Accept header if one isn't present already.
              if (!req.headers.has('Accept')) {
                xhr.setRequestHeader('Accept', 'application/json, text/plain, */*');
              }
              // Auto-detect the Content-Type header if one isn't present already.
              if (!req.headers.has('Content-Type')) {
                const detectedType = req.detectContentTypeHeader();
                // Sometimes Content-Type detection fails.
                if (detectedType !== null) {
                  xhr.setRequestHeader('Content-Type', detectedType);
                }
              }
              // Set the responseType if one was requested.
              if (req.responseType) {
                const responseType = req.responseType.toLowerCase();
                // JSON responses need to be processed as text. This is because if the server
                // returns an XSSI-prefixed JSON response, the browser will fail to parse it,
                // xhr.response will be null, and xhr.responseText cannot be accessed to
                // retrieve the prefixed JSON data in order to strip the prefix. Thus, all JSON
                // is parsed by first requesting text and then applying JSON.parse.
                xhr.responseType = responseType !== 'json' ? responseType : 'text';
              }
              // Serialize the request body if one is present. If not, this will be set to null.
              const reqBody = req.serializeBody();
              // If progress events are enabled, response headers will be delivered
              // in two events - the HttpHeaderResponse event and the full HttpResponse
              // event. However, since response headers don't change in between these
              // two events, it doesn't make sense to parse them twice. So headerResponse
              // caches the data extracted from the response whenever it's first parsed,
              // to ensure parsing isn't duplicated.
              let headerResponse = null;
              // partialFromXhr extracts the HttpHeaderResponse from the current XMLHttpRequest
              // state, and memoizes it into headerResponse.
              const partialFromXhr = () => {
                if (headerResponse !== null) {
                  return headerResponse;
                }
                // Read status and normalize an IE9 bug (http://bugs.jquery.com/ticket/1450).
                const status = xhr.status === 1223 ? 204 : xhr.status;
                const statusText = xhr.statusText || 'OK';
                // Parse headers from XMLHttpRequest - this step is lazy.
                const headers = new HttpHeaders(xhr.getAllResponseHeaders());
                // Read the response URL from the XMLHttpResponse instance and fall back on the
                // request URL.
                const url = getResponseUrl(xhr) || req.url;
                // Construct the HttpHeaderResponse and memoize it.
                headerResponse = new HttpHeaderResponse({
                  headers,
                  status,
                  statusText,
                  url
                });
                return headerResponse;
              };
              // Next, a few closures are defined for the various events which XMLHttpRequest can
              // emit. This allows them to be unregistered as event listeners later.
              // First up is the load event, which represents a response being fully available.
              const onLoad = () => {
                // Read response state from the memoized partial data.
                let {
                  headers,
                  status,
                  statusText,
                  url
                } = partialFromXhr();
                // The body will be read out if present.
                let body = null;
                if (status !== 204) {
                  // Use XMLHttpRequest.response if set, responseText otherwise.
                  body = typeof xhr.response === 'undefined' ? xhr.responseText : xhr.response;
                }
                // Normalize another potential bug (this one comes from CORS).
                if (status === 0) {
                  status = !!body ? 200 : 0;
                }
                // ok determines whether the response will be transmitted on the event or
                // error channel. Unsuccessful status codes (not 2xx) will always be errors,
                // but a successful status code can still result in an error if the user
                // asked for JSON data and the body cannot be parsed as such.
                let ok = status >= 200 && status < 300;
                // Check whether the body needs to be parsed as JSON (in many cases the browser
                // will have done that already).
                if (req.responseType === 'json' && typeof body === 'string') {
                  // Save the original body, before attempting XSSI prefix stripping.
                  const originalBody = body;
                  body = body.replace(XSSI_PREFIX, '');
                  try {
                    // Attempt the parse. If it fails, a parse error should be delivered to the user.
                    body = body !== '' ? JSON.parse(body) : null;
                  } catch (error) {
                    // Since the JSON.parse failed, it's reasonable to assume this might not have been a
                    // JSON response. Restore the original body (including any XSSI prefix) to deliver
                    // a better error response.
                    body = originalBody;
                    // If this was an error request to begin with, leave it as a string, it probably
                    // just isn't JSON. Otherwise, deliver the parsing error to the user.
                    if (ok) {
                      // Even though the response status was 2xx, this is still an error.
                      ok = false;
                      // The parse error contains the text of the body that failed to parse.
                      body = {
                        error,
                        text: body
                      };
                    }
                  }
                }
                if (ok) {
                  // A successful response is delivered on the event stream.
                  observer.next(new HttpResponse({
                    body,
                    headers,
                    status,
                    statusText,
                    url: url || undefined
                  }));
                  // The full body has been received and delivered, no further events
                  // are possible. This request is complete.
                  observer.complete();
                } else {
                  // An unsuccessful request is delivered on the error channel.
                  observer.error(new HttpErrorResponse({
                    // The error in this case is the response body (error from the server).
                    error: body,
                    headers,
                    status,
                    statusText,
                    url: url || undefined
                  }));
                }
              };
              // The onError callback is called when something goes wrong at the network level.
              // Connection timeout, DNS error, offline, etc. These are actual errors, and are
              // transmitted on the error channel.
              const onError = error => {
                const {
                  url
                } = partialFromXhr();
                const res = new HttpErrorResponse({
                  error,
                  status: xhr.status || 0,
                  statusText: xhr.statusText || 'Unknown Error',
                  url: url || undefined
                });
                observer.error(res);
              };
              // The sentHeaders flag tracks whether the HttpResponseHeaders event
              // has been sent on the stream. This is necessary to track if progress
              // is enabled since the event will be sent on only the first download
              // progerss event.
              let sentHeaders = false;
              // The download progress event handler, which is only registered if
              // progress events are enabled.
              const onDownProgress = event => {
                // Send the HttpResponseHeaders event if it hasn't been sent already.
                if (!sentHeaders) {
                  observer.next(partialFromXhr());
                  sentHeaders = true;
                }
                // Start building the download progress event to deliver on the response
                // event stream.
                let progressEvent = {
                  type: HttpEventType.DownloadProgress,
                  loaded: event.loaded
                };
                // Set the total number of bytes in the event if it's available.
                if (event.lengthComputable) {
                  progressEvent.total = event.total;
                }
                // If the request was for text content and a partial response is
                // available on XMLHttpRequest, include it in the progress event
                // to allow for streaming reads.
                if (req.responseType === 'text' && !!xhr.responseText) {
                  progressEvent.partialText = xhr.responseText;
                }
                // Finally, fire the event.
                observer.next(progressEvent);
              };
              // The upload progress event handler, which is only registered if
              // progress events are enabled.
              const onUpProgress = event => {
                // Upload progress events are simpler. Begin building the progress
                // event.
                let progress = {
                  type: HttpEventType.UploadProgress,
                  loaded: event.loaded
                };
                // If the total number of bytes being uploaded is available, include
                // it.
                if (event.lengthComputable) {
                  progress.total = event.total;
                }
                // Send the event.
                observer.next(progress);
              };
              // By default, register for load and error events.
              xhr.addEventListener('load', onLoad);
              xhr.addEventListener('error', onError);
              // Progress events are only enabled if requested.
              if (req.reportProgress) {
                // Download progress is always enabled if requested.
                xhr.addEventListener('progress', onDownProgress);
                // Upload progress depends on whether there is a body to upload.
                if (reqBody !== null && xhr.upload) {
                  xhr.upload.addEventListener('progress', onUpProgress);
                }
              }
              // Fire the request, and notify the event stream that it was fired.
              xhr.send(reqBody);
              observer.next({
                type: HttpEventType.Sent
              });
              // This is the return from the Observable function, which is the
              // request cancellation handler.
              return () => {
                // On a cancellation, remove all registered event listeners.
                xhr.removeEventListener('error', onError);
                xhr.removeEventListener('load', onLoad);
                if (req.reportProgress) {
                  xhr.removeEventListener('progress', onDownProgress);
                  if (reqBody !== null && xhr.upload) {
                    xhr.upload.removeEventListener('progress', onUpProgress);
                  }
                }
                // Finally, abort the in-flight request.
                if (xhr.readyState !== xhr.DONE) {
                  xhr.abort();
                }
              };
            });
          }
        }
        /**
         * @license
         * Copyright Google LLC All Rights Reserved.
         *
         * Use of this source code is governed by an MIT-style license that can be
         * found in the LICENSE file at https://angular.io/license
         */
        const XSRF_COOKIE_NAME = new _angular_core__WEBPACK_IMPORTED_MODULE_0__.InjectionToken('XSRF_COOKIE_NAME');
        const XSRF_HEADER_NAME = new _angular_core__WEBPACK_IMPORTED_MODULE_0__.InjectionToken('XSRF_HEADER_NAME');
        /**
         * Retrieves the current XSRF token to use with the next outgoing request.
         *
         * @publicApi
         */
        class HttpXsrfTokenExtractor {}
        /**
         * `HttpXsrfTokenExtractor` which retrieves the token from a cookie.
         */
        class HttpXsrfCookieExtractor {
          constructor(doc, platform, cookieName) {
            this.doc = doc;
            this.platform = platform;
            this.cookieName = cookieName;
            this.lastCookieString = '';
            this.lastToken = null;
            /**
             * @internal for testing
             */
            this.parseCount = 0;
          }
          getToken() {
            if (this.platform === 'server') {
              return null;
            }
            const cookieString = this.doc.cookie || '';
            if (cookieString !== this.lastCookieString) {
              this.parseCount++;
              this.lastToken = (0, _angular_common__WEBPACK_IMPORTED_MODULE_2__["ɵparseCookieValue"])(cookieString, this.cookieName);
              this.lastCookieString = cookieString;
            }
            return this.lastToken;
          }
        }
        /**
         * `HttpInterceptor` which adds an XSRF token to eligible outgoing requests.
         */
        class HttpXsrfInterceptor {
          constructor(tokenService, headerName) {
            this.tokenService = tokenService;
            this.headerName = headerName;
          }
          intercept(req, next) {
            const lcUrl = req.url.toLowerCase();
            // Skip both non-mutating requests and absolute URLs.
            // Non-mutating requests don't require a token, and absolute URLs require special handling
            // anyway as the cookie set
            // on our origin is not the same as the token expected by another origin.
            if (req.method === 'GET' || req.method === 'HEAD' || lcUrl.startsWith('http://') || lcUrl.startsWith('https://')) {
              return next.handle(req);
            }
            const token = this.tokenService.getToken();
            // Be careful not to overwrite an existing header of the same name.
            if (token !== null && !req.headers.has(this.headerName)) {
              req = req.clone({
                headers: req.headers.set(this.headerName, token)
              });
            }
            return next.handle(req);
          }
        }
        /**
         * @license
         * Copyright Google LLC All Rights Reserved.
         *
         * Use of this source code is governed by an MIT-style license that can be
         * found in the LICENSE file at https://angular.io/license
         */
        /**
         * An injectable `HttpHandler` that applies multiple interceptors
         * to a request before passing it to the given `HttpBackend`.
         *
         * The interceptors are loaded lazily from the injector, to allow
         * interceptors to themselves inject classes depending indirectly
         * on `HttpInterceptingHandler` itself.
         * @see `HttpInterceptor`
         */
        class HttpInterceptingHandler {
          constructor(backend, injector) {
            this.backend = backend;
            this.injector = injector;
            this.chain = null;
          }
          handle(req) {
            if (this.chain === null) {
              const interceptors = this.injector.get(HTTP_INTERCEPTORS, []);
              this.chain = interceptors.reduceRight((next, interceptor) => new HttpInterceptorHandler(next, interceptor), this.backend);
            }
            return this.chain.handle(req);
          }
        }
        /**
         * Constructs an `HttpHandler` that applies interceptors
         * to a request before passing it to the given `HttpBackend`.
         *
         * Use as a factory function within `HttpClientModule`.
         *
         *
         */
        function interceptingHandler(backend, interceptors = []) {
          if (!interceptors) {
            return backend;
          }
          return interceptors.reduceRight((next, interceptor) => new HttpInterceptorHandler(next, interceptor), backend);
        }
        /**
         * Factory function that determines where to store JSONP callbacks.
         *
         * Ordinarily JSONP callbacks are stored on the `window` object, but this may not exist
         * in test environments. In that case, callbacks are stored on an anonymous object instead.
         *
         *
         */
        function jsonpCallbackContext() {
          if (typeof window === 'object') {
            return window;
          }
          return {};
        }
        /**
         * Configures XSRF protection support for outgoing requests.
         *
         * For a server that supports a cookie-based XSRF protection system,
         * use directly to configure XSRF protection with the correct
         * cookie and header names.
         *
         * If no names are supplied, the default cookie name is `XSRF-TOKEN`
         * and the default header name is `X-XSRF-TOKEN`.
         *
         * @publicApi
         */
        class HttpClientXsrfModule {
          /**
           * Disable the default XSRF protection.
           */
          static disable() {
            return {
              ngModule: HttpClientXsrfModule,
              providers: [{
                provide: HttpXsrfInterceptor,
                useClass: NoopInterceptor
              }]
            };
          }
          /**
           * Configure XSRF protection.
           * @param options An object that can specify either or both
           * cookie name or header name.
           * - Cookie name default is `XSRF-TOKEN`.
           * - Header name default is `X-XSRF-TOKEN`.
           *
           */
          static withOptions(options = {}) {
            return {
              ngModule: HttpClientXsrfModule,
              providers: [options.cookieName ? {
                provide: XSRF_COOKIE_NAME,
                useValue: options.cookieName
              } : [], options.headerName ? {
                provide: XSRF_HEADER_NAME,
                useValue: options.headerName
              } : []]
            };
          }
        }
        /**
         * Configures the [dependency injector](guide/glossary#injector) for `HttpClient`
         * with supporting services for XSRF. Automatically imported by `HttpClientModule`.
         *
         * You can add interceptors to the chain behind `HttpClient` by binding them to the
         * multiprovider for built-in [DI token](guide/glossary#di-token) `HTTP_INTERCEPTORS`.
         *
         * @publicApi
         */
        class HttpClientModule {}
        /**
         * Configures the [dependency injector](guide/glossary#injector) for `HttpClient`
         * with supporting services for JSONP.
         * Without this module, Jsonp requests reach the backend
         * with method JSONP, where they are rejected.
         *
         * You can add interceptors to the chain behind `HttpClient` by binding them to the
         * multiprovider for built-in [DI token](guide/glossary#di-token) `HTTP_INTERCEPTORS`.
         *
         * @publicApi
         */
        class HttpClientJsonpModule {}

        /**
         * @license
         * Copyright Google LLC All Rights Reserved.
         *
         * Use of this source code is governed by an MIT-style license that can be
         * found in the LICENSE file at https://angular.io/license
         */

        /**
         * @license
         * Copyright Google LLC All Rights Reserved.
         *
         * Use of this source code is governed by an MIT-style license that can be
         * found in the LICENSE file at https://angular.io/license
         */

        /**
         * Generated bundle index. Do not edit.
         */

        //# sourceMappingURL=http.js.map

        /***/
      }),
      /***/"./node_modules/ip-regex/index.js": (
      /*!****************************************!*\
        !*** ./node_modules/ip-regex/index.js ***!
        \****************************************/
      /***/
      function (module) {
        "use strict";

        var word = '[a-fA-F\\d:]';
        var b = function b(options) {
          return options && options.includeBoundaries ? "(?:(?<=\\s|^)(?=".concat(word, ")|(?<=").concat(word, ")(?=\\s|$))") : '';
        };
        var v4 = '(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}';
        var v6seg = '[a-fA-F\\d]{1,4}';
        var v6 = "\n(\n(?:".concat(v6seg, ":){7}(?:").concat(v6seg, "|:)|                                // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8\n(?:").concat(v6seg, ":){6}(?:").concat(v4, "|:").concat(v6seg, "|:)|                         // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4\n(?:").concat(v6seg, ":){5}(?::").concat(v4, "|(:").concat(v6seg, "){1,2}|:)|                 // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4\n(?:").concat(v6seg, ":){4}(?:(:").concat(v6seg, "){0,1}:").concat(v4, "|(:").concat(v6seg, "){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4\n(?:").concat(v6seg, ":){3}(?:(:").concat(v6seg, "){0,2}:").concat(v4, "|(:").concat(v6seg, "){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4\n(?:").concat(v6seg, ":){2}(?:(:").concat(v6seg, "){0,3}:").concat(v4, "|(:").concat(v6seg, "){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4\n(?:").concat(v6seg, ":){1}(?:(:").concat(v6seg, "){0,4}:").concat(v4, "|(:").concat(v6seg, "){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4\n(?::((?::").concat(v6seg, "){0,5}:").concat(v4, "|(?::").concat(v6seg, "){1,7}|:))           // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4\n)(%[0-9a-zA-Z]{1,})?                                           // %eth0            %1\n").replace(/\s*\/\/.*$/gm, '').replace(/\n/g, '').trim(); // Pre-compile only the exact regexes because adding a global flag make regexes stateful

        var v46Exact = new RegExp("(?:^".concat(v4, "$)|(?:^").concat(v6, "$)"));
        var v4exact = new RegExp("^".concat(v4, "$"));
        var v6exact = new RegExp("^".concat(v6, "$"));
        var ip = function ip(options) {
          return options && options.exact ? v46Exact : new RegExp("(?:".concat(b(options)).concat(v4).concat(b(options), ")|(?:").concat(b(options)).concat(v6).concat(b(options), ")"), 'g');
        };
        ip.v4 = function (options) {
          return options && options.exact ? v4exact : new RegExp("".concat(b(options)).concat(v4).concat(b(options)), 'g');
        };
        ip.v6 = function (options) {
          return options && options.exact ? v6exact : new RegExp("".concat(b(options)).concat(v6).concat(b(options)), 'g');
        };
        module.exports = ip;

        /***/
      }),
      /***/"./node_modules/is-ip/index.js": (
      /*!*************************************!*\
        !*** ./node_modules/is-ip/index.js ***!
        \*************************************/
      /***/
      function (module, __unused_webpack_exports, __webpack_require__) {
        "use strict";

        var ipRegex = __webpack_require__(/*! ip-regex */"./node_modules/ip-regex/index.js");
        var isIp = function isIp(string) {
          return ipRegex({
            exact: true
          }).test(string);
        };
        isIp.v4 = function (string) {
          return ipRegex.v4({
            exact: true
          }).test(string);
        };
        isIp.v6 = function (string) {
          return ipRegex.v6({
            exact: true
          }).test(string);
        };
        isIp.version = function (string) {
          return isIp(string) ? isIp.v4(string) ? 4 : 6 : undefined;
        };
        module.exports = isIp;

        /***/
      }),
      /***/"./node_modules/public-ip/browser.js": (
      /*!*******************************************!*\
        !*** ./node_modules/public-ip/browser.js ***!
        \*******************************************/
      /***/
      function (module, __unused_webpack_exports, __webpack_require__) {
        "use strict";

        function ownKeys(object, enumerableOnly) {
          var keys = Object.keys(object);
          if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function (sym) {
              return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
          }
          return keys;
        }
        function _objectSpread(target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) {
              ownKeys(Object(source), true).forEach(function (key) {
                _defineProperty(target, key, source[key]);
              });
            } else if (Object.getOwnPropertyDescriptors) {
              Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            } else {
              ownKeys(Object(source)).forEach(function (key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
              });
            }
          }
          return target;
        }
        function _defineProperty(obj, key, value) {
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true
            });
          } else {
            obj[key] = value;
          }
          return obj;
        }
        function _createForOfIteratorHelper(o, allowArrayLike) {
          var it;
          if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
            if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
              if (it) o = it;
              var i = 0;
              var F = function F() {};
              return {
                s: F,
                n: function n() {
                  if (i >= o.length) return {
                    done: true
                  };
                  return {
                    done: false,
                    value: o[i++]
                  };
                },
                e: function e(_e) {
                  throw _e;
                },
                f: F
              };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }
          var normalCompletion = true,
            didErr = false,
            err;
          return {
            s: function s() {
              it = o[Symbol.iterator]();
            },
            n: function n() {
              var step = it.next();
              normalCompletion = step.done;
              return step;
            },
            e: function e(_e2) {
              didErr = true;
              err = _e2;
            },
            f: function f() {
              try {
                if (!normalCompletion && it["return"] != null) it["return"]();
              } finally {
                if (didErr) throw err;
              }
            }
          };
        }
        function _unsupportedIterableToArray(o, minLen) {
          if (!o) return;
          if (typeof o === "string") return _arrayLikeToArray(o, minLen);
          var n = Object.prototype.toString.call(o).slice(8, -1);
          if (n === "Object" && o.constructor) n = o.constructor.name;
          if (n === "Map" || n === "Set") return Array.from(o);
          if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
        }
        function _arrayLikeToArray(arr, len) {
          if (len == null || len > arr.length) len = arr.length;
          for (var i = 0, arr2 = new Array(len); i < len; i++) {
            arr2[i] = arr[i];
          }
          return arr2;
        }
        function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
          try {
            var info = gen[key](arg);
            var value = info.value;
          } catch (error) {
            reject(error);
            return;
          }
          if (info.done) {
            resolve(value);
          } else {
            Promise.resolve(value).then(_next, _throw);
          }
        }
        function _asyncToGenerator(fn) {
          return function () {
            var self = this,
              args = arguments;
            return new Promise(function (resolve, reject) {
              var gen = fn.apply(self, args);
              function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
              }
              function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
              }
              _next(undefined);
            });
          };
        }
        var isIp = __webpack_require__(/*! is-ip */"./node_modules/is-ip/index.js");
        var defaults = {
          timeout: 5000
        };
        var urls = {
          v4: ['https://ipv4.icanhazip.com/', 'https://api.ipify.org/'],
          v6: ['https://ipv6.icanhazip.com/', 'https://api6.ipify.org/']
        };
        var xhr;
        var sendXhr = /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(url, options, version) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    return _context.abrupt("return", new Promise(function (resolve, reject) {
                      xhr = new XMLHttpRequest();
                      xhr.addEventListener('error', reject, {
                        once: true
                      });
                      xhr.addEventListener('timeout', reject, {
                        once: true
                      });
                      xhr.addEventListener('load', function () {
                        var ip = xhr.responseText.trim();
                        if (!ip || !isIp[version](ip)) {
                          reject();
                          return;
                        }
                        resolve(ip);
                      }, {
                        once: true
                      });
                      xhr.open('GET', url);
                      xhr.timeout = options.timeout;
                      xhr.send();
                    }));
                  case 1:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));
          return function sendXhr(_x, _x2, _x3) {
            return _ref.apply(this, arguments);
          };
        }();
        var queryHttps = /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(version, options) {
            var ip, urls_, _iterator, _step, url;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    urls_ = [].concat.apply(urls[version], options.fallbackUrls || []);
                    _iterator = _createForOfIteratorHelper(urls_);
                    _context2.prev = 2;
                    _iterator.s();
                  case 4:
                    if ((_step = _iterator.n()).done) {
                      _context2.next = 17;
                      break;
                    }
                    url = _step.value;
                    _context2.prev = 6;
                    _context2.next = 9;
                    return sendXhr(url, options, version);
                  case 9:
                    ip = _context2.sent;
                    return _context2.abrupt("return", ip);
                  case 13:
                    _context2.prev = 13;
                    _context2.t0 = _context2["catch"](6);
                  case 15:
                    _context2.next = 4;
                    break;
                  case 17:
                    _context2.next = 22;
                    break;
                  case 19:
                    _context2.prev = 19;
                    _context2.t1 = _context2["catch"](2);
                    _iterator.e(_context2.t1);
                  case 22:
                    _context2.prev = 22;
                    _iterator.f();
                    return _context2.finish(22);
                  case 25:
                    throw new Error('Couldn\'t find your IP');
                  case 26:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, null, [[2, 19, 22, 25], [6, 13]]);
          }));
          return function queryHttps(_x4, _x5) {
            return _ref2.apply(this, arguments);
          };
        }();
        queryHttps.cancel = function () {
          xhr.abort();
        };
        module.exports.v4 = function (options) {
          return queryHttps('v4', _objectSpread(_objectSpread({}, defaults), options));
        };
        module.exports.v6 = function (options) {
          return queryHttps('v6', _objectSpread(_objectSpread({}, defaults), options));
        };

        /***/
      }),
      /***/"./node_modules/date-fns/esm/_lib/addLeadingZeros/index.js": (
      /*!*****************************************************************!*\
        !*** ./node_modules/date-fns/esm/_lib/addLeadingZeros/index.js ***!
        \*****************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function () {
            return /* binding */addLeadingZeros;
          }
          /* harmony export */
        });
        function addLeadingZeros(number, targetLength) {
          var sign = number < 0 ? '-' : '';
          var output = Math.abs(number).toString();
          while (output.length < targetLength) {
            output = '0' + output;
          }
          return sign + output;
        }

        /***/
      }),
      /***/"./node_modules/date-fns/esm/_lib/format/formatters/index.js": (
      /*!*******************************************************************!*\
        !*** ./node_modules/date-fns/esm/_lib/format/formatters/index.js ***!
        \*******************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */
        var _lightFormatters_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../lightFormatters/index.js */"./node_modules/date-fns/esm/_lib/format/lightFormatters/index.js");
        /* harmony import */
        var _lib_getUTCDayOfYear_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../_lib/getUTCDayOfYear/index.js */"./node_modules/date-fns/esm/_lib/getUTCDayOfYear/index.js");
        /* harmony import */
        var _lib_getUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../_lib/getUTCISOWeek/index.js */"./node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js");
        /* harmony import */
        var _lib_getUTCISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../_lib/getUTCISOWeekYear/index.js */"./node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js");
        /* harmony import */
        var _lib_getUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../_lib/getUTCWeek/index.js */"./node_modules/date-fns/esm/_lib/getUTCWeek/index.js");
        /* harmony import */
        var _lib_getUTCWeekYear_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../_lib/getUTCWeekYear/index.js */"./node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js");
        /* harmony import */
        var _addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../addLeadingZeros/index.js */"./node_modules/date-fns/esm/_lib/addLeadingZeros/index.js");
        var dayPeriodEnum = {
          am: 'am',
          pm: 'pm',
          midnight: 'midnight',
          noon: 'noon',
          morning: 'morning',
          afternoon: 'afternoon',
          evening: 'evening',
          night: 'night'
          /*
           * |     | Unit                           |     | Unit                           |
           * |-----|--------------------------------|-----|--------------------------------|
           * |  a  | AM, PM                         |  A* | Milliseconds in day            |
           * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
           * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
           * |  d  | Day of month                   |  D  | Day of year                    |
           * |  e  | Local day of week              |  E  | Day of week                    |
           * |  f  |                                |  F* | Day of week in month           |
           * |  g* | Modified Julian day            |  G  | Era                            |
           * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
           * |  i! | ISO day of week                |  I! | ISO week of year               |
           * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
           * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
           * |  l* | (deprecated)                   |  L  | Stand-alone month              |
           * |  m  | Minute                         |  M  | Month                          |
           * |  n  |                                |  N  |                                |
           * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
           * |  p! | Long localized time            |  P! | Long localized date            |
           * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
           * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
           * |  s  | Second                         |  S  | Fraction of second             |
           * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
           * |  u  | Extended year                  |  U* | Cyclic year                    |
           * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
           * |  w  | Local week of year             |  W* | Week of month                  |
           * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
           * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
           * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
           *
           * Letters marked by * are not implemented but reserved by Unicode standard.
           *
           * Letters marked by ! are non-standard, but implemented by date-fns:
           * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
           * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
           *   i.e. 7 for Sunday, 1 for Monday, etc.
           * - `I` is ISO week of year, as opposed to `w` which is local week of year.
           * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
           *   `R` is supposed to be used in conjunction with `I` and `i`
           *   for universal ISO week-numbering date, whereas
           *   `Y` is supposed to be used in conjunction with `w` and `e`
           *   for week-numbering date specific to the locale.
           * - `P` is long localized date format
           * - `p` is long localized time format
           */
        };
        var formatters = {
          // Era
          G: function (date, token, localize) {
            var era = date.getUTCFullYear() > 0 ? 1 : 0;
            switch (token) {
              // AD, BC
              case 'G':
              case 'GG':
              case 'GGG':
                return localize.era(era, {
                  width: 'abbreviated'
                });
              // A, B

              case 'GGGGG':
                return localize.era(era, {
                  width: 'narrow'
                });
              // Anno Domini, Before Christ

              case 'GGGG':
              default:
                return localize.era(era, {
                  width: 'wide'
                });
            }
          },
          // Year
          y: function (date, token, localize) {
            // Ordinal number
            if (token === 'yo') {
              var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

              var year = signedYear > 0 ? signedYear : 1 - signedYear;
              return localize.ordinalNumber(year, {
                unit: 'year'
              });
            }
            return _lightFormatters_index_js__WEBPACK_IMPORTED_MODULE_0__.default.y(date, token);
          },
          // Local week-numbering year
          Y: function (date, token, localize, options) {
            var signedWeekYear = (0, _lib_getUTCWeekYear_index_js__WEBPACK_IMPORTED_MODULE_1__.default)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

            var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

            if (token === 'YY') {
              var twoDigitYear = weekYear % 100;
              return (0, _addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_2__.default)(twoDigitYear, 2);
            } // Ordinal number

            if (token === 'Yo') {
              return localize.ordinalNumber(weekYear, {
                unit: 'year'
              });
            } // Padding

            return (0, _addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_2__.default)(weekYear, token.length);
          },
          // ISO week-numbering year
          R: function (date, token) {
            var isoWeekYear = (0, _lib_getUTCISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_3__.default)(date); // Padding

            return (0, _addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_2__.default)(isoWeekYear, token.length);
          },
          // Extended year. This is a single number designating the year of this calendar system.
          // The main difference between `y` and `u` localizers are B.C. years:
          // | Year | `y` | `u` |
          // |------|-----|-----|
          // | AC 1 |   1 |   1 |
          // | BC 1 |   1 |   0 |
          // | BC 2 |   2 |  -1 |
          // Also `yy` always returns the last two digits of a year,
          // while `uu` pads single digit years to 2 characters and returns other years unchanged.
          u: function (date, token) {
            var year = date.getUTCFullYear();
            return (0, _addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_2__.default)(year, token.length);
          },
          // Quarter
          Q: function (date, token, localize) {
            var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
            switch (token) {
              // 1, 2, 3, 4
              case 'Q':
                return String(quarter);
              // 01, 02, 03, 04

              case 'QQ':
                return (0, _addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_2__.default)(quarter, 2);
              // 1st, 2nd, 3rd, 4th

              case 'Qo':
                return localize.ordinalNumber(quarter, {
                  unit: 'quarter'
                });
              // Q1, Q2, Q3, Q4

              case 'QQQ':
                return localize.quarter(quarter, {
                  width: 'abbreviated',
                  context: 'formatting'
                });
              // 1, 2, 3, 4 (narrow quarter; could be not numerical)

              case 'QQQQQ':
                return localize.quarter(quarter, {
                  width: 'narrow',
                  context: 'formatting'
                });
              // 1st quarter, 2nd quarter, ...

              case 'QQQQ':
              default:
                return localize.quarter(quarter, {
                  width: 'wide',
                  context: 'formatting'
                });
            }
          },
          // Stand-alone quarter
          q: function (date, token, localize) {
            var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
            switch (token) {
              // 1, 2, 3, 4
              case 'q':
                return String(quarter);
              // 01, 02, 03, 04

              case 'qq':
                return (0, _addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_2__.default)(quarter, 2);
              // 1st, 2nd, 3rd, 4th

              case 'qo':
                return localize.ordinalNumber(quarter, {
                  unit: 'quarter'
                });
              // Q1, Q2, Q3, Q4

              case 'qqq':
                return localize.quarter(quarter, {
                  width: 'abbreviated',
                  context: 'standalone'
                });
              // 1, 2, 3, 4 (narrow quarter; could be not numerical)

              case 'qqqqq':
                return localize.quarter(quarter, {
                  width: 'narrow',
                  context: 'standalone'
                });
              // 1st quarter, 2nd quarter, ...

              case 'qqqq':
              default:
                return localize.quarter(quarter, {
                  width: 'wide',
                  context: 'standalone'
                });
            }
          },
          // Month
          M: function (date, token, localize) {
            var month = date.getUTCMonth();
            switch (token) {
              case 'M':
              case 'MM':
                return _lightFormatters_index_js__WEBPACK_IMPORTED_MODULE_0__.default.M(date, token);
              // 1st, 2nd, ..., 12th

              case 'Mo':
                return localize.ordinalNumber(month + 1, {
                  unit: 'month'
                });
              // Jan, Feb, ..., Dec

              case 'MMM':
                return localize.month(month, {
                  width: 'abbreviated',
                  context: 'formatting'
                });
              // J, F, ..., D

              case 'MMMMM':
                return localize.month(month, {
                  width: 'narrow',
                  context: 'formatting'
                });
              // January, February, ..., December

              case 'MMMM':
              default:
                return localize.month(month, {
                  width: 'wide',
                  context: 'formatting'
                });
            }
          },
          // Stand-alone month
          L: function (date, token, localize) {
            var month = date.getUTCMonth();
            switch (token) {
              // 1, 2, ..., 12
              case 'L':
                return String(month + 1);
              // 01, 02, ..., 12

              case 'LL':
                return (0, _addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_2__.default)(month + 1, 2);
              // 1st, 2nd, ..., 12th

              case 'Lo':
                return localize.ordinalNumber(month + 1, {
                  unit: 'month'
                });
              // Jan, Feb, ..., Dec

              case 'LLL':
                return localize.month(month, {
                  width: 'abbreviated',
                  context: 'standalone'
                });
              // J, F, ..., D

              case 'LLLLL':
                return localize.month(month, {
                  width: 'narrow',
                  context: 'standalone'
                });
              // January, February, ..., December

              case 'LLLL':
              default:
                return localize.month(month, {
                  width: 'wide',
                  context: 'standalone'
                });
            }
          },
          // Local week of year
          w: function (date, token, localize, options) {
            var week = (0, _lib_getUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_4__.default)(date, options);
            if (token === 'wo') {
              return localize.ordinalNumber(week, {
                unit: 'week'
              });
            }
            return (0, _addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_2__.default)(week, token.length);
          },
          // ISO week of year
          I: function (date, token, localize) {
            var isoWeek = (0, _lib_getUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_5__.default)(date);
            if (token === 'Io') {
              return localize.ordinalNumber(isoWeek, {
                unit: 'week'
              });
            }
            return (0, _addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_2__.default)(isoWeek, token.length);
          },
          // Day of the month
          d: function (date, token, localize) {
            if (token === 'do') {
              return localize.ordinalNumber(date.getUTCDate(), {
                unit: 'date'
              });
            }
            return _lightFormatters_index_js__WEBPACK_IMPORTED_MODULE_0__.default.d(date, token);
          },
          // Day of year
          D: function (date, token, localize) {
            var dayOfYear = (0, _lib_getUTCDayOfYear_index_js__WEBPACK_IMPORTED_MODULE_6__.default)(date);
            if (token === 'Do') {
              return localize.ordinalNumber(dayOfYear, {
                unit: 'dayOfYear'
              });
            }
            return (0, _addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_2__.default)(dayOfYear, token.length);
          },
          // Day of week
          E: function (date, token, localize) {
            var dayOfWeek = date.getUTCDay();
            switch (token) {
              // Tue
              case 'E':
              case 'EE':
              case 'EEE':
                return localize.day(dayOfWeek, {
                  width: 'abbreviated',
                  context: 'formatting'
                });
              // T

              case 'EEEEE':
                return localize.day(dayOfWeek, {
                  width: 'narrow',
                  context: 'formatting'
                });
              // Tu

              case 'EEEEEE':
                return localize.day(dayOfWeek, {
                  width: 'short',
                  context: 'formatting'
                });
              // Tuesday

              case 'EEEE':
              default:
                return localize.day(dayOfWeek, {
                  width: 'wide',
                  context: 'formatting'
                });
            }
          },
          // Local day of week
          e: function (date, token, localize, options) {
            var dayOfWeek = date.getUTCDay();
            var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
            switch (token) {
              // Numerical value (Nth day of week with current locale or weekStartsOn)
              case 'e':
                return String(localDayOfWeek);
              // Padded numerical value

              case 'ee':
                return (0, _addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_2__.default)(localDayOfWeek, 2);
              // 1st, 2nd, ..., 7th

              case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                  unit: 'day'
                });
              case 'eee':
                return localize.day(dayOfWeek, {
                  width: 'abbreviated',
                  context: 'formatting'
                });
              // T

              case 'eeeee':
                return localize.day(dayOfWeek, {
                  width: 'narrow',
                  context: 'formatting'
                });
              // Tu

              case 'eeeeee':
                return localize.day(dayOfWeek, {
                  width: 'short',
                  context: 'formatting'
                });
              // Tuesday

              case 'eeee':
              default:
                return localize.day(dayOfWeek, {
                  width: 'wide',
                  context: 'formatting'
                });
            }
          },
          // Stand-alone local day of week
          c: function (date, token, localize, options) {
            var dayOfWeek = date.getUTCDay();
            var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
            switch (token) {
              // Numerical value (same as in `e`)
              case 'c':
                return String(localDayOfWeek);
              // Padded numerical value

              case 'cc':
                return (0, _addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_2__.default)(localDayOfWeek, token.length);
              // 1st, 2nd, ..., 7th

              case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                  unit: 'day'
                });
              case 'ccc':
                return localize.day(dayOfWeek, {
                  width: 'abbreviated',
                  context: 'standalone'
                });
              // T

              case 'ccccc':
                return localize.day(dayOfWeek, {
                  width: 'narrow',
                  context: 'standalone'
                });
              // Tu

              case 'cccccc':
                return localize.day(dayOfWeek, {
                  width: 'short',
                  context: 'standalone'
                });
              // Tuesday

              case 'cccc':
              default:
                return localize.day(dayOfWeek, {
                  width: 'wide',
                  context: 'standalone'
                });
            }
          },
          // ISO day of week
          i: function (date, token, localize) {
            var dayOfWeek = date.getUTCDay();
            var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
            switch (token) {
              // 2
              case 'i':
                return String(isoDayOfWeek);
              // 02

              case 'ii':
                return (0, _addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_2__.default)(isoDayOfWeek, token.length);
              // 2nd

              case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                  unit: 'day'
                });
              // Tue

              case 'iii':
                return localize.day(dayOfWeek, {
                  width: 'abbreviated',
                  context: 'formatting'
                });
              // T

              case 'iiiii':
                return localize.day(dayOfWeek, {
                  width: 'narrow',
                  context: 'formatting'
                });
              // Tu

              case 'iiiiii':
                return localize.day(dayOfWeek, {
                  width: 'short',
                  context: 'formatting'
                });
              // Tuesday

              case 'iiii':
              default:
                return localize.day(dayOfWeek, {
                  width: 'wide',
                  context: 'formatting'
                });
            }
          },
          // AM or PM
          a: function (date, token, localize) {
            var hours = date.getUTCHours();
            var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
            switch (token) {
              case 'a':
              case 'aa':
              case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                  width: 'abbreviated',
                  context: 'formatting'
                });
              case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                  width: 'narrow',
                  context: 'formatting'
                });
              case 'aaaa':
              default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                  width: 'wide',
                  context: 'formatting'
                });
            }
          },
          // AM, PM, midnight, noon
          b: function (date, token, localize) {
            var hours = date.getUTCHours();
            var dayPeriodEnumValue;
            if (hours === 12) {
              dayPeriodEnumValue = dayPeriodEnum.noon;
            } else if (hours === 0) {
              dayPeriodEnumValue = dayPeriodEnum.midnight;
            } else {
              dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
            }
            switch (token) {
              case 'b':
              case 'bb':
              case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                  width: 'abbreviated',
                  context: 'formatting'
                });
              case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                  width: 'narrow',
                  context: 'formatting'
                });
              case 'bbbb':
              default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                  width: 'wide',
                  context: 'formatting'
                });
            }
          },
          // in the morning, in the afternoon, in the evening, at night
          B: function (date, token, localize) {
            var hours = date.getUTCHours();
            var dayPeriodEnumValue;
            if (hours >= 17) {
              dayPeriodEnumValue = dayPeriodEnum.evening;
            } else if (hours >= 12) {
              dayPeriodEnumValue = dayPeriodEnum.afternoon;
            } else if (hours >= 4) {
              dayPeriodEnumValue = dayPeriodEnum.morning;
            } else {
              dayPeriodEnumValue = dayPeriodEnum.night;
            }
            switch (token) {
              case 'B':
              case 'BB':
              case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                  width: 'abbreviated',
                  context: 'formatting'
                });
              case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                  width: 'narrow',
                  context: 'formatting'
                });
              case 'BBBB':
              default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                  width: 'wide',
                  context: 'formatting'
                });
            }
          },
          // Hour [1-12]
          h: function (date, token, localize) {
            if (token === 'ho') {
              var hours = date.getUTCHours() % 12;
              if (hours === 0) hours = 12;
              return localize.ordinalNumber(hours, {
                unit: 'hour'
              });
            }
            return _lightFormatters_index_js__WEBPACK_IMPORTED_MODULE_0__.default.h(date, token);
          },
          // Hour [0-23]
          H: function (date, token, localize) {
            if (token === 'Ho') {
              return localize.ordinalNumber(date.getUTCHours(), {
                unit: 'hour'
              });
            }
            return _lightFormatters_index_js__WEBPACK_IMPORTED_MODULE_0__.default.H(date, token);
          },
          // Hour [0-11]
          K: function (date, token, localize) {
            var hours = date.getUTCHours() % 12;
            if (token === 'Ko') {
              return localize.ordinalNumber(hours, {
                unit: 'hour'
              });
            }
            return (0, _addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_2__.default)(hours, token.length);
          },
          // Hour [1-24]
          k: function (date, token, localize) {
            var hours = date.getUTCHours();
            if (hours === 0) hours = 24;
            if (token === 'ko') {
              return localize.ordinalNumber(hours, {
                unit: 'hour'
              });
            }
            return (0, _addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_2__.default)(hours, token.length);
          },
          // Minute
          m: function (date, token, localize) {
            if (token === 'mo') {
              return localize.ordinalNumber(date.getUTCMinutes(), {
                unit: 'minute'
              });
            }
            return _lightFormatters_index_js__WEBPACK_IMPORTED_MODULE_0__.default.m(date, token);
          },
          // Second
          s: function (date, token, localize) {
            if (token === 'so') {
              return localize.ordinalNumber(date.getUTCSeconds(), {
                unit: 'second'
              });
            }
            return _lightFormatters_index_js__WEBPACK_IMPORTED_MODULE_0__.default.s(date, token);
          },
          // Fraction of second
          S: function (date, token) {
            return _lightFormatters_index_js__WEBPACK_IMPORTED_MODULE_0__.default.S(date, token);
          },
          // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
          X: function (date, token, _localize, options) {
            var originalDate = options._originalDate || date;
            var timezoneOffset = originalDate.getTimezoneOffset();
            if (timezoneOffset === 0) {
              return 'Z';
            }
            switch (token) {
              // Hours and optional minutes
              case 'X':
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
              // Hours, minutes and optional seconds without `:` delimiter
              // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
              // so this token always has the same output as `XX`

              case 'XXXX':
              case 'XX':
                // Hours and minutes without `:` delimiter
                return formatTimezone(timezoneOffset);
              // Hours, minutes and optional seconds with `:` delimiter
              // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
              // so this token always has the same output as `XXX`

              case 'XXXXX':
              case 'XXX': // Hours and minutes with `:` delimiter

              default:
                return formatTimezone(timezoneOffset, ':');
            }
          },
          // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
          x: function (date, token, _localize, options) {
            var originalDate = options._originalDate || date;
            var timezoneOffset = originalDate.getTimezoneOffset();
            switch (token) {
              // Hours and optional minutes
              case 'x':
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
              // Hours, minutes and optional seconds without `:` delimiter
              // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
              // so this token always has the same output as `xx`

              case 'xxxx':
              case 'xx':
                // Hours and minutes without `:` delimiter
                return formatTimezone(timezoneOffset);
              // Hours, minutes and optional seconds with `:` delimiter
              // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
              // so this token always has the same output as `xxx`

              case 'xxxxx':
              case 'xxx': // Hours and minutes with `:` delimiter

              default:
                return formatTimezone(timezoneOffset, ':');
            }
          },
          // Timezone (GMT)
          O: function (date, token, _localize, options) {
            var originalDate = options._originalDate || date;
            var timezoneOffset = originalDate.getTimezoneOffset();
            switch (token) {
              // Short
              case 'O':
              case 'OO':
              case 'OOO':
                return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
              // Long

              case 'OOOO':
              default:
                return 'GMT' + formatTimezone(timezoneOffset, ':');
            }
          },
          // Timezone (specific non-location)
          z: function (date, token, _localize, options) {
            var originalDate = options._originalDate || date;
            var timezoneOffset = originalDate.getTimezoneOffset();
            switch (token) {
              // Short
              case 'z':
              case 'zz':
              case 'zzz':
                return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
              // Long

              case 'zzzz':
              default:
                return 'GMT' + formatTimezone(timezoneOffset, ':');
            }
          },
          // Seconds timestamp
          t: function (date, token, _localize, options) {
            var originalDate = options._originalDate || date;
            var timestamp = Math.floor(originalDate.getTime() / 1000);
            return (0, _addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_2__.default)(timestamp, token.length);
          },
          // Milliseconds timestamp
          T: function (date, token, _localize, options) {
            var originalDate = options._originalDate || date;
            var timestamp = originalDate.getTime();
            return (0, _addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_2__.default)(timestamp, token.length);
          }
        };
        function formatTimezoneShort(offset, dirtyDelimiter) {
          var sign = offset > 0 ? '-' : '+';
          var absOffset = Math.abs(offset);
          var hours = Math.floor(absOffset / 60);
          var minutes = absOffset % 60;
          if (minutes === 0) {
            return sign + String(hours);
          }
          var delimiter = dirtyDelimiter || '';
          return sign + String(hours) + delimiter + (0, _addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_2__.default)(minutes, 2);
        }
        function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
          if (offset % 60 === 0) {
            var sign = offset > 0 ? '-' : '+';
            return sign + (0, _addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_2__.default)(Math.abs(offset) / 60, 2);
          }
          return formatTimezone(offset, dirtyDelimiter);
        }
        function formatTimezone(offset, dirtyDelimiter) {
          var delimiter = dirtyDelimiter || '';
          var sign = offset > 0 ? '-' : '+';
          var absOffset = Math.abs(offset);
          var hours = (0, _addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_2__.default)(Math.floor(absOffset / 60), 2);
          var minutes = (0, _addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_2__.default)(absOffset % 60, 2);
          return sign + hours + delimiter + minutes;
        }

        /* harmony default export */
        __webpack_exports__["default"] = formatters;

        /***/
      }),
      /***/"./node_modules/date-fns/esm/_lib/format/lightFormatters/index.js": (
      /*!************************************************************************!*\
        !*** ./node_modules/date-fns/esm/_lib/format/lightFormatters/index.js ***!
        \************************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */
        var _addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../addLeadingZeros/index.js */"./node_modules/date-fns/esm/_lib/addLeadingZeros/index.js");

        /*
         * |     | Unit                           |     | Unit                           |
         * |-----|--------------------------------|-----|--------------------------------|
         * |  a  | AM, PM                         |  A* |                                |
         * |  d  | Day of month                   |  D  |                                |
         * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
         * |  m  | Minute                         |  M  | Month                          |
         * |  s  | Second                         |  S  | Fraction of second             |
         * |  y  | Year (abs)                     |  Y  |                                |
         *
         * Letters marked by * are not implemented but reserved by Unicode standard.
         */

        var formatters = {
          // Year
          y: function (date, token) {
            // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
            // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
            // |----------|-------|----|-------|-------|-------|
            // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
            // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
            // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
            // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
            // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
            var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return (0, _addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_0__.default)(token === 'yy' ? year % 100 : year, token.length);
          },
          // Month
          M: function (date, token) {
            var month = date.getUTCMonth();
            return token === 'M' ? String(month + 1) : (0, _addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_0__.default)(month + 1, 2);
          },
          // Day of the month
          d: function (date, token) {
            return (0, _addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_0__.default)(date.getUTCDate(), token.length);
          },
          // AM or PM
          a: function (date, token) {
            var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
            switch (token) {
              case 'a':
              case 'aa':
              case 'aaa':
                return dayPeriodEnumValue.toUpperCase();
              case 'aaaaa':
                return dayPeriodEnumValue[0];
              case 'aaaa':
              default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
            }
          },
          // Hour [1-12]
          h: function (date, token) {
            return (0, _addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_0__.default)(date.getUTCHours() % 12 || 12, token.length);
          },
          // Hour [0-23]
          H: function (date, token) {
            return (0, _addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_0__.default)(date.getUTCHours(), token.length);
          },
          // Minute
          m: function (date, token) {
            return (0, _addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_0__.default)(date.getUTCMinutes(), token.length);
          },
          // Second
          s: function (date, token) {
            return (0, _addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_0__.default)(date.getUTCSeconds(), token.length);
          },
          // Fraction of second
          S: function (date, token) {
            var numberOfDigits = token.length;
            var milliseconds = date.getUTCMilliseconds();
            var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
            return (0, _addLeadingZeros_index_js__WEBPACK_IMPORTED_MODULE_0__.default)(fractionalSeconds, token.length);
          }
        };
        /* harmony default export */
        __webpack_exports__["default"] = formatters;

        /***/
      }),
      /***/"./node_modules/date-fns/esm/_lib/format/longFormatters/index.js": (
      /*!***********************************************************************!*\
        !*** ./node_modules/date-fns/esm/_lib/format/longFormatters/index.js ***!
        \***********************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        function dateLongFormatter(pattern, formatLong) {
          switch (pattern) {
            case 'P':
              return formatLong.date({
                width: 'short'
              });
            case 'PP':
              return formatLong.date({
                width: 'medium'
              });
            case 'PPP':
              return formatLong.date({
                width: 'long'
              });
            case 'PPPP':
            default:
              return formatLong.date({
                width: 'full'
              });
          }
        }
        function timeLongFormatter(pattern, formatLong) {
          switch (pattern) {
            case 'p':
              return formatLong.time({
                width: 'short'
              });
            case 'pp':
              return formatLong.time({
                width: 'medium'
              });
            case 'ppp':
              return formatLong.time({
                width: 'long'
              });
            case 'pppp':
            default:
              return formatLong.time({
                width: 'full'
              });
          }
        }
        function dateTimeLongFormatter(pattern, formatLong) {
          var matchResult = pattern.match(/(P+)(p+)?/);
          var datePattern = matchResult[1];
          var timePattern = matchResult[2];
          if (!timePattern) {
            return dateLongFormatter(pattern, formatLong);
          }
          var dateTimeFormat;
          switch (datePattern) {
            case 'P':
              dateTimeFormat = formatLong.dateTime({
                width: 'short'
              });
              break;
            case 'PP':
              dateTimeFormat = formatLong.dateTime({
                width: 'medium'
              });
              break;
            case 'PPP':
              dateTimeFormat = formatLong.dateTime({
                width: 'long'
              });
              break;
            case 'PPPP':
            default:
              dateTimeFormat = formatLong.dateTime({
                width: 'full'
              });
              break;
          }
          return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
        }
        var longFormatters = {
          p: timeLongFormatter,
          P: dateTimeLongFormatter
        };
        /* harmony default export */
        __webpack_exports__["default"] = longFormatters;

        /***/
      }),
      /***/"./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js": (
      /*!*********************************************************************************!*\
        !*** ./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js ***!
        \*********************************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function () {
            return /* binding */getTimezoneOffsetInMilliseconds;
          }
          /* harmony export */
        });
        var MILLISECONDS_IN_MINUTE = 60000;
        function getDateMillisecondsPart(date) {
          return date.getTime() % MILLISECONDS_IN_MINUTE;
        }
        /**
         * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
         * They usually appear for dates that denote time before the timezones were introduced
         * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
         * and GMT+01:00:00 after that date)
         *
         * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
         * which would lead to incorrect calculations.
         *
         * This function returns the timezone offset in milliseconds that takes seconds in account.
         */

        function getTimezoneOffsetInMilliseconds(dirtyDate) {
          var date = new Date(dirtyDate.getTime());
          var baseTimezoneOffset = Math.ceil(date.getTimezoneOffset());
          date.setSeconds(0, 0);
          var hasNegativeUTCOffset = baseTimezoneOffset > 0;
          var millisecondsPartOfTimezoneOffset = hasNegativeUTCOffset ? (MILLISECONDS_IN_MINUTE + getDateMillisecondsPart(date)) % MILLISECONDS_IN_MINUTE : getDateMillisecondsPart(date);
          return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset;
        }

        /***/
      }),
      /***/"./node_modules/date-fns/esm/_lib/getUTCDayOfYear/index.js": (
      /*!*****************************************************************!*\
        !*** ./node_modules/date-fns/esm/_lib/getUTCDayOfYear/index.js ***!
        \*****************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function () {
            return /* binding */getUTCDayOfYear;
          }
          /* harmony export */
        });
        /* harmony import */
        var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../toDate/index.js */"./node_modules/date-fns/esm/toDate/index.js");
        /* harmony import */
        var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../requiredArgs/index.js */"./node_modules/date-fns/esm/_lib/requiredArgs/index.js");
        var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
        // See issue: https://github.com/date-fns/date-fns/issues/376

        function getUTCDayOfYear(dirtyDate) {
          (0, _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__.default)(1, arguments);
          var date = (0, _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__.default)(dirtyDate);
          var timestamp = date.getTime();
          date.setUTCMonth(0, 1);
          date.setUTCHours(0, 0, 0, 0);
          var startOfYearTimestamp = date.getTime();
          var difference = timestamp - startOfYearTimestamp;
          return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
        }

        /***/
      }),
      /***/"./node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js": (
      /*!***************************************************************!*\
        !*** ./node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js ***!
        \***************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function () {
            return /* binding */getUTCISOWeek;
          }
          /* harmony export */
        });
        /* harmony import */
        var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../toDate/index.js */"./node_modules/date-fns/esm/toDate/index.js");
        /* harmony import */
        var _startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../startOfUTCISOWeek/index.js */"./node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js");
        /* harmony import */
        var _startOfUTCISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../startOfUTCISOWeekYear/index.js */"./node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js");
        /* harmony import */
        var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../requiredArgs/index.js */"./node_modules/date-fns/esm/_lib/requiredArgs/index.js");
        var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
        // See issue: https://github.com/date-fns/date-fns/issues/376

        function getUTCISOWeek(dirtyDate) {
          (0, _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__.default)(1, arguments);
          var date = (0, _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__.default)(dirtyDate);
          var diff = (0, _startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__.default)(date).getTime() - (0, _startOfUTCISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_3__.default)(date).getTime(); // Round the number of days to the nearest integer
          // because the number of milliseconds in a week is not constant
          // (e.g. it's different in the week of the daylight saving time clock shift)

          return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
        }

        /***/
      }),
      /***/"./node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js": (
      /*!*******************************************************************!*\
        !*** ./node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js ***!
        \*******************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function () {
            return /* binding */getUTCISOWeekYear;
          }
          /* harmony export */
        });
        /* harmony import */
        var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../toDate/index.js */"./node_modules/date-fns/esm/toDate/index.js");
        /* harmony import */
        var _startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../startOfUTCISOWeek/index.js */"./node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js");
        /* harmony import */
        var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../requiredArgs/index.js */"./node_modules/date-fns/esm/_lib/requiredArgs/index.js");

        // This function will be a part of public API when UTC function will be implemented.
        // See issue: https://github.com/date-fns/date-fns/issues/376

        function getUTCISOWeekYear(dirtyDate) {
          (0, _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__.default)(1, arguments);
          var date = (0, _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__.default)(dirtyDate);
          var year = date.getUTCFullYear();
          var fourthOfJanuaryOfNextYear = new Date(0);
          fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
          fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
          var startOfNextYear = (0, _startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__.default)(fourthOfJanuaryOfNextYear);
          var fourthOfJanuaryOfThisYear = new Date(0);
          fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
          fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
          var startOfThisYear = (0, _startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__.default)(fourthOfJanuaryOfThisYear);
          if (date.getTime() >= startOfNextYear.getTime()) {
            return year + 1;
          } else if (date.getTime() >= startOfThisYear.getTime()) {
            return year;
          } else {
            return year - 1;
          }
        }

        /***/
      }),
      /***/"./node_modules/date-fns/esm/_lib/getUTCWeek/index.js": (
      /*!************************************************************!*\
        !*** ./node_modules/date-fns/esm/_lib/getUTCWeek/index.js ***!
        \************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function () {
            return /* binding */getUTCWeek;
          }
          /* harmony export */
        });
        /* harmony import */
        var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../toDate/index.js */"./node_modules/date-fns/esm/toDate/index.js");
        /* harmony import */
        var _startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../startOfUTCWeek/index.js */"./node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js");
        /* harmony import */
        var _startOfUTCWeekYear_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../startOfUTCWeekYear/index.js */"./node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js");
        /* harmony import */
        var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../requiredArgs/index.js */"./node_modules/date-fns/esm/_lib/requiredArgs/index.js");
        var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
        // See issue: https://github.com/date-fns/date-fns/issues/376

        function getUTCWeek(dirtyDate, options) {
          (0, _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__.default)(1, arguments);
          var date = (0, _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__.default)(dirtyDate);
          var diff = (0, _startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_2__.default)(date, options).getTime() - (0, _startOfUTCWeekYear_index_js__WEBPACK_IMPORTED_MODULE_3__.default)(date, options).getTime(); // Round the number of days to the nearest integer
          // because the number of milliseconds in a week is not constant
          // (e.g. it's different in the week of the daylight saving time clock shift)

          return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
        }

        /***/
      }),
      /***/"./node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js": (
      /*!****************************************************************!*\
        !*** ./node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js ***!
        \****************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function () {
            return /* binding */getUTCWeekYear;
          }
          /* harmony export */
        });
        /* harmony import */
        var _toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../toInteger/index.js */"./node_modules/date-fns/esm/_lib/toInteger/index.js");
        /* harmony import */
        var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../toDate/index.js */"./node_modules/date-fns/esm/toDate/index.js");
        /* harmony import */
        var _startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../startOfUTCWeek/index.js */"./node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js");
        /* harmony import */
        var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../requiredArgs/index.js */"./node_modules/date-fns/esm/_lib/requiredArgs/index.js");

        // This function will be a part of public API when UTC function will be implemented.
        // See issue: https://github.com/date-fns/date-fns/issues/376

        function getUTCWeekYear(dirtyDate, dirtyOptions) {
          (0, _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__.default)(1, arguments);
          var date = (0, _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__.default)(dirtyDate, dirtyOptions);
          var year = date.getUTCFullYear();
          var options = dirtyOptions || {};
          var locale = options.locale;
          var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
          var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__.default)(localeFirstWeekContainsDate);
          var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

          if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
            throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
          }
          var firstWeekOfNextYear = new Date(0);
          firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
          firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
          var startOfNextYear = (0, _startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_3__.default)(firstWeekOfNextYear, dirtyOptions);
          var firstWeekOfThisYear = new Date(0);
          firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
          firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
          var startOfThisYear = (0, _startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_3__.default)(firstWeekOfThisYear, dirtyOptions);
          if (date.getTime() >= startOfNextYear.getTime()) {
            return year + 1;
          } else if (date.getTime() >= startOfThisYear.getTime()) {
            return year;
          } else {
            return year - 1;
          }
        }

        /***/
      }),
      /***/"./node_modules/date-fns/esm/_lib/protectedTokens/index.js": (
      /*!*****************************************************************!*\
        !*** ./node_modules/date-fns/esm/_lib/protectedTokens/index.js ***!
        \*****************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"isProtectedDayOfYearToken": function () {
            return /* binding */isProtectedDayOfYearToken;
          },
          /* harmony export */"isProtectedWeekYearToken": function () {
            return /* binding */isProtectedWeekYearToken;
          },
          /* harmony export */"throwProtectedError": function () {
            return /* binding */throwProtectedError;
          }
          /* harmony export */
        });
        var protectedDayOfYearTokens = ['D', 'DD'];
        var protectedWeekYearTokens = ['YY', 'YYYY'];
        function isProtectedDayOfYearToken(token) {
          return protectedDayOfYearTokens.indexOf(token) !== -1;
        }
        function isProtectedWeekYearToken(token) {
          return protectedWeekYearTokens.indexOf(token) !== -1;
        }
        function throwProtectedError(token, format, input) {
          if (token === 'YYYY') {
            throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
          } else if (token === 'YY') {
            throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
          } else if (token === 'D') {
            throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
          } else if (token === 'DD') {
            throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
          }
        }

        /***/
      }),
      /***/"./node_modules/date-fns/esm/_lib/requiredArgs/index.js": (
      /*!**************************************************************!*\
        !*** ./node_modules/date-fns/esm/_lib/requiredArgs/index.js ***!
        \**************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function () {
            return /* binding */requiredArgs;
          }
          /* harmony export */
        });
        function requiredArgs(required, args) {
          if (args.length < required) {
            throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
          }
        }

        /***/
      }),
      /***/"./node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js": (
      /*!*******************************************************************!*\
        !*** ./node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js ***!
        \*******************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function () {
            return /* binding */startOfUTCISOWeek;
          }
          /* harmony export */
        });
        /* harmony import */
        var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../toDate/index.js */"./node_modules/date-fns/esm/toDate/index.js");
        /* harmony import */
        var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../requiredArgs/index.js */"./node_modules/date-fns/esm/_lib/requiredArgs/index.js");

        // This function will be a part of public API when UTC function will be implemented.
        // See issue: https://github.com/date-fns/date-fns/issues/376

        function startOfUTCISOWeek(dirtyDate) {
          (0, _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__.default)(1, arguments);
          var weekStartsOn = 1;
          var date = (0, _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__.default)(dirtyDate);
          var day = date.getUTCDay();
          var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
          date.setUTCDate(date.getUTCDate() - diff);
          date.setUTCHours(0, 0, 0, 0);
          return date;
        }

        /***/
      }),
      /***/"./node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js": (
      /*!***********************************************************************!*\
        !*** ./node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js ***!
        \***********************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function () {
            return /* binding */startOfUTCISOWeekYear;
          }
          /* harmony export */
        });
        /* harmony import */
        var _getUTCISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../getUTCISOWeekYear/index.js */"./node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js");
        /* harmony import */
        var _startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../startOfUTCISOWeek/index.js */"./node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js");
        /* harmony import */
        var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../requiredArgs/index.js */"./node_modules/date-fns/esm/_lib/requiredArgs/index.js");

        // This function will be a part of public API when UTC function will be implemented.
        // See issue: https://github.com/date-fns/date-fns/issues/376

        function startOfUTCISOWeekYear(dirtyDate) {
          (0, _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__.default)(1, arguments);
          var year = (0, _getUTCISOWeekYear_index_js__WEBPACK_IMPORTED_MODULE_1__.default)(dirtyDate);
          var fourthOfJanuary = new Date(0);
          fourthOfJanuary.setUTCFullYear(year, 0, 4);
          fourthOfJanuary.setUTCHours(0, 0, 0, 0);
          var date = (0, _startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__.default)(fourthOfJanuary);
          return date;
        }

        /***/
      }),
      /***/"./node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js": (
      /*!****************************************************************!*\
        !*** ./node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js ***!
        \****************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function () {
            return /* binding */startOfUTCWeek;
          }
          /* harmony export */
        });
        /* harmony import */
        var _toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../toInteger/index.js */"./node_modules/date-fns/esm/_lib/toInteger/index.js");
        /* harmony import */
        var _toDate_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../toDate/index.js */"./node_modules/date-fns/esm/toDate/index.js");
        /* harmony import */
        var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../requiredArgs/index.js */"./node_modules/date-fns/esm/_lib/requiredArgs/index.js");

        // This function will be a part of public API when UTC function will be implemented.
        // See issue: https://github.com/date-fns/date-fns/issues/376

        function startOfUTCWeek(dirtyDate, dirtyOptions) {
          (0, _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__.default)(1, arguments);
          var options = dirtyOptions || {};
          var locale = options.locale;
          var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
          var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__.default)(localeWeekStartsOn);
          var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

          if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
            throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
          }
          var date = (0, _toDate_index_js__WEBPACK_IMPORTED_MODULE_2__.default)(dirtyDate);
          var day = date.getUTCDay();
          var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
          date.setUTCDate(date.getUTCDate() - diff);
          date.setUTCHours(0, 0, 0, 0);
          return date;
        }

        /***/
      }),
      /***/"./node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js": (
      /*!********************************************************************!*\
        !*** ./node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js ***!
        \********************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function () {
            return /* binding */startOfUTCWeekYear;
          }
          /* harmony export */
        });
        /* harmony import */
        var _toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../toInteger/index.js */"./node_modules/date-fns/esm/_lib/toInteger/index.js");
        /* harmony import */
        var _getUTCWeekYear_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../getUTCWeekYear/index.js */"./node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js");
        /* harmony import */
        var _startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../startOfUTCWeek/index.js */"./node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js");
        /* harmony import */
        var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../requiredArgs/index.js */"./node_modules/date-fns/esm/_lib/requiredArgs/index.js");

        // This function will be a part of public API when UTC function will be implemented.
        // See issue: https://github.com/date-fns/date-fns/issues/376

        function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
          (0, _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__.default)(1, arguments);
          var options = dirtyOptions || {};
          var locale = options.locale;
          var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
          var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__.default)(localeFirstWeekContainsDate);
          var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__.default)(options.firstWeekContainsDate);
          var year = (0, _getUTCWeekYear_index_js__WEBPACK_IMPORTED_MODULE_2__.default)(dirtyDate, dirtyOptions);
          var firstWeek = new Date(0);
          firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
          firstWeek.setUTCHours(0, 0, 0, 0);
          var date = (0, _startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_3__.default)(firstWeek, dirtyOptions);
          return date;
        }

        /***/
      }),
      /***/"./node_modules/date-fns/esm/_lib/toInteger/index.js": (
      /*!***********************************************************!*\
        !*** ./node_modules/date-fns/esm/_lib/toInteger/index.js ***!
        \***********************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function () {
            return /* binding */toInteger;
          }
          /* harmony export */
        });
        function toInteger(dirtyNumber) {
          if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
            return NaN;
          }
          var number = Number(dirtyNumber);
          if (isNaN(number)) {
            return number;
          }
          return number < 0 ? Math.ceil(number) : Math.floor(number);
        }

        /***/
      }),
      /***/"./node_modules/date-fns/esm/addMilliseconds/index.js": (
      /*!************************************************************!*\
        !*** ./node_modules/date-fns/esm/addMilliseconds/index.js ***!
        \************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function () {
            return /* binding */addMilliseconds;
          }
          /* harmony export */
        });
        /* harmony import */
        var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../_lib/toInteger/index.js */"./node_modules/date-fns/esm/_lib/toInteger/index.js");
        /* harmony import */
        var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../toDate/index.js */"./node_modules/date-fns/esm/toDate/index.js");
        /* harmony import */
        var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/requiredArgs/index.js */"./node_modules/date-fns/esm/_lib/requiredArgs/index.js");

        /**
         * @name addMilliseconds
         * @category Millisecond Helpers
         * @summary Add the specified number of milliseconds to the given date.
         *
         * @description
         * Add the specified number of milliseconds to the given date.
         *
         * ### v2.0.0 breaking changes:
         *
         * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
         *
         * @param {Date|Number} date - the date to be changed
         * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
         * @returns {Date} the new date with the milliseconds added
         * @throws {TypeError} 2 arguments required
         *
         * @example
         * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
         * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
         * //=> Thu Jul 10 2014 12:45:30.750
         */

        function addMilliseconds(dirtyDate, dirtyAmount) {
          (0, _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__.default)(2, arguments);
          var timestamp = (0, _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__.default)(dirtyDate).getTime();
          var amount = (0, _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__.default)(dirtyAmount);
          return new Date(timestamp + amount);
        }

        /***/
      }),
      /***/"./node_modules/date-fns/esm/format/index.js": (
      /*!***************************************************!*\
        !*** ./node_modules/date-fns/esm/format/index.js ***!
        \***************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function () {
            return /* binding */format;
          }
          /* harmony export */
        });
        /* harmony import */
        var _isValid_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../isValid/index.js */"./node_modules/date-fns/esm/isValid/index.js");
        /* harmony import */
        var _locale_en_US_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../locale/en-US/index.js */"./node_modules/date-fns/esm/locale/en-US/index.js");
        /* harmony import */
        var _subMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../subMilliseconds/index.js */"./node_modules/date-fns/esm/subMilliseconds/index.js");
        /* harmony import */
        var _toDate_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../toDate/index.js */"./node_modules/date-fns/esm/toDate/index.js");
        /* harmony import */
        var _lib_format_formatters_index_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../_lib/format/formatters/index.js */"./node_modules/date-fns/esm/_lib/format/formatters/index.js");
        /* harmony import */
        var _lib_format_longFormatters_index_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../_lib/format/longFormatters/index.js */"./node_modules/date-fns/esm/_lib/format/longFormatters/index.js");
        /* harmony import */
        var _lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../_lib/getTimezoneOffsetInMilliseconds/index.js */"./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js");
        /* harmony import */
        var _lib_protectedTokens_index_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../_lib/protectedTokens/index.js */"./node_modules/date-fns/esm/_lib/protectedTokens/index.js");
        /* harmony import */
        var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../_lib/toInteger/index.js */"./node_modules/date-fns/esm/_lib/toInteger/index.js");
        /* harmony import */
        var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/requiredArgs/index.js */"./node_modules/date-fns/esm/_lib/requiredArgs/index.js");

        // This RegExp consists of three parts separated by `|`:
        // - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
        //   (one of the certain letters followed by `o`)
        // - (\w)\1* matches any sequences of the same letter
        // - '' matches two quote characters in a row
        // - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
        //   except a single quote symbol, which ends the sequence.
        //   Two quote characters do not end the sequence.
        //   If there is no matching single quote
        //   then the sequence will continue until the end of the string.
        // - . matches any single character unmatched by previous parts of the RegExps

        var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
        // sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

        var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
        var escapedStringRegExp = /^'([^]*?)'?$/;
        var doubleQuoteRegExp = /''/g;
        var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
        /**
         * @name format
         * @category Common Helpers
         * @summary Format the date.
         *
         * @description
         * Return the formatted date string in the given format. The result may vary by locale.
         *
         * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
         * > See: https://git.io/fxCyr
         *
         * The characters wrapped between two single quotes characters (') are escaped.
         * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
         * (see the last example)
         *
         * Format of the string is based on Unicode Technical Standard #35:
         * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
         * with a few additions (see note 7 below the table).
         *
         * Accepted patterns:
         * | Unit                            | Pattern | Result examples                   | Notes |
         * |---------------------------------|---------|-----------------------------------|-------|
         * | Era                             | G..GGG  | AD, BC                            |       |
         * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
         * |                                 | GGGGG   | A, B                              |       |
         * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
         * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
         * |                                 | yy      | 44, 01, 00, 17                    | 5     |
         * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
         * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
         * |                                 | yyyyy   | ...                               | 3,5   |
         * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
         * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
         * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
         * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
         * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
         * |                                 | YYYYY   | ...                               | 3,5   |
         * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
         * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
         * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
         * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
         * |                                 | RRRRR   | ...                               | 3,5,7 |
         * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
         * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
         * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
         * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
         * |                                 | uuuuu   | ...                               | 3,5   |
         * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
         * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
         * |                                 | QQ      | 01, 02, 03, 04                    |       |
         * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
         * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
         * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
         * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
         * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
         * |                                 | qq      | 01, 02, 03, 04                    |       |
         * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
         * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
         * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
         * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
         * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
         * |                                 | MM      | 01, 02, ..., 12                   |       |
         * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
         * |                                 | MMMM    | January, February, ..., December  | 2     |
         * |                                 | MMMMM   | J, F, ..., D                      |       |
         * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
         * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
         * |                                 | LL      | 01, 02, ..., 12                   |       |
         * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
         * |                                 | LLLL    | January, February, ..., December  | 2     |
         * |                                 | LLLLL   | J, F, ..., D                      |       |
         * | Local week of year              | w       | 1, 2, ..., 53                     |       |
         * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
         * |                                 | ww      | 01, 02, ..., 53                   |       |
         * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
         * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
         * |                                 | II      | 01, 02, ..., 53                   | 7     |
         * | Day of month                    | d       | 1, 2, ..., 31                     |       |
         * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
         * |                                 | dd      | 01, 02, ..., 31                   |       |
         * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
         * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
         * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
         * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
         * |                                 | DDDD    | ...                               | 3     |
         * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
         * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
         * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
         * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
         * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
         * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
         * |                                 | ii      | 01, 02, ..., 07                   | 7     |
         * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
         * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
         * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
         * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
         * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
         * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
         * |                                 | ee      | 02, 03, ..., 01                   |       |
         * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
         * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
         * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
         * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
         * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
         * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
         * |                                 | cc      | 02, 03, ..., 01                   |       |
         * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
         * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
         * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
         * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
         * | AM, PM                          | a..aaa  | AM, PM                            |       |
         * |                                 | aaaa    | a.m., p.m.                        | 2     |
         * |                                 | aaaaa   | a, p                              |       |
         * | AM, PM, noon, midnight          | b..bbb  | AM, PM, noon, midnight            |       |
         * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
         * |                                 | bbbbb   | a, p, n, mi                       |       |
         * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
         * |                                 | BBBB    | at night, in the morning, ...     | 2     |
         * |                                 | BBBBB   | at night, in the morning, ...     |       |
         * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
         * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
         * |                                 | hh      | 01, 02, ..., 11, 12               |       |
         * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
         * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
         * |                                 | HH      | 00, 01, 02, ..., 23               |       |
         * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
         * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
         * |                                 | KK      | 01, 02, ..., 11, 00               |       |
         * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
         * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
         * |                                 | kk      | 24, 01, 02, ..., 23               |       |
         * | Minute                          | m       | 0, 1, ..., 59                     |       |
         * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
         * |                                 | mm      | 00, 01, ..., 59                   |       |
         * | Second                          | s       | 0, 1, ..., 59                     |       |
         * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
         * |                                 | ss      | 00, 01, ..., 59                   |       |
         * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
         * |                                 | SS      | 00, 01, ..., 99                   |       |
         * |                                 | SSS     | 000, 0001, ..., 999               |       |
         * |                                 | SSSS    | ...                               | 3     |
         * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
         * |                                 | XX      | -0800, +0530, Z                   |       |
         * |                                 | XXX     | -08:00, +05:30, Z                 |       |
         * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
         * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
         * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
         * |                                 | xx      | -0800, +0530, +0000               |       |
         * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
         * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
         * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
         * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
         * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
         * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
         * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
         * | Seconds timestamp               | t       | 512969520                         | 7     |
         * |                                 | tt      | ...                               | 3,7   |
         * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
         * |                                 | TT      | ...                               | 3,7   |
         * | Long localized date             | P       | 05/29/1453                        | 7     |
         * |                                 | PP      | May 29, 1453                      | 7     |
         * |                                 | PPP     | May 29th, 1453                    | 7     |
         * |                                 | PPPP    | Sunday, May 29th, 1453            | 2,7   |
         * | Long localized time             | p       | 12:00 AM                          | 7     |
         * |                                 | pp      | 12:00:00 AM                       | 7     |
         * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
         * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
         * | Combination of date and time    | Pp      | 05/29/1453, 12:00 AM              | 7     |
         * |                                 | PPpp    | May 29, 1453, 12:00:00 AM         | 7     |
         * |                                 | PPPppp  | May 29th, 1453 at ...             | 7     |
         * |                                 | PPPPpppp| Sunday, May 29th, 1453 at ...     | 2,7   |
         * Notes:
         * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
         *    are the same as "stand-alone" units, but are different in some languages.
         *    "Formatting" units are declined according to the rules of the language
         *    in the context of a date. "Stand-alone" units are always nominative singular:
         *
         *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
         *
         *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
         *
         * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
         *    the single quote characters (see below).
         *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
         *    the output will be the same as default pattern for this unit, usually
         *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
         *    are marked with "2" in the last column of the table.
         *
         *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
         *
         *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
         *
         *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
         *
         *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
         *
         *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
         *
         * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
         *    The output will be padded with zeros to match the length of the pattern.
         *
         *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
         *
         * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
         *    These tokens represent the shortest form of the quarter.
         *
         * 5. The main difference between `y` and `u` patterns are B.C. years:
         *
         *    | Year | `y` | `u` |
         *    |------|-----|-----|
         *    | AC 1 |   1 |   1 |
         *    | BC 1 |   1 |   0 |
         *    | BC 2 |   2 |  -1 |
         *
         *    Also `yy` always returns the last two digits of a year,
         *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
         *
         *    | Year | `yy` | `uu` |
         *    |------|------|------|
         *    | 1    |   01 |   01 |
         *    | 14   |   14 |   14 |
         *    | 376  |   76 |  376 |
         *    | 1453 |   53 | 1453 |
         *
         *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
         *    except local week-numbering years are dependent on `options.weekStartsOn`
         *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
         *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
         *
         * 6. Specific non-location timezones are currently unavailable in `date-fns`,
         *    so right now these tokens fall back to GMT timezones.
         *
         * 7. These patterns are not in the Unicode Technical Standard #35:
         *    - `i`: ISO day of week
         *    - `I`: ISO week of year
         *    - `R`: ISO week-numbering year
         *    - `t`: seconds timestamp
         *    - `T`: milliseconds timestamp
         *    - `o`: ordinal number modifier
         *    - `P`: long localized date
         *    - `p`: long localized time
         *
         * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
         *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
         *
         * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
         *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
         *
         * ### v2.0.0 breaking changes:
         *
         * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
         *
         * - The second argument is now required for the sake of explicitness.
         *
         *   ```javascript
         *   // Before v2.0.0
         *   format(new Date(2016, 0, 1))
         *
         *   // v2.0.0 onward
         *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
         *   ```
         *
         * - New format string API for `format` function
         *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
         *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
         *
         * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
         *
         * @param {Date|Number} date - the original date
         * @param {String} format - the string of tokens
         * @param {Object} [options] - an object with options.
         * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
         * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
         * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
         * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
         *   see: https://git.io/fxCyr
         * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
         *   see: https://git.io/fxCyr
         * @returns {String} the formatted date string
         * @throws {TypeError} 2 arguments required
         * @throws {RangeError} `date` must not be Invalid Date
         * @throws {RangeError} `options.locale` must contain `localize` property
         * @throws {RangeError} `options.locale` must contain `formatLong` property
         * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
         * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
         * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
         * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
         * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
         * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
         * @throws {RangeError} format string contains an unescaped latin alphabet character
         *
         * @example
         * // Represent 11 February 2014 in middle-endian format:
         * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
         * //=> '02/11/2014'
         *
         * @example
         * // Represent 2 July 2014 in Esperanto:
         * import { eoLocale } from 'date-fns/locale/eo'
         * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
         *   locale: eoLocale
         * })
         * //=> '2-a de julio 2014'
         *
         * @example
         * // Escape string by single quote characters:
         * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
         * //=> "3 o'clock"
         */

        function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
          (0, _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__.default)(2, arguments);
          var formatStr = String(dirtyFormatStr);
          var options = dirtyOptions || {};
          var locale = options.locale || _locale_en_US_index_js__WEBPACK_IMPORTED_MODULE_1__.default;
          var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
          var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__.default)(localeFirstWeekContainsDate);
          var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

          if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
            throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
          }
          var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
          var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__.default)(localeWeekStartsOn);
          var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

          if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
            throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
          }
          if (!locale.localize) {
            throw new RangeError('locale must contain localize property');
          }
          if (!locale.formatLong) {
            throw new RangeError('locale must contain formatLong property');
          }
          var originalDate = (0, _toDate_index_js__WEBPACK_IMPORTED_MODULE_3__.default)(dirtyDate);
          if (!(0, _isValid_index_js__WEBPACK_IMPORTED_MODULE_4__.default)(originalDate)) {
            throw new RangeError('Invalid time value');
          } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
          // This ensures that when UTC functions will be implemented, locales will be compatible with them.
          // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376

          var timezoneOffset = (0, _lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_5__.default)(originalDate);
          var utcDate = (0, _subMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_6__.default)(originalDate, timezoneOffset);
          var formatterOptions = {
            firstWeekContainsDate: firstWeekContainsDate,
            weekStartsOn: weekStartsOn,
            locale: locale,
            _originalDate: originalDate
          };
          var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
            var firstCharacter = substring[0];
            if (firstCharacter === 'p' || firstCharacter === 'P') {
              var longFormatter = _lib_format_longFormatters_index_js__WEBPACK_IMPORTED_MODULE_7__.default[firstCharacter];
              return longFormatter(substring, locale.formatLong, formatterOptions);
            }
            return substring;
          }).join('').match(formattingTokensRegExp).map(function (substring) {
            // Replace two single quote characters with one single quote character
            if (substring === "''") {
              return "'";
            }
            var firstCharacter = substring[0];
            if (firstCharacter === "'") {
              return cleanEscapedString(substring);
            }
            var formatter = _lib_format_formatters_index_js__WEBPACK_IMPORTED_MODULE_8__.default[firstCharacter];
            if (formatter) {
              if (!options.useAdditionalWeekYearTokens && (0, _lib_protectedTokens_index_js__WEBPACK_IMPORTED_MODULE_9__.isProtectedWeekYearToken)(substring)) {
                (0, _lib_protectedTokens_index_js__WEBPACK_IMPORTED_MODULE_9__.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
              }
              if (!options.useAdditionalDayOfYearTokens && (0, _lib_protectedTokens_index_js__WEBPACK_IMPORTED_MODULE_9__.isProtectedDayOfYearToken)(substring)) {
                (0, _lib_protectedTokens_index_js__WEBPACK_IMPORTED_MODULE_9__.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
              }
              return formatter(utcDate, substring, locale.localize, formatterOptions);
            }
            if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
              throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
            }
            return substring;
          }).join('');
          return result;
        }
        function cleanEscapedString(input) {
          return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
        }

        /***/
      }),
      /***/"./node_modules/date-fns/esm/isValid/index.js": (
      /*!****************************************************!*\
        !*** ./node_modules/date-fns/esm/isValid/index.js ***!
        \****************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function () {
            return /* binding */isValid;
          }
          /* harmony export */
        });
        /* harmony import */
        var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../toDate/index.js */"./node_modules/date-fns/esm/toDate/index.js");
        /* harmony import */
        var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/requiredArgs/index.js */"./node_modules/date-fns/esm/_lib/requiredArgs/index.js");

        /**
         * @name isValid
         * @category Common Helpers
         * @summary Is the given date valid?
         *
         * @description
         * Returns false if argument is Invalid Date and true otherwise.
         * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
         * Invalid Date is a Date, whose time value is NaN.
         *
         * Time value of Date: http://es5.github.io/#x15.9.1.1
         *
         * ### v2.0.0 breaking changes:
         *
         * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
         *
         * - Now `isValid` doesn't throw an exception
         *   if the first argument is not an instance of Date.
         *   Instead, argument is converted beforehand using `toDate`.
         *
         *   Examples:
         *
         *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
         *   |---------------------------|---------------|---------------|
         *   | `new Date()`              | `true`        | `true`        |
         *   | `new Date('2016-01-01')`  | `true`        | `true`        |
         *   | `new Date('')`            | `false`       | `false`       |
         *   | `new Date(1488370835081)` | `true`        | `true`        |
         *   | `new Date(NaN)`           | `false`       | `false`       |
         *   | `'2016-01-01'`            | `TypeError`   | `false`       |
         *   | `''`                      | `TypeError`   | `false`       |
         *   | `1488370835081`           | `TypeError`   | `true`        |
         *   | `NaN`                     | `TypeError`   | `false`       |
         *
         *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
         *   that try to coerce arguments to the expected type
         *   (which is also the case with other *date-fns* functions).
         *
         * @param {*} date - the date to check
         * @returns {Boolean} the date is valid
         * @throws {TypeError} 1 argument required
         *
         * @example
         * // For the valid date:
         * var result = isValid(new Date(2014, 1, 31))
         * //=> true
         *
         * @example
         * // For the value, convertable into a date:
         * var result = isValid(1393804800000)
         * //=> true
         *
         * @example
         * // For the invalid date:
         * var result = isValid(new Date(''))
         * //=> false
         */

        function isValid(dirtyDate) {
          (0, _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__.default)(1, arguments);
          var date = (0, _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__.default)(dirtyDate);
          return !isNaN(date);
        }

        /***/
      }),
      /***/"./node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js": (
      /*!**************************************************************************!*\
        !*** ./node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js ***!
        \**************************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function () {
            return /* binding */buildFormatLongFn;
          }
          /* harmony export */
        });
        function buildFormatLongFn(args) {
          return function (dirtyOptions) {
            var options = dirtyOptions || {};
            var width = options.width ? String(options.width) : args.defaultWidth;
            var format = args.formats[width] || args.formats[args.defaultWidth];
            return format;
          };
        }

        /***/
      }),
      /***/"./node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js": (
      /*!************************************************************************!*\
        !*** ./node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js ***!
        \************************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function () {
            return /* binding */buildLocalizeFn;
          }
          /* harmony export */
        });
        function buildLocalizeFn(args) {
          return function (dirtyIndex, dirtyOptions) {
            var options = dirtyOptions || {};
            var context = options.context ? String(options.context) : 'standalone';
            var valuesArray;
            if (context === 'formatting' && args.formattingValues) {
              var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
              var width = options.width ? String(options.width) : defaultWidth;
              valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
            } else {
              var _defaultWidth = args.defaultWidth;
              var _width = options.width ? String(options.width) : args.defaultWidth;
              valuesArray = args.values[_width] || args.values[_defaultWidth];
            }
            var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
            return valuesArray[index];
          };
        }

        /***/
      }),
      /***/"./node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js": (
      /*!*********************************************************************!*\
        !*** ./node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js ***!
        \*********************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function () {
            return /* binding */buildMatchFn;
          }
          /* harmony export */
        });
        function buildMatchFn(args) {
          return function (dirtyString, dirtyOptions) {
            var string = String(dirtyString);
            var options = dirtyOptions || {};
            var width = options.width;
            var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
            var matchResult = string.match(matchPattern);
            if (!matchResult) {
              return null;
            }
            var matchedString = matchResult[0];
            var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
            var value;
            if (Object.prototype.toString.call(parsePatterns) === '[object Array]') {
              value = findIndex(parsePatterns, function (pattern) {
                return pattern.test(matchedString);
              });
            } else {
              value = findKey(parsePatterns, function (pattern) {
                return pattern.test(matchedString);
              });
            }
            value = args.valueCallback ? args.valueCallback(value) : value;
            value = options.valueCallback ? options.valueCallback(value) : value;
            return {
              value: value,
              rest: string.slice(matchedString.length)
            };
          };
        }
        function findKey(object, predicate) {
          for (var key in object) {
            if (object.hasOwnProperty(key) && predicate(object[key])) {
              return key;
            }
          }
        }
        function findIndex(array, predicate) {
          for (var key = 0; key < array.length; key++) {
            if (predicate(array[key])) {
              return key;
            }
          }
        }

        /***/
      }),
      /***/"./node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js": (
      /*!****************************************************************************!*\
        !*** ./node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js ***!
        \****************************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function () {
            return /* binding */buildMatchPatternFn;
          }
          /* harmony export */
        });
        function buildMatchPatternFn(args) {
          return function (dirtyString, dirtyOptions) {
            var string = String(dirtyString);
            var options = dirtyOptions || {};
            var matchResult = string.match(args.matchPattern);
            if (!matchResult) {
              return null;
            }
            var matchedString = matchResult[0];
            var parseResult = string.match(args.parsePattern);
            if (!parseResult) {
              return null;
            }
            var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
            value = options.valueCallback ? options.valueCallback(value) : value;
            return {
              value: value,
              rest: string.slice(matchedString.length)
            };
          };
        }

        /***/
      }),
      /***/"./node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js": (
      /*!*****************************************************************************!*\
        !*** ./node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js ***!
        \*****************************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function () {
            return /* binding */formatDistance;
          }
          /* harmony export */
        });
        var formatDistanceLocale = {
          lessThanXSeconds: {
            one: 'less than a second',
            other: 'less than {{count}} seconds'
          },
          xSeconds: {
            one: '1 second',
            other: '{{count}} seconds'
          },
          halfAMinute: 'half a minute',
          lessThanXMinutes: {
            one: 'less than a minute',
            other: 'less than {{count}} minutes'
          },
          xMinutes: {
            one: '1 minute',
            other: '{{count}} minutes'
          },
          aboutXHours: {
            one: 'about 1 hour',
            other: 'about {{count}} hours'
          },
          xHours: {
            one: '1 hour',
            other: '{{count}} hours'
          },
          xDays: {
            one: '1 day',
            other: '{{count}} days'
          },
          aboutXWeeks: {
            one: 'about 1 week',
            other: 'about {{count}} weeks'
          },
          xWeeks: {
            one: '1 week',
            other: '{{count}} weeks'
          },
          aboutXMonths: {
            one: 'about 1 month',
            other: 'about {{count}} months'
          },
          xMonths: {
            one: '1 month',
            other: '{{count}} months'
          },
          aboutXYears: {
            one: 'about 1 year',
            other: 'about {{count}} years'
          },
          xYears: {
            one: '1 year',
            other: '{{count}} years'
          },
          overXYears: {
            one: 'over 1 year',
            other: 'over {{count}} years'
          },
          almostXYears: {
            one: 'almost 1 year',
            other: 'almost {{count}} years'
          }
        };
        function formatDistance(token, count, options) {
          options = options || {};
          var result;
          if (typeof formatDistanceLocale[token] === 'string') {
            result = formatDistanceLocale[token];
          } else if (count === 1) {
            result = formatDistanceLocale[token].one;
          } else {
            result = formatDistanceLocale[token].other.replace('{{count}}', count);
          }
          if (options.addSuffix) {
            if (options.comparison > 0) {
              return 'in ' + result;
            } else {
              return result + ' ago';
            }
          }
          return result;
        }

        /***/
      }),
      /***/"./node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js": (
      /*!*************************************************************************!*\
        !*** ./node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js ***!
        \*************************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */
        var _lib_buildFormatLongFn_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../_lib/buildFormatLongFn/index.js */"./node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js");
        var dateFormats = {
          full: 'EEEE, MMMM do, y',
          long: 'MMMM do, y',
          medium: 'MMM d, y',
          short: 'MM/dd/yyyy'
        };
        var timeFormats = {
          full: 'h:mm:ss a zzzz',
          long: 'h:mm:ss a z',
          medium: 'h:mm:ss a',
          short: 'h:mm a'
        };
        var dateTimeFormats = {
          full: "{{date}} 'at' {{time}}",
          long: "{{date}} 'at' {{time}}",
          medium: '{{date}}, {{time}}',
          short: '{{date}}, {{time}}'
        };
        var formatLong = {
          date: (0, _lib_buildFormatLongFn_index_js__WEBPACK_IMPORTED_MODULE_0__.default)({
            formats: dateFormats,
            defaultWidth: 'full'
          }),
          time: (0, _lib_buildFormatLongFn_index_js__WEBPACK_IMPORTED_MODULE_0__.default)({
            formats: timeFormats,
            defaultWidth: 'full'
          }),
          dateTime: (0, _lib_buildFormatLongFn_index_js__WEBPACK_IMPORTED_MODULE_0__.default)({
            formats: dateTimeFormats,
            defaultWidth: 'full'
          })
        };
        /* harmony default export */
        __webpack_exports__["default"] = formatLong;

        /***/
      }),
      /***/"./node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js": (
      /*!*****************************************************************************!*\
        !*** ./node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js ***!
        \*****************************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function () {
            return /* binding */formatRelative;
          }
          /* harmony export */
        });
        var formatRelativeLocale = {
          lastWeek: "'last' eeee 'at' p",
          yesterday: "'yesterday at' p",
          today: "'today at' p",
          tomorrow: "'tomorrow at' p",
          nextWeek: "eeee 'at' p",
          other: 'P'
        };
        function formatRelative(token, _date, _baseDate, _options) {
          return formatRelativeLocale[token];
        }

        /***/
      }),
      /***/"./node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js": (
      /*!***********************************************************************!*\
        !*** ./node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js ***!
        \***********************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */
        var _lib_buildLocalizeFn_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../_lib/buildLocalizeFn/index.js */"./node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js");
        var eraValues = {
          narrow: ['B', 'A'],
          abbreviated: ['BC', 'AD'],
          wide: ['Before Christ', 'Anno Domini']
        };
        var quarterValues = {
          narrow: ['1', '2', '3', '4'],
          abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
          wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter'] // Note: in English, the names of days of the week and months are capitalized.
          // If you are making a new locale based on this one, check if the same is true for the language you're working on.
          // Generally, formatted dates should look like they are in the middle of a sentence,
          // e.g. in Spanish language the weekdays and months should be in the lowercase.
        };
        var monthValues = {
          narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
          abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
        };
        var dayValues = {
          narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
          short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
          abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
        };
        var dayPeriodValues = {
          narrow: {
            am: 'a',
            pm: 'p',
            midnight: 'mi',
            noon: 'n',
            morning: 'morning',
            afternoon: 'afternoon',
            evening: 'evening',
            night: 'night'
          },
          abbreviated: {
            am: 'AM',
            pm: 'PM',
            midnight: 'midnight',
            noon: 'noon',
            morning: 'morning',
            afternoon: 'afternoon',
            evening: 'evening',
            night: 'night'
          },
          wide: {
            am: 'a.m.',
            pm: 'p.m.',
            midnight: 'midnight',
            noon: 'noon',
            morning: 'morning',
            afternoon: 'afternoon',
            evening: 'evening',
            night: 'night'
          }
        };
        var formattingDayPeriodValues = {
          narrow: {
            am: 'a',
            pm: 'p',
            midnight: 'mi',
            noon: 'n',
            morning: 'in the morning',
            afternoon: 'in the afternoon',
            evening: 'in the evening',
            night: 'at night'
          },
          abbreviated: {
            am: 'AM',
            pm: 'PM',
            midnight: 'midnight',
            noon: 'noon',
            morning: 'in the morning',
            afternoon: 'in the afternoon',
            evening: 'in the evening',
            night: 'at night'
          },
          wide: {
            am: 'a.m.',
            pm: 'p.m.',
            midnight: 'midnight',
            noon: 'noon',
            morning: 'in the morning',
            afternoon: 'in the afternoon',
            evening: 'in the evening',
            night: 'at night'
          }
        };
        function ordinalNumber(dirtyNumber, _dirtyOptions) {
          var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
          // if they are different for different grammatical genders,
          // use `options.unit`:
          //
          //   var options = dirtyOptions || {}
          //   var unit = String(options.unit)
          //
          // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
          // 'day', 'hour', 'minute', 'second'

          var rem100 = number % 100;
          if (rem100 > 20 || rem100 < 10) {
            switch (rem100 % 10) {
              case 1:
                return number + 'st';
              case 2:
                return number + 'nd';
              case 3:
                return number + 'rd';
            }
          }
          return number + 'th';
        }
        var localize = {
          ordinalNumber: ordinalNumber,
          era: (0, _lib_buildLocalizeFn_index_js__WEBPACK_IMPORTED_MODULE_0__.default)({
            values: eraValues,
            defaultWidth: 'wide'
          }),
          quarter: (0, _lib_buildLocalizeFn_index_js__WEBPACK_IMPORTED_MODULE_0__.default)({
            values: quarterValues,
            defaultWidth: 'wide',
            argumentCallback: function (quarter) {
              return Number(quarter) - 1;
            }
          }),
          month: (0, _lib_buildLocalizeFn_index_js__WEBPACK_IMPORTED_MODULE_0__.default)({
            values: monthValues,
            defaultWidth: 'wide'
          }),
          day: (0, _lib_buildLocalizeFn_index_js__WEBPACK_IMPORTED_MODULE_0__.default)({
            values: dayValues,
            defaultWidth: 'wide'
          }),
          dayPeriod: (0, _lib_buildLocalizeFn_index_js__WEBPACK_IMPORTED_MODULE_0__.default)({
            values: dayPeriodValues,
            defaultWidth: 'wide',
            formattingValues: formattingDayPeriodValues,
            defaultFormattingWidth: 'wide'
          })
        };
        /* harmony default export */
        __webpack_exports__["default"] = localize;

        /***/
      }),
      /***/"./node_modules/date-fns/esm/locale/en-US/_lib/match/index.js": (
      /*!********************************************************************!*\
        !*** ./node_modules/date-fns/esm/locale/en-US/_lib/match/index.js ***!
        \********************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */
        var _lib_buildMatchPatternFn_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../_lib/buildMatchPatternFn/index.js */"./node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js");
        /* harmony import */
        var _lib_buildMatchFn_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../_lib/buildMatchFn/index.js */"./node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js");
        var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
        var parseOrdinalNumberPattern = /\d+/i;
        var matchEraPatterns = {
          narrow: /^(b|a)/i,
          abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
          wide: /^(before christ|before common era|anno domini|common era)/i
        };
        var parseEraPatterns = {
          any: [/^b/i, /^(a|c)/i]
        };
        var matchQuarterPatterns = {
          narrow: /^[1234]/i,
          abbreviated: /^q[1234]/i,
          wide: /^[1234](th|st|nd|rd)? quarter/i
        };
        var parseQuarterPatterns = {
          any: [/1/i, /2/i, /3/i, /4/i]
        };
        var matchMonthPatterns = {
          narrow: /^[jfmasond]/i,
          abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
          wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
        };
        var parseMonthPatterns = {
          narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
          any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
        };
        var matchDayPatterns = {
          narrow: /^[smtwf]/i,
          short: /^(su|mo|tu|we|th|fr|sa)/i,
          abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
          wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
        };
        var parseDayPatterns = {
          narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
          any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
        };
        var matchDayPeriodPatterns = {
          narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
          any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
        };
        var parseDayPeriodPatterns = {
          any: {
            am: /^a/i,
            pm: /^p/i,
            midnight: /^mi/i,
            noon: /^no/i,
            morning: /morning/i,
            afternoon: /afternoon/i,
            evening: /evening/i,
            night: /night/i
          }
        };
        var match = {
          ordinalNumber: (0, _lib_buildMatchPatternFn_index_js__WEBPACK_IMPORTED_MODULE_0__.default)({
            matchPattern: matchOrdinalNumberPattern,
            parsePattern: parseOrdinalNumberPattern,
            valueCallback: function (value) {
              return parseInt(value, 10);
            }
          }),
          era: (0, _lib_buildMatchFn_index_js__WEBPACK_IMPORTED_MODULE_1__.default)({
            matchPatterns: matchEraPatterns,
            defaultMatchWidth: 'wide',
            parsePatterns: parseEraPatterns,
            defaultParseWidth: 'any'
          }),
          quarter: (0, _lib_buildMatchFn_index_js__WEBPACK_IMPORTED_MODULE_1__.default)({
            matchPatterns: matchQuarterPatterns,
            defaultMatchWidth: 'wide',
            parsePatterns: parseQuarterPatterns,
            defaultParseWidth: 'any',
            valueCallback: function (index) {
              return index + 1;
            }
          }),
          month: (0, _lib_buildMatchFn_index_js__WEBPACK_IMPORTED_MODULE_1__.default)({
            matchPatterns: matchMonthPatterns,
            defaultMatchWidth: 'wide',
            parsePatterns: parseMonthPatterns,
            defaultParseWidth: 'any'
          }),
          day: (0, _lib_buildMatchFn_index_js__WEBPACK_IMPORTED_MODULE_1__.default)({
            matchPatterns: matchDayPatterns,
            defaultMatchWidth: 'wide',
            parsePatterns: parseDayPatterns,
            defaultParseWidth: 'any'
          }),
          dayPeriod: (0, _lib_buildMatchFn_index_js__WEBPACK_IMPORTED_MODULE_1__.default)({
            matchPatterns: matchDayPeriodPatterns,
            defaultMatchWidth: 'any',
            parsePatterns: parseDayPeriodPatterns,
            defaultParseWidth: 'any'
          })
        };
        /* harmony default export */
        __webpack_exports__["default"] = match;

        /***/
      }),
      /***/"./node_modules/date-fns/esm/locale/en-US/index.js": (
      /*!*********************************************************!*\
        !*** ./node_modules/date-fns/esm/locale/en-US/index.js ***!
        \*********************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */
        var _lib_formatDistance_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./_lib/formatDistance/index.js */"./node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js");
        /* harmony import */
        var _lib_formatLong_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./_lib/formatLong/index.js */"./node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js");
        /* harmony import */
        var _lib_formatRelative_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./_lib/formatRelative/index.js */"./node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js");
        /* harmony import */
        var _lib_localize_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./_lib/localize/index.js */"./node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js");
        /* harmony import */
        var _lib_match_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./_lib/match/index.js */"./node_modules/date-fns/esm/locale/en-US/_lib/match/index.js");

        /**
         * @type {Locale}
         * @category Locales
         * @summary English locale (United States).
         * @language English
         * @iso-639-2 eng
         * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
         * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
         */

        var locale = {
          code: 'en-US',
          formatDistance: _lib_formatDistance_index_js__WEBPACK_IMPORTED_MODULE_0__.default,
          formatLong: _lib_formatLong_index_js__WEBPACK_IMPORTED_MODULE_1__.default,
          formatRelative: _lib_formatRelative_index_js__WEBPACK_IMPORTED_MODULE_2__.default,
          localize: _lib_localize_index_js__WEBPACK_IMPORTED_MODULE_3__.default,
          match: _lib_match_index_js__WEBPACK_IMPORTED_MODULE_4__.default,
          options: {
            weekStartsOn: 0
            /* Sunday */,

            firstWeekContainsDate: 1
          }
        };
        /* harmony default export */
        __webpack_exports__["default"] = locale;

        /***/
      }),
      /***/"./node_modules/date-fns/esm/subMilliseconds/index.js": (
      /*!************************************************************!*\
        !*** ./node_modules/date-fns/esm/subMilliseconds/index.js ***!
        \************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function () {
            return /* binding */subMilliseconds;
          }
          /* harmony export */
        });
        /* harmony import */
        var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../_lib/toInteger/index.js */"./node_modules/date-fns/esm/_lib/toInteger/index.js");
        /* harmony import */
        var _addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../addMilliseconds/index.js */"./node_modules/date-fns/esm/addMilliseconds/index.js");
        /* harmony import */
        var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/requiredArgs/index.js */"./node_modules/date-fns/esm/_lib/requiredArgs/index.js");

        /**
         * @name subMilliseconds
         * @category Millisecond Helpers
         * @summary Subtract the specified number of milliseconds from the given date.
         *
         * @description
         * Subtract the specified number of milliseconds from the given date.
         *
         * ### v2.0.0 breaking changes:
         *
         * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
         *
         * @param {Date|Number} date - the date to be changed
         * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
         * @returns {Date} the new date with the milliseconds subtracted
         * @throws {TypeError} 2 arguments required
         *
         * @example
         * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
         * var result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
         * //=> Thu Jul 10 2014 12:45:29.250
         */

        function subMilliseconds(dirtyDate, dirtyAmount) {
          (0, _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__.default)(2, arguments);
          var amount = (0, _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__.default)(dirtyAmount);
          return (0, _addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__.default)(dirtyDate, -amount);
        }

        /***/
      }),
      /***/"./node_modules/date-fns/esm/toDate/index.js": (
      /*!***************************************************!*\
        !*** ./node_modules/date-fns/esm/toDate/index.js ***!
        \***************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function () {
            return /* binding */toDate;
          }
          /* harmony export */
        });
        /* harmony import */
        var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../_lib/requiredArgs/index.js */"./node_modules/date-fns/esm/_lib/requiredArgs/index.js");

        /**
         * @name toDate
         * @category Common Helpers
         * @summary Convert the given argument to an instance of Date.
         *
         * @description
         * Convert the given argument to an instance of Date.
         *
         * If the argument is an instance of Date, the function returns its clone.
         *
         * If the argument is a number, it is treated as a timestamp.
         *
         * If the argument is none of the above, the function returns Invalid Date.
         *
         * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
         *
         * @param {Date|Number} argument - the value to convert
         * @returns {Date} the parsed date in the local time zone
         * @throws {TypeError} 1 argument required
         *
         * @example
         * // Clone the date:
         * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
         * //=> Tue Feb 11 2014 11:30:30
         *
         * @example
         * // Convert the timestamp to date:
         * const result = toDate(1392098430000)
         * //=> Tue Feb 11 2014 11:30:30
         */

        function toDate(argument) {
          (0, _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__.default)(1, arguments);
          var argStr = Object.prototype.toString.call(argument); // Clone the date

          if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
            // Prevent the date to lose the milliseconds when passed to new Date() in IE10
            return new Date(argument.getTime());
          } else if (typeof argument === 'number' || argStr === '[object Number]') {
            return new Date(argument);
          } else {
            if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
              // eslint-disable-next-line no-console
              console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

              console.warn(new Error().stack);
            }
            return new Date(NaN);
          }
        }

        /***/
      }),
      /***/"./node_modules/regenerator-runtime/runtime.js": (
      /*!*****************************************************!*\
        !*** ./node_modules/regenerator-runtime/runtime.js ***!
        \*****************************************************/
      /***/
      function (module) {
        /**
         * Copyright (c) 2014-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */

        var runtime = function (exports) {
          "use strict";

          var Op = Object.prototype;
          var hasOwn = Op.hasOwnProperty;
          var undefined; // More compressible than void 0.
          var $Symbol = typeof Symbol === "function" ? Symbol : {};
          var iteratorSymbol = $Symbol.iterator || "@@iterator";
          var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
          var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
          function define(obj, key, value) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true
            });
            return obj[key];
          }
          try {
            // IE 8 has a broken Object.defineProperty that only works on DOM objects.
            define({}, "");
          } catch (err) {
            define = function (obj, key, value) {
              return obj[key] = value;
            };
          }
          function wrap(innerFn, outerFn, self, tryLocsList) {
            // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
            var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
            var generator = Object.create(protoGenerator.prototype);
            var context = new Context(tryLocsList || []);

            // The ._invoke method unifies the implementations of the .next,
            // .throw, and .return methods.
            generator._invoke = makeInvokeMethod(innerFn, self, context);
            return generator;
          }
          exports.wrap = wrap;

          // Try/catch helper to minimize deoptimizations. Returns a completion
          // record like context.tryEntries[i].completion. This interface could
          // have been (and was previously) designed to take a closure to be
          // invoked without arguments, but in all the cases we care about we
          // already have an existing method we want to call, so there's no need
          // to create a new function object. We can even get away with assuming
          // the method takes exactly one argument, since that happens to be true
          // in every case, so we don't have to touch the arguments object. The
          // only additional allocation required is the completion record, which
          // has a stable shape and so hopefully should be cheap to allocate.
          function tryCatch(fn, obj, arg) {
            try {
              return {
                type: "normal",
                arg: fn.call(obj, arg)
              };
            } catch (err) {
              return {
                type: "throw",
                arg: err
              };
            }
          }
          var GenStateSuspendedStart = "suspendedStart";
          var GenStateSuspendedYield = "suspendedYield";
          var GenStateExecuting = "executing";
          var GenStateCompleted = "completed";

          // Returning this object from the innerFn has the same effect as
          // breaking out of the dispatch switch statement.
          var ContinueSentinel = {};

          // Dummy constructor functions that we use as the .constructor and
          // .constructor.prototype properties for functions that return Generator
          // objects. For full spec compliance, you may wish to configure your
          // minifier not to mangle the names of these two functions.
          function Generator() {}
          function GeneratorFunction() {}
          function GeneratorFunctionPrototype() {}

          // This is a polyfill for %IteratorPrototype% for environments that
          // don't natively support it.
          var IteratorPrototype = {};
          IteratorPrototype[iteratorSymbol] = function () {
            return this;
          };
          var getProto = Object.getPrototypeOf;
          var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
          if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
            // This environment has a native %IteratorPrototype%; use it instead
            // of the polyfill.
            IteratorPrototype = NativeIteratorPrototype;
          }
          var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
          GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
          GeneratorFunctionPrototype.constructor = GeneratorFunction;
          GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");

          // Helper for defining the .next, .throw, and .return methods of the
          // Iterator interface in terms of a single ._invoke method.
          function defineIteratorMethods(prototype) {
            ["next", "throw", "return"].forEach(function (method) {
              define(prototype, method, function (arg) {
                return this._invoke(method, arg);
              });
            });
          }
          exports.isGeneratorFunction = function (genFun) {
            var ctor = typeof genFun === "function" && genFun.constructor;
            return ctor ? ctor === GeneratorFunction ||
            // For the native GeneratorFunction constructor, the best we can
            // do is to check its .name property.
            (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
          };
          exports.mark = function (genFun) {
            if (Object.setPrototypeOf) {
              Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
            } else {
              genFun.__proto__ = GeneratorFunctionPrototype;
              define(genFun, toStringTagSymbol, "GeneratorFunction");
            }
            genFun.prototype = Object.create(Gp);
            return genFun;
          };

          // Within the body of any async function, `await x` is transformed to
          // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
          // `hasOwn.call(value, "__await")` to determine if the yielded value is
          // meant to be awaited.
          exports.awrap = function (arg) {
            return {
              __await: arg
            };
          };
          function AsyncIterator(generator, PromiseImpl) {
            function invoke(method, arg, resolve, reject) {
              var record = tryCatch(generator[method], generator, arg);
              if (record.type === "throw") {
                reject(record.arg);
              } else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
                  return PromiseImpl.resolve(value.__await).then(function (value) {
                    invoke("next", value, resolve, reject);
                  }, function (err) {
                    invoke("throw", err, resolve, reject);
                  });
                }
                return PromiseImpl.resolve(value).then(function (unwrapped) {
                  // When a yielded Promise is resolved, its final value becomes
                  // the .value of the Promise<{value,done}> result for the
                  // current iteration.
                  result.value = unwrapped;
                  resolve(result);
                }, function (error) {
                  // If a rejected Promise was yielded, throw the rejection back
                  // into the async generator function so it can be handled there.
                  return invoke("throw", error, resolve, reject);
                });
              }
            }
            var previousPromise;
            function enqueue(method, arg) {
              function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function (resolve, reject) {
                  invoke(method, arg, resolve, reject);
                });
              }
              return previousPromise =
              // If enqueue has been called before, then we want to wait until
              // all previous Promises have been resolved before calling invoke,
              // so that results are always delivered in the correct order. If
              // enqueue has not been called before, then it is important to
              // call invoke immediately, without waiting on a callback to fire,
              // so that the async generator function has the opportunity to do
              // any necessary setup in a predictable way. This predictability
              // is why the Promise constructor synchronously invokes its
              // executor callback, and why async functions synchronously
              // execute code before the first await. Since we implement simple
              // async functions in terms of async generators, it is especially
              // important to get this right, even though it requires care.
              previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
              // Avoid propagating failures to Promises returned by later
              // invocations of the iterator.
              callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }

            // Define the unified helper method that is used to implement .next,
            // .throw, and .return (see defineIteratorMethods).
            this._invoke = enqueue;
          }
          defineIteratorMethods(AsyncIterator.prototype);
          AsyncIterator.prototype[asyncIteratorSymbol] = function () {
            return this;
          };
          exports.AsyncIterator = AsyncIterator;

          // Note that simple async functions are implemented on top of
          // AsyncIterator objects; they just return a Promise for the value of
          // the final result produced by the iterator.
          exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
            if (PromiseImpl === void 0) PromiseImpl = Promise;
            var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
            return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
            : iter.next().then(function (result) {
              return result.done ? result.value : iter.next();
            });
          };
          function makeInvokeMethod(innerFn, self, context) {
            var state = GenStateSuspendedStart;
            return function invoke(method, arg) {
              if (state === GenStateExecuting) {
                throw new Error("Generator is already running");
              }
              if (state === GenStateCompleted) {
                if (method === "throw") {
                  throw arg;
                }

                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
              }
              context.method = method;
              context.arg = arg;
              while (true) {
                var delegate = context.delegate;
                if (delegate) {
                  var delegateResult = maybeInvokeDelegate(delegate, context);
                  if (delegateResult) {
                    if (delegateResult === ContinueSentinel) continue;
                    return delegateResult;
                  }
                }
                if (context.method === "next") {
                  // Setting context._sent for legacy support of Babel's
                  // function.sent implementation.
                  context.sent = context._sent = context.arg;
                } else if (context.method === "throw") {
                  if (state === GenStateSuspendedStart) {
                    state = GenStateCompleted;
                    throw context.arg;
                  }
                  context.dispatchException(context.arg);
                } else if (context.method === "return") {
                  context.abrupt("return", context.arg);
                }
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                  // If an exception is thrown from innerFn, we leave state ===
                  // GenStateExecuting and loop back for another invocation.
                  state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                  if (record.arg === ContinueSentinel) {
                    continue;
                  }
                  return {
                    value: record.arg,
                    done: context.done
                  };
                } else if (record.type === "throw") {
                  state = GenStateCompleted;
                  // Dispatch the exception by looping back around to the
                  // context.dispatchException(context.arg) call above.
                  context.method = "throw";
                  context.arg = record.arg;
                }
              }
            };
          }

          // Call delegate.iterator[context.method](context.arg) and handle the
          // result, either by returning a { value, done } result from the
          // delegate iterator, or by modifying context.method and context.arg,
          // setting context.delegate to null, and returning the ContinueSentinel.
          function maybeInvokeDelegate(delegate, context) {
            var method = delegate.iterator[context.method];
            if (method === undefined) {
              // A .throw or .return when the delegate iterator has no .throw
              // method always terminates the yield* loop.
              context.delegate = null;
              if (context.method === "throw") {
                // Note: ["return"] must be used for ES3 parsing compatibility.
                if (delegate.iterator["return"]) {
                  // If the delegate iterator has a return method, give it a
                  // chance to clean up.
                  context.method = "return";
                  context.arg = undefined;
                  maybeInvokeDelegate(delegate, context);
                  if (context.method === "throw") {
                    // If maybeInvokeDelegate(context) changed context.method from
                    // "return" to "throw", let that override the TypeError below.
                    return ContinueSentinel;
                  }
                }
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a 'throw' method");
              }
              return ContinueSentinel;
            }
            var record = tryCatch(method, delegate.iterator, context.arg);
            if (record.type === "throw") {
              context.method = "throw";
              context.arg = record.arg;
              context.delegate = null;
              return ContinueSentinel;
            }
            var info = record.arg;
            if (!info) {
              context.method = "throw";
              context.arg = new TypeError("iterator result is not an object");
              context.delegate = null;
              return ContinueSentinel;
            }
            if (info.done) {
              // Assign the result of the finished delegate to the temporary
              // variable specified by delegate.resultName (see delegateYield).
              context[delegate.resultName] = info.value;

              // Resume execution at the desired location (see delegateYield).
              context.next = delegate.nextLoc;

              // If context.method was "throw" but the delegate handled the
              // exception, let the outer generator proceed normally. If
              // context.method was "next", forget context.arg since it has been
              // "consumed" by the delegate iterator. If context.method was
              // "return", allow the original .return call to continue in the
              // outer generator.
              if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
              }
            } else {
              // Re-yield the result returned by the delegate method.
              return info;
            }

            // The delegate iterator is finished, so forget it and continue with
            // the outer generator.
            context.delegate = null;
            return ContinueSentinel;
          }

          // Define Generator.prototype.{next,throw,return} in terms of the
          // unified ._invoke helper method.
          defineIteratorMethods(Gp);
          define(Gp, toStringTagSymbol, "Generator");

          // A Generator should always return itself as the iterator object when the
          // @@iterator function is called on it. Some browsers' implementations of the
          // iterator prototype chain incorrectly implement this, causing the Generator
          // object to not be returned from this call. This ensures that doesn't happen.
          // See https://github.com/facebook/regenerator/issues/274 for more details.
          Gp[iteratorSymbol] = function () {
            return this;
          };
          Gp.toString = function () {
            return "[object Generator]";
          };
          function pushTryEntry(locs) {
            var entry = {
              tryLoc: locs[0]
            };
            if (1 in locs) {
              entry.catchLoc = locs[1];
            }
            if (2 in locs) {
              entry.finallyLoc = locs[2];
              entry.afterLoc = locs[3];
            }
            this.tryEntries.push(entry);
          }
          function resetTryEntry(entry) {
            var record = entry.completion || {};
            record.type = "normal";
            delete record.arg;
            entry.completion = record;
          }
          function Context(tryLocsList) {
            // The root entry object (effectively a try statement without a catch
            // or a finally block) gives us a place to store values thrown from
            // locations where there is no enclosing try statement.
            this.tryEntries = [{
              tryLoc: "root"
            }];
            tryLocsList.forEach(pushTryEntry, this);
            this.reset(true);
          }
          exports.keys = function (object) {
            var keys = [];
            for (var key in object) {
              keys.push(key);
            }
            keys.reverse();

            // Rather than returning an object with a next method, we keep
            // things simple and return the next function itself.
            return function next() {
              while (keys.length) {
                var key = keys.pop();
                if (key in object) {
                  next.value = key;
                  next.done = false;
                  return next;
                }
              }

              // To avoid creating an additional object, we just hang the .value
              // and .done properties off the next function object itself. This
              // also ensures that the minifier will not anonymize the function.
              next.done = true;
              return next;
            };
          };
          function values(iterable) {
            if (iterable) {
              var iteratorMethod = iterable[iteratorSymbol];
              if (iteratorMethod) {
                return iteratorMethod.call(iterable);
              }
              if (typeof iterable.next === "function") {
                return iterable;
              }
              if (!isNaN(iterable.length)) {
                var i = -1,
                  next = function next() {
                    while (++i < iterable.length) {
                      if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                      }
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                  };
                return next.next = next;
              }
            }

            // Return an iterator with no values.
            return {
              next: doneResult
            };
          }
          exports.values = values;
          function doneResult() {
            return {
              value: undefined,
              done: true
            };
          }
          Context.prototype = {
            constructor: Context,
            reset: function (skipTempReset) {
              this.prev = 0;
              this.next = 0;
              // Resetting context._sent for legacy support of Babel's
              // function.sent implementation.
              this.sent = this._sent = undefined;
              this.done = false;
              this.delegate = null;
              this.method = "next";
              this.arg = undefined;
              this.tryEntries.forEach(resetTryEntry);
              if (!skipTempReset) {
                for (var name in this) {
                  // Not sure about the optimal order of these conditions:
                  if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
                    this[name] = undefined;
                  }
                }
              }
            },
            stop: function () {
              this.done = true;
              var rootEntry = this.tryEntries[0];
              var rootRecord = rootEntry.completion;
              if (rootRecord.type === "throw") {
                throw rootRecord.arg;
              }
              return this.rval;
            },
            dispatchException: function (exception) {
              if (this.done) {
                throw exception;
              }
              var context = this;
              function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                  // If the dispatched exception was caught by a catch block,
                  // then let that catch block handle the exception normally.
                  context.method = "next";
                  context.arg = undefined;
                }
                return !!caught;
              }
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") {
                  // Exception thrown outside of any try block that could handle
                  // it, so set the completion value of the entire function to
                  // throw the exception.
                  return handle("end");
                }
                if (entry.tryLoc <= this.prev) {
                  var hasCatch = hasOwn.call(entry, "catchLoc");
                  var hasFinally = hasOwn.call(entry, "finallyLoc");
                  if (hasCatch && hasFinally) {
                    if (this.prev < entry.catchLoc) {
                      return handle(entry.catchLoc, true);
                    } else if (this.prev < entry.finallyLoc) {
                      return handle(entry.finallyLoc);
                    }
                  } else if (hasCatch) {
                    if (this.prev < entry.catchLoc) {
                      return handle(entry.catchLoc, true);
                    }
                  } else if (hasFinally) {
                    if (this.prev < entry.finallyLoc) {
                      return handle(entry.finallyLoc);
                    }
                  } else {
                    throw new Error("try statement without catch or finally");
                  }
                }
              }
            },
            abrupt: function (type, arg) {
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                  var finallyEntry = entry;
                  break;
                }
              }
              if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
                // Ignore the finally entry if control is not jumping to a
                // location outside the try/catch block.
                finallyEntry = null;
              }
              var record = finallyEntry ? finallyEntry.completion : {};
              record.type = type;
              record.arg = arg;
              if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
              }
              return this.complete(record);
            },
            complete: function (record, afterLoc) {
              if (record.type === "throw") {
                throw record.arg;
              }
              if (record.type === "break" || record.type === "continue") {
                this.next = record.arg;
              } else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
              } else if (record.type === "normal" && afterLoc) {
                this.next = afterLoc;
              }
              return ContinueSentinel;
            },
            finish: function (finallyLoc) {
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                  this.complete(entry.completion, entry.afterLoc);
                  resetTryEntry(entry);
                  return ContinueSentinel;
                }
              }
            },
            "catch": function (tryLoc) {
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                  var record = entry.completion;
                  if (record.type === "throw") {
                    var thrown = record.arg;
                    resetTryEntry(entry);
                  }
                  return thrown;
                }
              }

              // The context.catch method must only be called with a location
              // argument that corresponds to a known catch block.
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (iterable, resultName, nextLoc) {
              this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
              };
              if (this.method === "next") {
                // Deliberately forget the last sent value so that we don't
                // accidentally pass it on to the delegate.
                this.arg = undefined;
              }
              return ContinueSentinel;
            }
          };

          // Regardless of whether this script is executing as a CommonJS module
          // or not, return the runtime object so that we can declare the variable
          // regeneratorRuntime in the outer scope, which allows this module to be
          // injected easily by `bin/regenerator --include-runtime script.js`.
          return exports;
        }(
        // If this script is executing as a CommonJS module, use module.exports
        // as the regeneratorRuntime namespace. Otherwise create a new empty
        // object. Either way, the resulting object will be used to initialize
        // the regeneratorRuntime variable at the top of this file.
        true ? module.exports : 0);
        try {
          regeneratorRuntime = runtime;
        } catch (accidentalStrictMode) {
          // This module should not be running in strict mode, so the above
          // assignment should always work unless something is misconfigured. Just
          // in case runtime.js accidentally runs in strict mode, we can escape
          // strict mode using a global Function call. This could conceivably fail
          // if a Content Security Policy forbids using Function, but in that case
          // the proper solution is to fix the accidental strict mode problem. If
          // you've misconfigured your bundler to force strict mode and applied a
          // CSP to forbid Function, and you're not willing to fix either of those
          // problems, please detail your unique predicament in a GitHub issue.
          Function("r", "regeneratorRuntime = r")(runtime);
        }

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/Observable.js": (
      /*!********************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/Observable.js ***!
        \********************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"Observable": function () {
            return /* binding */Observable;
          }
          /* harmony export */
        });
        /* harmony import */
        var _util_canReportError__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./util/canReportError */"./node_modules/rxjs/_esm5/internal/util/canReportError.js");
        /* harmony import */
        var _util_toSubscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./util/toSubscriber */"./node_modules/rxjs/_esm5/internal/util/toSubscriber.js");
        /* harmony import */
        var _symbol_observable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./symbol/observable */"./node_modules/rxjs/_esm5/internal/symbol/observable.js");
        /* harmony import */
        var _util_pipe__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./util/pipe */"./node_modules/rxjs/_esm5/internal/util/pipe.js");
        /* harmony import */
        var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./config */"./node_modules/rxjs/_esm5/internal/config.js");
        /** PURE_IMPORTS_START _util_canReportError,_util_toSubscriber,_symbol_observable,_util_pipe,_config PURE_IMPORTS_END */

        var Observable = /*@__PURE__*/function () {
          function Observable(subscribe) {
            this._isScalar = false;
            if (subscribe) {
              this._subscribe = subscribe;
            }
          }
          Observable.prototype.lift = function (operator) {
            var observable = new Observable();
            observable.source = this;
            observable.operator = operator;
            return observable;
          };
          Observable.prototype.subscribe = function (observerOrNext, error, complete) {
            var operator = this.operator;
            var sink = (0, _util_toSubscriber__WEBPACK_IMPORTED_MODULE_0__.toSubscriber)(observerOrNext, error, complete);
            if (operator) {
              sink.add(operator.call(sink, this.source));
            } else {
              sink.add(this.source || _config__WEBPACK_IMPORTED_MODULE_1__.config.useDeprecatedSynchronousErrorHandling && !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
            }
            if (_config__WEBPACK_IMPORTED_MODULE_1__.config.useDeprecatedSynchronousErrorHandling) {
              if (sink.syncErrorThrowable) {
                sink.syncErrorThrowable = false;
                if (sink.syncErrorThrown) {
                  throw sink.syncErrorValue;
                }
              }
            }
            return sink;
          };
          Observable.prototype._trySubscribe = function (sink) {
            try {
              return this._subscribe(sink);
            } catch (err) {
              if (_config__WEBPACK_IMPORTED_MODULE_1__.config.useDeprecatedSynchronousErrorHandling) {
                sink.syncErrorThrown = true;
                sink.syncErrorValue = err;
              }
              if ((0, _util_canReportError__WEBPACK_IMPORTED_MODULE_2__.canReportError)(sink)) {
                sink.error(err);
              } else {
                console.warn(err);
              }
            }
          };
          Observable.prototype.forEach = function (next, promiseCtor) {
            var _this = this;
            promiseCtor = getPromiseCtor(promiseCtor);
            return new promiseCtor(function (resolve, reject) {
              var subscription;
              subscription = _this.subscribe(function (value) {
                try {
                  next(value);
                } catch (err) {
                  reject(err);
                  if (subscription) {
                    subscription.unsubscribe();
                  }
                }
              }, reject, resolve);
            });
          };
          Observable.prototype._subscribe = function (subscriber) {
            var source = this.source;
            return source && source.subscribe(subscriber);
          };
          Observable.prototype[_symbol_observable__WEBPACK_IMPORTED_MODULE_3__.observable] = function () {
            return this;
          };
          Observable.prototype.pipe = function () {
            var operations = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              operations[_i] = arguments[_i];
            }
            if (operations.length === 0) {
              return this;
            }
            return (0, _util_pipe__WEBPACK_IMPORTED_MODULE_4__.pipeFromArray)(operations)(this);
          };
          Observable.prototype.toPromise = function (promiseCtor) {
            var _this = this;
            promiseCtor = getPromiseCtor(promiseCtor);
            return new promiseCtor(function (resolve, reject) {
              var value;
              _this.subscribe(function (x) {
                return value = x;
              }, function (err) {
                return reject(err);
              }, function () {
                return resolve(value);
              });
            });
          };
          Observable.create = function (subscribe) {
            return new Observable(subscribe);
          };
          return Observable;
        }();
        function getPromiseCtor(promiseCtor) {
          if (!promiseCtor) {
            promiseCtor = _config__WEBPACK_IMPORTED_MODULE_1__.config.Promise || Promise;
          }
          if (!promiseCtor) {
            throw new Error('no Promise impl found');
          }
          return promiseCtor;
        }
        //# sourceMappingURL=Observable.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/Observer.js": (
      /*!******************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/Observer.js ***!
        \******************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"empty": function () {
            return /* binding */empty;
          }
          /* harmony export */
        });
        /* harmony import */
        var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./config */"./node_modules/rxjs/_esm5/internal/config.js");
        /* harmony import */
        var _util_hostReportError__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./util/hostReportError */"./node_modules/rxjs/_esm5/internal/util/hostReportError.js");
        /** PURE_IMPORTS_START _config,_util_hostReportError PURE_IMPORTS_END */

        var empty = {
          closed: true,
          next: function (value) {},
          error: function (err) {
            if (_config__WEBPACK_IMPORTED_MODULE_0__.config.useDeprecatedSynchronousErrorHandling) {
              throw err;
            } else {
              (0, _util_hostReportError__WEBPACK_IMPORTED_MODULE_1__.hostReportError)(err);
            }
          },
          complete: function () {}
        };
        //# sourceMappingURL=Observer.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/Subscriber.js": (
      /*!********************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/Subscriber.js ***!
        \********************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"Subscriber": function () {
            return /* binding */Subscriber;
          },
          /* harmony export */"SafeSubscriber": function () {
            return /* binding */SafeSubscriber;
          }
          /* harmony export */
        });
        /* harmony import */
        var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */"./node_modules/tslib/tslib.es6.js");
        /* harmony import */
        var _util_isFunction__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./util/isFunction */"./node_modules/rxjs/_esm5/internal/util/isFunction.js");
        /* harmony import */
        var _Observer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Observer */"./node_modules/rxjs/_esm5/internal/Observer.js");
        /* harmony import */
        var _Subscription__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Subscription */"./node_modules/rxjs/_esm5/internal/Subscription.js");
        /* harmony import */
        var _internal_symbol_rxSubscriber__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../internal/symbol/rxSubscriber */"./node_modules/rxjs/_esm5/internal/symbol/rxSubscriber.js");
        /* harmony import */
        var _config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./config */"./node_modules/rxjs/_esm5/internal/config.js");
        /* harmony import */
        var _util_hostReportError__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./util/hostReportError */"./node_modules/rxjs/_esm5/internal/util/hostReportError.js");
        /** PURE_IMPORTS_START tslib,_util_isFunction,_Observer,_Subscription,_internal_symbol_rxSubscriber,_config,_util_hostReportError PURE_IMPORTS_END */

        var Subscriber = /*@__PURE__*/function (_super) {
          tslib__WEBPACK_IMPORTED_MODULE_0__.__extends(Subscriber, _super);
          function Subscriber(destinationOrNext, error, complete) {
            var _this = _super.call(this) || this;
            _this.syncErrorValue = null;
            _this.syncErrorThrown = false;
            _this.syncErrorThrowable = false;
            _this.isStopped = false;
            switch (arguments.length) {
              case 0:
                _this.destination = _Observer__WEBPACK_IMPORTED_MODULE_1__.empty;
                break;
              case 1:
                if (!destinationOrNext) {
                  _this.destination = _Observer__WEBPACK_IMPORTED_MODULE_1__.empty;
                  break;
                }
                if (typeof destinationOrNext === 'object') {
                  if (destinationOrNext instanceof Subscriber) {
                    _this.syncErrorThrowable = destinationOrNext.syncErrorThrowable;
                    _this.destination = destinationOrNext;
                    destinationOrNext.add(_this);
                  } else {
                    _this.syncErrorThrowable = true;
                    _this.destination = new SafeSubscriber(_this, destinationOrNext);
                  }
                  break;
                }
              default:
                _this.syncErrorThrowable = true;
                _this.destination = new SafeSubscriber(_this, destinationOrNext, error, complete);
                break;
            }
            return _this;
          }
          Subscriber.prototype[_internal_symbol_rxSubscriber__WEBPACK_IMPORTED_MODULE_2__.rxSubscriber] = function () {
            return this;
          };
          Subscriber.create = function (next, error, complete) {
            var subscriber = new Subscriber(next, error, complete);
            subscriber.syncErrorThrowable = false;
            return subscriber;
          };
          Subscriber.prototype.next = function (value) {
            if (!this.isStopped) {
              this._next(value);
            }
          };
          Subscriber.prototype.error = function (err) {
            if (!this.isStopped) {
              this.isStopped = true;
              this._error(err);
            }
          };
          Subscriber.prototype.complete = function () {
            if (!this.isStopped) {
              this.isStopped = true;
              this._complete();
            }
          };
          Subscriber.prototype.unsubscribe = function () {
            if (this.closed) {
              return;
            }
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
          };
          Subscriber.prototype._next = function (value) {
            this.destination.next(value);
          };
          Subscriber.prototype._error = function (err) {
            this.destination.error(err);
            this.unsubscribe();
          };
          Subscriber.prototype._complete = function () {
            this.destination.complete();
            this.unsubscribe();
          };
          Subscriber.prototype._unsubscribeAndRecycle = function () {
            var _parentOrParents = this._parentOrParents;
            this._parentOrParents = null;
            this.unsubscribe();
            this.closed = false;
            this.isStopped = false;
            this._parentOrParents = _parentOrParents;
            return this;
          };
          return Subscriber;
        }(_Subscription__WEBPACK_IMPORTED_MODULE_3__.Subscription);
        var SafeSubscriber = /*@__PURE__*/function (_super) {
          tslib__WEBPACK_IMPORTED_MODULE_0__.__extends(SafeSubscriber, _super);
          function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
            var _this = _super.call(this) || this;
            _this._parentSubscriber = _parentSubscriber;
            var next;
            var context = _this;
            if ((0, _util_isFunction__WEBPACK_IMPORTED_MODULE_4__.isFunction)(observerOrNext)) {
              next = observerOrNext;
            } else if (observerOrNext) {
              next = observerOrNext.next;
              error = observerOrNext.error;
              complete = observerOrNext.complete;
              if (observerOrNext !== _Observer__WEBPACK_IMPORTED_MODULE_1__.empty) {
                context = Object.create(observerOrNext);
                if ((0, _util_isFunction__WEBPACK_IMPORTED_MODULE_4__.isFunction)(context.unsubscribe)) {
                  _this.add(context.unsubscribe.bind(context));
                }
                context.unsubscribe = _this.unsubscribe.bind(_this);
              }
            }
            _this._context = context;
            _this._next = next;
            _this._error = error;
            _this._complete = complete;
            return _this;
          }
          SafeSubscriber.prototype.next = function (value) {
            if (!this.isStopped && this._next) {
              var _parentSubscriber = this._parentSubscriber;
              if (!_config__WEBPACK_IMPORTED_MODULE_5__.config.useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                this.__tryOrUnsub(this._next, value);
              } else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
                this.unsubscribe();
              }
            }
          };
          SafeSubscriber.prototype.error = function (err) {
            if (!this.isStopped) {
              var _parentSubscriber = this._parentSubscriber;
              var useDeprecatedSynchronousErrorHandling = _config__WEBPACK_IMPORTED_MODULE_5__.config.useDeprecatedSynchronousErrorHandling;
              if (this._error) {
                if (!useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                  this.__tryOrUnsub(this._error, err);
                  this.unsubscribe();
                } else {
                  this.__tryOrSetError(_parentSubscriber, this._error, err);
                  this.unsubscribe();
                }
              } else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                if (useDeprecatedSynchronousErrorHandling) {
                  throw err;
                }
                (0, _util_hostReportError__WEBPACK_IMPORTED_MODULE_6__.hostReportError)(err);
              } else {
                if (useDeprecatedSynchronousErrorHandling) {
                  _parentSubscriber.syncErrorValue = err;
                  _parentSubscriber.syncErrorThrown = true;
                } else {
                  (0, _util_hostReportError__WEBPACK_IMPORTED_MODULE_6__.hostReportError)(err);
                }
                this.unsubscribe();
              }
            }
          };
          SafeSubscriber.prototype.complete = function () {
            var _this = this;
            if (!this.isStopped) {
              var _parentSubscriber = this._parentSubscriber;
              if (this._complete) {
                var wrappedComplete = function () {
                  return _this._complete.call(_this._context);
                };
                if (!_config__WEBPACK_IMPORTED_MODULE_5__.config.useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                  this.__tryOrUnsub(wrappedComplete);
                  this.unsubscribe();
                } else {
                  this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                  this.unsubscribe();
                }
              } else {
                this.unsubscribe();
              }
            }
          };
          SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
            try {
              fn.call(this._context, value);
            } catch (err) {
              this.unsubscribe();
              if (_config__WEBPACK_IMPORTED_MODULE_5__.config.useDeprecatedSynchronousErrorHandling) {
                throw err;
              } else {
                (0, _util_hostReportError__WEBPACK_IMPORTED_MODULE_6__.hostReportError)(err);
              }
            }
          };
          SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
            if (!_config__WEBPACK_IMPORTED_MODULE_5__.config.useDeprecatedSynchronousErrorHandling) {
              throw new Error('bad call');
            }
            try {
              fn.call(this._context, value);
            } catch (err) {
              if (_config__WEBPACK_IMPORTED_MODULE_5__.config.useDeprecatedSynchronousErrorHandling) {
                parent.syncErrorValue = err;
                parent.syncErrorThrown = true;
                return true;
              } else {
                (0, _util_hostReportError__WEBPACK_IMPORTED_MODULE_6__.hostReportError)(err);
                return true;
              }
            }
            return false;
          };
          SafeSubscriber.prototype._unsubscribe = function () {
            var _parentSubscriber = this._parentSubscriber;
            this._context = null;
            this._parentSubscriber = null;
            _parentSubscriber.unsubscribe();
          };
          return SafeSubscriber;
        }(Subscriber);

        //# sourceMappingURL=Subscriber.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/Subscription.js": (
      /*!**********************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/Subscription.js ***!
        \**********************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"Subscription": function () {
            return /* binding */Subscription;
          }
          /* harmony export */
        });
        /* harmony import */
        var _util_isArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./util/isArray */"./node_modules/rxjs/_esm5/internal/util/isArray.js");
        /* harmony import */
        var _util_isObject__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./util/isObject */"./node_modules/rxjs/_esm5/internal/util/isObject.js");
        /* harmony import */
        var _util_isFunction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./util/isFunction */"./node_modules/rxjs/_esm5/internal/util/isFunction.js");
        /* harmony import */
        var _util_UnsubscriptionError__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./util/UnsubscriptionError */"./node_modules/rxjs/_esm5/internal/util/UnsubscriptionError.js");
        /** PURE_IMPORTS_START _util_isArray,_util_isObject,_util_isFunction,_util_UnsubscriptionError PURE_IMPORTS_END */

        var Subscription = /*@__PURE__*/function () {
          function Subscription(unsubscribe) {
            this.closed = false;
            this._parentOrParents = null;
            this._subscriptions = null;
            if (unsubscribe) {
              this._ctorUnsubscribe = true;
              this._unsubscribe = unsubscribe;
            }
          }
          Subscription.prototype.unsubscribe = function () {
            var errors;
            if (this.closed) {
              return;
            }
            var _a = this,
              _parentOrParents = _a._parentOrParents,
              _ctorUnsubscribe = _a._ctorUnsubscribe,
              _unsubscribe = _a._unsubscribe,
              _subscriptions = _a._subscriptions;
            this.closed = true;
            this._parentOrParents = null;
            this._subscriptions = null;
            if (_parentOrParents instanceof Subscription) {
              _parentOrParents.remove(this);
            } else if (_parentOrParents !== null) {
              for (var index = 0; index < _parentOrParents.length; ++index) {
                var parent_1 = _parentOrParents[index];
                parent_1.remove(this);
              }
            }
            if ((0, _util_isFunction__WEBPACK_IMPORTED_MODULE_0__.isFunction)(_unsubscribe)) {
              if (_ctorUnsubscribe) {
                this._unsubscribe = undefined;
              }
              try {
                _unsubscribe.call(this);
              } catch (e) {
                errors = e instanceof _util_UnsubscriptionError__WEBPACK_IMPORTED_MODULE_1__.UnsubscriptionError ? flattenUnsubscriptionErrors(e.errors) : [e];
              }
            }
            if ((0, _util_isArray__WEBPACK_IMPORTED_MODULE_2__.isArray)(_subscriptions)) {
              var index = -1;
              var len = _subscriptions.length;
              while (++index < len) {
                var sub = _subscriptions[index];
                if ((0, _util_isObject__WEBPACK_IMPORTED_MODULE_3__.isObject)(sub)) {
                  try {
                    sub.unsubscribe();
                  } catch (e) {
                    errors = errors || [];
                    if (e instanceof _util_UnsubscriptionError__WEBPACK_IMPORTED_MODULE_1__.UnsubscriptionError) {
                      errors = errors.concat(flattenUnsubscriptionErrors(e.errors));
                    } else {
                      errors.push(e);
                    }
                  }
                }
              }
            }
            if (errors) {
              throw new _util_UnsubscriptionError__WEBPACK_IMPORTED_MODULE_1__.UnsubscriptionError(errors);
            }
          };
          Subscription.prototype.add = function (teardown) {
            var subscription = teardown;
            if (!teardown) {
              return Subscription.EMPTY;
            }
            switch (typeof teardown) {
              case 'function':
                subscription = new Subscription(teardown);
              case 'object':
                if (subscription === this || subscription.closed || typeof subscription.unsubscribe !== 'function') {
                  return subscription;
                } else if (this.closed) {
                  subscription.unsubscribe();
                  return subscription;
                } else if (!(subscription instanceof Subscription)) {
                  var tmp = subscription;
                  subscription = new Subscription();
                  subscription._subscriptions = [tmp];
                }
                break;
              default:
                {
                  throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
                }
            }
            var _parentOrParents = subscription._parentOrParents;
            if (_parentOrParents === null) {
              subscription._parentOrParents = this;
            } else if (_parentOrParents instanceof Subscription) {
              if (_parentOrParents === this) {
                return subscription;
              }
              subscription._parentOrParents = [_parentOrParents, this];
            } else if (_parentOrParents.indexOf(this) === -1) {
              _parentOrParents.push(this);
            } else {
              return subscription;
            }
            var subscriptions = this._subscriptions;
            if (subscriptions === null) {
              this._subscriptions = [subscription];
            } else {
              subscriptions.push(subscription);
            }
            return subscription;
          };
          Subscription.prototype.remove = function (subscription) {
            var subscriptions = this._subscriptions;
            if (subscriptions) {
              var subscriptionIndex = subscriptions.indexOf(subscription);
              if (subscriptionIndex !== -1) {
                subscriptions.splice(subscriptionIndex, 1);
              }
            }
          };
          Subscription.EMPTY = function (empty) {
            empty.closed = true;
            return empty;
          }(new Subscription());
          return Subscription;
        }();
        function flattenUnsubscriptionErrors(errors) {
          return errors.reduce(function (errs, err) {
            return errs.concat(err instanceof _util_UnsubscriptionError__WEBPACK_IMPORTED_MODULE_1__.UnsubscriptionError ? err.errors : err);
          }, []);
        }
        //# sourceMappingURL=Subscription.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/config.js": (
      /*!****************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/config.js ***!
        \****************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"config": function () {
            return /* binding */config;
          }
          /* harmony export */
        });
        /** PURE_IMPORTS_START  PURE_IMPORTS_END */
        var _enable_super_gross_mode_that_will_cause_bad_things = false;
        var config = {
          Promise: undefined,
          set useDeprecatedSynchronousErrorHandling(value) {
            if (value) {
              var error = /*@__PURE__*/new Error();
              /*@__PURE__*/
              console.warn('DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n' + error.stack);
            } else if (_enable_super_gross_mode_that_will_cause_bad_things) {
              /*@__PURE__*/console.log('RxJS: Back to a better error behavior. Thank you. <3');
            }
            _enable_super_gross_mode_that_will_cause_bad_things = value;
          },
          get useDeprecatedSynchronousErrorHandling() {
            return _enable_super_gross_mode_that_will_cause_bad_things;
          }
        };
        //# sourceMappingURL=config.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/innerSubscribe.js": (
      /*!************************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/innerSubscribe.js ***!
        \************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"SimpleInnerSubscriber": function () {
            return /* binding */SimpleInnerSubscriber;
          },
          /* harmony export */"ComplexInnerSubscriber": function () {
            return /* binding */ComplexInnerSubscriber;
          },
          /* harmony export */"SimpleOuterSubscriber": function () {
            return /* binding */SimpleOuterSubscriber;
          },
          /* harmony export */"ComplexOuterSubscriber": function () {
            return /* binding */ComplexOuterSubscriber;
          },
          /* harmony export */"innerSubscribe": function () {
            return /* binding */innerSubscribe;
          }
          /* harmony export */
        });
        /* harmony import */
        var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */"./node_modules/tslib/tslib.es6.js");
        /* harmony import */
        var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Subscriber */"./node_modules/rxjs/_esm5/internal/Subscriber.js");
        /* harmony import */
        var _Observable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Observable */"./node_modules/rxjs/_esm5/internal/Observable.js");
        /* harmony import */
        var _util_subscribeTo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./util/subscribeTo */"./node_modules/rxjs/_esm5/internal/util/subscribeTo.js");
        /** PURE_IMPORTS_START tslib,_Subscriber,_Observable,_util_subscribeTo PURE_IMPORTS_END */

        var SimpleInnerSubscriber = /*@__PURE__*/function (_super) {
          tslib__WEBPACK_IMPORTED_MODULE_0__.__extends(SimpleInnerSubscriber, _super);
          function SimpleInnerSubscriber(parent) {
            var _this = _super.call(this) || this;
            _this.parent = parent;
            return _this;
          }
          SimpleInnerSubscriber.prototype._next = function (value) {
            this.parent.notifyNext(value);
          };
          SimpleInnerSubscriber.prototype._error = function (error) {
            this.parent.notifyError(error);
            this.unsubscribe();
          };
          SimpleInnerSubscriber.prototype._complete = function () {
            this.parent.notifyComplete();
            this.unsubscribe();
          };
          return SimpleInnerSubscriber;
        }(_Subscriber__WEBPACK_IMPORTED_MODULE_1__.Subscriber);
        var ComplexInnerSubscriber = /*@__PURE__*/function (_super) {
          tslib__WEBPACK_IMPORTED_MODULE_0__.__extends(ComplexInnerSubscriber, _super);
          function ComplexInnerSubscriber(parent, outerValue, outerIndex) {
            var _this = _super.call(this) || this;
            _this.parent = parent;
            _this.outerValue = outerValue;
            _this.outerIndex = outerIndex;
            return _this;
          }
          ComplexInnerSubscriber.prototype._next = function (value) {
            this.parent.notifyNext(this.outerValue, value, this.outerIndex, this);
          };
          ComplexInnerSubscriber.prototype._error = function (error) {
            this.parent.notifyError(error);
            this.unsubscribe();
          };
          ComplexInnerSubscriber.prototype._complete = function () {
            this.parent.notifyComplete(this);
            this.unsubscribe();
          };
          return ComplexInnerSubscriber;
        }(_Subscriber__WEBPACK_IMPORTED_MODULE_1__.Subscriber);
        var SimpleOuterSubscriber = /*@__PURE__*/function (_super) {
          tslib__WEBPACK_IMPORTED_MODULE_0__.__extends(SimpleOuterSubscriber, _super);
          function SimpleOuterSubscriber() {
            return _super !== null && _super.apply(this, arguments) || this;
          }
          SimpleOuterSubscriber.prototype.notifyNext = function (innerValue) {
            this.destination.next(innerValue);
          };
          SimpleOuterSubscriber.prototype.notifyError = function (err) {
            this.destination.error(err);
          };
          SimpleOuterSubscriber.prototype.notifyComplete = function () {
            this.destination.complete();
          };
          return SimpleOuterSubscriber;
        }(_Subscriber__WEBPACK_IMPORTED_MODULE_1__.Subscriber);
        var ComplexOuterSubscriber = /*@__PURE__*/function (_super) {
          tslib__WEBPACK_IMPORTED_MODULE_0__.__extends(ComplexOuterSubscriber, _super);
          function ComplexOuterSubscriber() {
            return _super !== null && _super.apply(this, arguments) || this;
          }
          ComplexOuterSubscriber.prototype.notifyNext = function (_outerValue, innerValue, _outerIndex, _innerSub) {
            this.destination.next(innerValue);
          };
          ComplexOuterSubscriber.prototype.notifyError = function (error) {
            this.destination.error(error);
          };
          ComplexOuterSubscriber.prototype.notifyComplete = function (_innerSub) {
            this.destination.complete();
          };
          return ComplexOuterSubscriber;
        }(_Subscriber__WEBPACK_IMPORTED_MODULE_1__.Subscriber);
        function innerSubscribe(result, innerSubscriber) {
          if (innerSubscriber.closed) {
            return undefined;
          }
          if (result instanceof _Observable__WEBPACK_IMPORTED_MODULE_2__.Observable) {
            return result.subscribe(innerSubscriber);
          }
          var subscription;
          try {
            subscription = (0, _util_subscribeTo__WEBPACK_IMPORTED_MODULE_3__.subscribeTo)(result)(innerSubscriber);
          } catch (error) {
            innerSubscriber.error(error);
          }
          return subscription;
        }
        //# sourceMappingURL=innerSubscribe.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/observable/from.js": (
      /*!*************************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/observable/from.js ***!
        \*************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"from": function () {
            return /* binding */from;
          }
          /* harmony export */
        });
        /* harmony import */
        var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */"./node_modules/rxjs/_esm5/internal/Observable.js");
        /* harmony import */
        var _util_subscribeTo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/subscribeTo */"./node_modules/rxjs/_esm5/internal/util/subscribeTo.js");
        /* harmony import */
        var _scheduled_scheduled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../scheduled/scheduled */"./node_modules/rxjs/_esm5/internal/scheduled/scheduled.js");
        /** PURE_IMPORTS_START _Observable,_util_subscribeTo,_scheduled_scheduled PURE_IMPORTS_END */

        function from(input, scheduler) {
          if (!scheduler) {
            if (input instanceof _Observable__WEBPACK_IMPORTED_MODULE_0__.Observable) {
              return input;
            }
            return new _Observable__WEBPACK_IMPORTED_MODULE_0__.Observable((0, _util_subscribeTo__WEBPACK_IMPORTED_MODULE_1__.subscribeTo)(input));
          } else {
            return (0, _scheduled_scheduled__WEBPACK_IMPORTED_MODULE_2__.scheduled)(input, scheduler);
          }
        }
        //# sourceMappingURL=from.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/operators/concatMap.js": (
      /*!*****************************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/operators/concatMap.js ***!
        \*****************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"concatMap": function () {
            return /* binding */concatMap;
          }
          /* harmony export */
        });
        /* harmony import */
        var _mergeMap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./mergeMap */"./node_modules/rxjs/_esm5/internal/operators/mergeMap.js");
        /** PURE_IMPORTS_START _mergeMap PURE_IMPORTS_END */

        function concatMap(project, resultSelector) {
          return (0, _mergeMap__WEBPACK_IMPORTED_MODULE_0__.mergeMap)(project, resultSelector, 1);
        }
        //# sourceMappingURL=concatMap.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/operators/filter.js": (
      /*!**************************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/operators/filter.js ***!
        \**************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"filter": function () {
            return /* binding */filter;
          }
          /* harmony export */
        });
        /* harmony import */
        var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */"./node_modules/tslib/tslib.es6.js");
        /* harmony import */
        var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */"./node_modules/rxjs/_esm5/internal/Subscriber.js");
        /** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */

        function filter(predicate, thisArg) {
          return function filterOperatorFunction(source) {
            return source.lift(new FilterOperator(predicate, thisArg));
          };
        }
        var FilterOperator = /*@__PURE__*/function () {
          function FilterOperator(predicate, thisArg) {
            this.predicate = predicate;
            this.thisArg = thisArg;
          }
          FilterOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new FilterSubscriber(subscriber, this.predicate, this.thisArg));
          };
          return FilterOperator;
        }();
        var FilterSubscriber = /*@__PURE__*/function (_super) {
          tslib__WEBPACK_IMPORTED_MODULE_0__.__extends(FilterSubscriber, _super);
          function FilterSubscriber(destination, predicate, thisArg) {
            var _this = _super.call(this, destination) || this;
            _this.predicate = predicate;
            _this.thisArg = thisArg;
            _this.count = 0;
            return _this;
          }
          FilterSubscriber.prototype._next = function (value) {
            var result;
            try {
              result = this.predicate.call(this.thisArg, value, this.count++);
            } catch (err) {
              this.destination.error(err);
              return;
            }
            if (result) {
              this.destination.next(value);
            }
          };
          return FilterSubscriber;
        }(_Subscriber__WEBPACK_IMPORTED_MODULE_1__.Subscriber);
        //# sourceMappingURL=filter.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/operators/map.js": (
      /*!***********************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/operators/map.js ***!
        \***********************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"map": function () {
            return /* binding */map;
          },
          /* harmony export */"MapOperator": function () {
            return /* binding */MapOperator;
          }
          /* harmony export */
        });
        /* harmony import */
        var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */"./node_modules/tslib/tslib.es6.js");
        /* harmony import */
        var _Subscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscriber */"./node_modules/rxjs/_esm5/internal/Subscriber.js");
        /** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */

        function map(project, thisArg) {
          return function mapOperation(source) {
            if (typeof project !== 'function') {
              throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
            }
            return source.lift(new MapOperator(project, thisArg));
          };
        }
        var MapOperator = /*@__PURE__*/function () {
          function MapOperator(project, thisArg) {
            this.project = project;
            this.thisArg = thisArg;
          }
          MapOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
          };
          return MapOperator;
        }();
        var MapSubscriber = /*@__PURE__*/function (_super) {
          tslib__WEBPACK_IMPORTED_MODULE_0__.__extends(MapSubscriber, _super);
          function MapSubscriber(destination, project, thisArg) {
            var _this = _super.call(this, destination) || this;
            _this.project = project;
            _this.count = 0;
            _this.thisArg = thisArg || _this;
            return _this;
          }
          MapSubscriber.prototype._next = function (value) {
            var result;
            try {
              result = this.project.call(this.thisArg, value, this.count++);
            } catch (err) {
              this.destination.error(err);
              return;
            }
            this.destination.next(result);
          };
          return MapSubscriber;
        }(_Subscriber__WEBPACK_IMPORTED_MODULE_1__.Subscriber);
        //# sourceMappingURL=map.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/operators/mergeMap.js": (
      /*!****************************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/operators/mergeMap.js ***!
        \****************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"mergeMap": function () {
            return /* binding */mergeMap;
          },
          /* harmony export */"MergeMapOperator": function () {
            return /* binding */MergeMapOperator;
          },
          /* harmony export */"MergeMapSubscriber": function () {
            return /* binding */MergeMapSubscriber;
          },
          /* harmony export */"flatMap": function () {
            return /* binding */flatMap;
          }
          /* harmony export */
        });
        /* harmony import */
        var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! tslib */"./node_modules/tslib/tslib.es6.js");
        /* harmony import */
        var _map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./map */"./node_modules/rxjs/_esm5/internal/operators/map.js");
        /* harmony import */
        var _observable_from__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../observable/from */"./node_modules/rxjs/_esm5/internal/observable/from.js");
        /* harmony import */
        var _innerSubscribe__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../innerSubscribe */"./node_modules/rxjs/_esm5/internal/innerSubscribe.js");
        /** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */

        function mergeMap(project, resultSelector, concurrent) {
          if (concurrent === void 0) {
            concurrent = Number.POSITIVE_INFINITY;
          }
          if (typeof resultSelector === 'function') {
            return function (source) {
              return source.pipe(mergeMap(function (a, i) {
                return (0, _observable_from__WEBPACK_IMPORTED_MODULE_0__.from)(project(a, i)).pipe((0, _map__WEBPACK_IMPORTED_MODULE_1__.map)(function (b, ii) {
                  return resultSelector(a, b, i, ii);
                }));
              }, concurrent));
            };
          } else if (typeof resultSelector === 'number') {
            concurrent = resultSelector;
          }
          return function (source) {
            return source.lift(new MergeMapOperator(project, concurrent));
          };
        }
        var MergeMapOperator = /*@__PURE__*/function () {
          function MergeMapOperator(project, concurrent) {
            if (concurrent === void 0) {
              concurrent = Number.POSITIVE_INFINITY;
            }
            this.project = project;
            this.concurrent = concurrent;
          }
          MergeMapOperator.prototype.call = function (observer, source) {
            return source.subscribe(new MergeMapSubscriber(observer, this.project, this.concurrent));
          };
          return MergeMapOperator;
        }();
        var MergeMapSubscriber = /*@__PURE__*/function (_super) {
          tslib__WEBPACK_IMPORTED_MODULE_2__.__extends(MergeMapSubscriber, _super);
          function MergeMapSubscriber(destination, project, concurrent) {
            if (concurrent === void 0) {
              concurrent = Number.POSITIVE_INFINITY;
            }
            var _this = _super.call(this, destination) || this;
            _this.project = project;
            _this.concurrent = concurrent;
            _this.hasCompleted = false;
            _this.buffer = [];
            _this.active = 0;
            _this.index = 0;
            return _this;
          }
          MergeMapSubscriber.prototype._next = function (value) {
            if (this.active < this.concurrent) {
              this._tryNext(value);
            } else {
              this.buffer.push(value);
            }
          };
          MergeMapSubscriber.prototype._tryNext = function (value) {
            var result;
            var index = this.index++;
            try {
              result = this.project(value, index);
            } catch (err) {
              this.destination.error(err);
              return;
            }
            this.active++;
            this._innerSub(result);
          };
          MergeMapSubscriber.prototype._innerSub = function (ish) {
            var innerSubscriber = new _innerSubscribe__WEBPACK_IMPORTED_MODULE_3__.SimpleInnerSubscriber(this);
            var destination = this.destination;
            destination.add(innerSubscriber);
            var innerSubscription = (0, _innerSubscribe__WEBPACK_IMPORTED_MODULE_3__.innerSubscribe)(ish, innerSubscriber);
            if (innerSubscription !== innerSubscriber) {
              destination.add(innerSubscription);
            }
          };
          MergeMapSubscriber.prototype._complete = function () {
            this.hasCompleted = true;
            if (this.active === 0 && this.buffer.length === 0) {
              this.destination.complete();
            }
            this.unsubscribe();
          };
          MergeMapSubscriber.prototype.notifyNext = function (innerValue) {
            this.destination.next(innerValue);
          };
          MergeMapSubscriber.prototype.notifyComplete = function () {
            var buffer = this.buffer;
            this.active--;
            if (buffer.length > 0) {
              this._next(buffer.shift());
            } else if (this.active === 0 && this.hasCompleted) {
              this.destination.complete();
            }
          };
          return MergeMapSubscriber;
        }(_innerSubscribe__WEBPACK_IMPORTED_MODULE_3__.SimpleOuterSubscriber);
        var flatMap = mergeMap;
        //# sourceMappingURL=mergeMap.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/operators/tap.js": (
      /*!***********************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/operators/tap.js ***!
        \***********************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"tap": function () {
            return /* binding */tap;
          }
          /* harmony export */
        });
        /* harmony import */
        var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */"./node_modules/tslib/tslib.es6.js");
        /* harmony import */
        var _Subscriber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Subscriber */"./node_modules/rxjs/_esm5/internal/Subscriber.js");
        /* harmony import */
        var _util_noop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/noop */"./node_modules/rxjs/_esm5/internal/util/noop.js");
        /* harmony import */
        var _util_isFunction__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/isFunction */"./node_modules/rxjs/_esm5/internal/util/isFunction.js");
        /** PURE_IMPORTS_START tslib,_Subscriber,_util_noop,_util_isFunction PURE_IMPORTS_END */

        function tap(nextOrObserver, error, complete) {
          return function tapOperatorFunction(source) {
            return source.lift(new DoOperator(nextOrObserver, error, complete));
          };
        }
        var DoOperator = /*@__PURE__*/function () {
          function DoOperator(nextOrObserver, error, complete) {
            this.nextOrObserver = nextOrObserver;
            this.error = error;
            this.complete = complete;
          }
          DoOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new TapSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
          };
          return DoOperator;
        }();
        var TapSubscriber = /*@__PURE__*/function (_super) {
          tslib__WEBPACK_IMPORTED_MODULE_0__.__extends(TapSubscriber, _super);
          function TapSubscriber(destination, observerOrNext, error, complete) {
            var _this = _super.call(this, destination) || this;
            _this._tapNext = _util_noop__WEBPACK_IMPORTED_MODULE_1__.noop;
            _this._tapError = _util_noop__WEBPACK_IMPORTED_MODULE_1__.noop;
            _this._tapComplete = _util_noop__WEBPACK_IMPORTED_MODULE_1__.noop;
            _this._tapError = error || _util_noop__WEBPACK_IMPORTED_MODULE_1__.noop;
            _this._tapComplete = complete || _util_noop__WEBPACK_IMPORTED_MODULE_1__.noop;
            if ((0, _util_isFunction__WEBPACK_IMPORTED_MODULE_2__.isFunction)(observerOrNext)) {
              _this._context = _this;
              _this._tapNext = observerOrNext;
            } else if (observerOrNext) {
              _this._context = observerOrNext;
              _this._tapNext = observerOrNext.next || _util_noop__WEBPACK_IMPORTED_MODULE_1__.noop;
              _this._tapError = observerOrNext.error || _util_noop__WEBPACK_IMPORTED_MODULE_1__.noop;
              _this._tapComplete = observerOrNext.complete || _util_noop__WEBPACK_IMPORTED_MODULE_1__.noop;
            }
            return _this;
          }
          TapSubscriber.prototype._next = function (value) {
            try {
              this._tapNext.call(this._context, value);
            } catch (err) {
              this.destination.error(err);
              return;
            }
            this.destination.next(value);
          };
          TapSubscriber.prototype._error = function (err) {
            try {
              this._tapError.call(this._context, err);
            } catch (err) {
              this.destination.error(err);
              return;
            }
            this.destination.error(err);
          };
          TapSubscriber.prototype._complete = function () {
            try {
              this._tapComplete.call(this._context);
            } catch (err) {
              this.destination.error(err);
              return;
            }
            return this.destination.complete();
          };
          return TapSubscriber;
        }(_Subscriber__WEBPACK_IMPORTED_MODULE_3__.Subscriber);
        //# sourceMappingURL=tap.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/scheduled/scheduleArray.js": (
      /*!*********************************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/scheduled/scheduleArray.js ***!
        \*********************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"scheduleArray": function () {
            return /* binding */scheduleArray;
          }
          /* harmony export */
        });
        /* harmony import */
        var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */"./node_modules/rxjs/_esm5/internal/Observable.js");
        /* harmony import */
        var _Subscription__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscription */"./node_modules/rxjs/_esm5/internal/Subscription.js");
        /** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */

        function scheduleArray(input, scheduler) {
          return new _Observable__WEBPACK_IMPORTED_MODULE_0__.Observable(function (subscriber) {
            var sub = new _Subscription__WEBPACK_IMPORTED_MODULE_1__.Subscription();
            var i = 0;
            sub.add(scheduler.schedule(function () {
              if (i === input.length) {
                subscriber.complete();
                return;
              }
              subscriber.next(input[i++]);
              if (!subscriber.closed) {
                sub.add(this.schedule());
              }
            }));
            return sub;
          });
        }
        //# sourceMappingURL=scheduleArray.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/scheduled/scheduleIterable.js": (
      /*!************************************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/scheduled/scheduleIterable.js ***!
        \************************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"scheduleIterable": function () {
            return /* binding */scheduleIterable;
          }
          /* harmony export */
        });
        /* harmony import */
        var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */"./node_modules/rxjs/_esm5/internal/Observable.js");
        /* harmony import */
        var _Subscription__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscription */"./node_modules/rxjs/_esm5/internal/Subscription.js");
        /* harmony import */
        var _symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../symbol/iterator */"./node_modules/rxjs/_esm5/internal/symbol/iterator.js");
        /** PURE_IMPORTS_START _Observable,_Subscription,_symbol_iterator PURE_IMPORTS_END */

        function scheduleIterable(input, scheduler) {
          if (!input) {
            throw new Error('Iterable cannot be null');
          }
          return new _Observable__WEBPACK_IMPORTED_MODULE_0__.Observable(function (subscriber) {
            var sub = new _Subscription__WEBPACK_IMPORTED_MODULE_1__.Subscription();
            var iterator;
            sub.add(function () {
              if (iterator && typeof iterator.return === 'function') {
                iterator.return();
              }
            });
            sub.add(scheduler.schedule(function () {
              iterator = input[_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__.iterator]();
              sub.add(scheduler.schedule(function () {
                if (subscriber.closed) {
                  return;
                }
                var value;
                var done;
                try {
                  var result = iterator.next();
                  value = result.value;
                  done = result.done;
                } catch (err) {
                  subscriber.error(err);
                  return;
                }
                if (done) {
                  subscriber.complete();
                } else {
                  subscriber.next(value);
                  this.schedule();
                }
              }));
            }));
            return sub;
          });
        }
        //# sourceMappingURL=scheduleIterable.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/scheduled/scheduleObservable.js": (
      /*!**************************************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/scheduled/scheduleObservable.js ***!
        \**************************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"scheduleObservable": function () {
            return /* binding */scheduleObservable;
          }
          /* harmony export */
        });
        /* harmony import */
        var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */"./node_modules/rxjs/_esm5/internal/Observable.js");
        /* harmony import */
        var _Subscription__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscription */"./node_modules/rxjs/_esm5/internal/Subscription.js");
        /* harmony import */
        var _symbol_observable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../symbol/observable */"./node_modules/rxjs/_esm5/internal/symbol/observable.js");
        /** PURE_IMPORTS_START _Observable,_Subscription,_symbol_observable PURE_IMPORTS_END */

        function scheduleObservable(input, scheduler) {
          return new _Observable__WEBPACK_IMPORTED_MODULE_0__.Observable(function (subscriber) {
            var sub = new _Subscription__WEBPACK_IMPORTED_MODULE_1__.Subscription();
            sub.add(scheduler.schedule(function () {
              var observable = input[_symbol_observable__WEBPACK_IMPORTED_MODULE_2__.observable]();
              sub.add(observable.subscribe({
                next: function (value) {
                  sub.add(scheduler.schedule(function () {
                    return subscriber.next(value);
                  }));
                },
                error: function (err) {
                  sub.add(scheduler.schedule(function () {
                    return subscriber.error(err);
                  }));
                },
                complete: function () {
                  sub.add(scheduler.schedule(function () {
                    return subscriber.complete();
                  }));
                }
              }));
            }));
            return sub;
          });
        }
        //# sourceMappingURL=scheduleObservable.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/scheduled/schedulePromise.js": (
      /*!***********************************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/scheduled/schedulePromise.js ***!
        \***********************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"schedulePromise": function () {
            return /* binding */schedulePromise;
          }
          /* harmony export */
        });
        /* harmony import */
        var _Observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Observable */"./node_modules/rxjs/_esm5/internal/Observable.js");
        /* harmony import */
        var _Subscription__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Subscription */"./node_modules/rxjs/_esm5/internal/Subscription.js");
        /** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */

        function schedulePromise(input, scheduler) {
          return new _Observable__WEBPACK_IMPORTED_MODULE_0__.Observable(function (subscriber) {
            var sub = new _Subscription__WEBPACK_IMPORTED_MODULE_1__.Subscription();
            sub.add(scheduler.schedule(function () {
              return input.then(function (value) {
                sub.add(scheduler.schedule(function () {
                  subscriber.next(value);
                  sub.add(scheduler.schedule(function () {
                    return subscriber.complete();
                  }));
                }));
              }, function (err) {
                sub.add(scheduler.schedule(function () {
                  return subscriber.error(err);
                }));
              });
            }));
            return sub;
          });
        }
        //# sourceMappingURL=schedulePromise.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/scheduled/scheduled.js": (
      /*!*****************************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/scheduled/scheduled.js ***!
        \*****************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"scheduled": function () {
            return /* binding */scheduled;
          }
          /* harmony export */
        });
        /* harmony import */
        var _scheduleObservable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./scheduleObservable */"./node_modules/rxjs/_esm5/internal/scheduled/scheduleObservable.js");
        /* harmony import */
        var _schedulePromise__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./schedulePromise */"./node_modules/rxjs/_esm5/internal/scheduled/schedulePromise.js");
        /* harmony import */
        var _scheduleArray__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./scheduleArray */"./node_modules/rxjs/_esm5/internal/scheduled/scheduleArray.js");
        /* harmony import */
        var _scheduleIterable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./scheduleIterable */"./node_modules/rxjs/_esm5/internal/scheduled/scheduleIterable.js");
        /* harmony import */
        var _util_isInteropObservable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/isInteropObservable */"./node_modules/rxjs/_esm5/internal/util/isInteropObservable.js");
        /* harmony import */
        var _util_isPromise__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/isPromise */"./node_modules/rxjs/_esm5/internal/util/isPromise.js");
        /* harmony import */
        var _util_isArrayLike__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../util/isArrayLike */"./node_modules/rxjs/_esm5/internal/util/isArrayLike.js");
        /* harmony import */
        var _util_isIterable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../util/isIterable */"./node_modules/rxjs/_esm5/internal/util/isIterable.js");
        /** PURE_IMPORTS_START _scheduleObservable,_schedulePromise,_scheduleArray,_scheduleIterable,_util_isInteropObservable,_util_isPromise,_util_isArrayLike,_util_isIterable PURE_IMPORTS_END */

        function scheduled(input, scheduler) {
          if (input != null) {
            if ((0, _util_isInteropObservable__WEBPACK_IMPORTED_MODULE_0__.isInteropObservable)(input)) {
              return (0, _scheduleObservable__WEBPACK_IMPORTED_MODULE_1__.scheduleObservable)(input, scheduler);
            } else if ((0, _util_isPromise__WEBPACK_IMPORTED_MODULE_2__.isPromise)(input)) {
              return (0, _schedulePromise__WEBPACK_IMPORTED_MODULE_3__.schedulePromise)(input, scheduler);
            } else if ((0, _util_isArrayLike__WEBPACK_IMPORTED_MODULE_4__.isArrayLike)(input)) {
              return (0, _scheduleArray__WEBPACK_IMPORTED_MODULE_5__.scheduleArray)(input, scheduler);
            } else if ((0, _util_isIterable__WEBPACK_IMPORTED_MODULE_6__.isIterable)(input) || typeof input === 'string') {
              return (0, _scheduleIterable__WEBPACK_IMPORTED_MODULE_7__.scheduleIterable)(input, scheduler);
            }
          }
          throw new TypeError((input !== null && typeof input || input) + ' is not observable');
        }
        //# sourceMappingURL=scheduled.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/symbol/iterator.js": (
      /*!*************************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/symbol/iterator.js ***!
        \*************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"getSymbolIterator": function () {
            return /* binding */getSymbolIterator;
          },
          /* harmony export */"iterator": function () {
            return /* binding */iterator;
          },
          /* harmony export */"$$iterator": function () {
            return /* binding */$$iterator;
          }
          /* harmony export */
        });
        /** PURE_IMPORTS_START  PURE_IMPORTS_END */
        function getSymbolIterator() {
          if (typeof Symbol !== 'function' || !Symbol.iterator) {
            return '@@iterator';
          }
          return Symbol.iterator;
        }
        var iterator = /*@__PURE__*/getSymbolIterator();
        var $$iterator = iterator;
        //# sourceMappingURL=iterator.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/symbol/observable.js": (
      /*!***************************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/symbol/observable.js ***!
        \***************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"observable": function () {
            return /* binding */observable;
          }
          /* harmony export */
        });
        /** PURE_IMPORTS_START  PURE_IMPORTS_END */
        var observable = /*@__PURE__*/function () {
          return typeof Symbol === 'function' && Symbol.observable || '@@observable';
        }();
        //# sourceMappingURL=observable.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/symbol/rxSubscriber.js": (
      /*!*****************************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/symbol/rxSubscriber.js ***!
        \*****************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"rxSubscriber": function () {
            return /* binding */rxSubscriber;
          },
          /* harmony export */"$$rxSubscriber": function () {
            return /* binding */$$rxSubscriber;
          }
          /* harmony export */
        });
        /** PURE_IMPORTS_START  PURE_IMPORTS_END */
        var rxSubscriber = /*@__PURE__*/function () {
          return typeof Symbol === 'function' ? /*@__PURE__*/Symbol('rxSubscriber') : '@@rxSubscriber_' + /*@__PURE__*/Math.random();
        }();
        var $$rxSubscriber = rxSubscriber;
        //# sourceMappingURL=rxSubscriber.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/util/UnsubscriptionError.js": (
      /*!**********************************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/util/UnsubscriptionError.js ***!
        \**********************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"UnsubscriptionError": function () {
            return /* binding */UnsubscriptionError;
          }
          /* harmony export */
        });
        /** PURE_IMPORTS_START  PURE_IMPORTS_END */
        var UnsubscriptionErrorImpl = /*@__PURE__*/function () {
          function UnsubscriptionErrorImpl(errors) {
            Error.call(this);
            this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function (err, i) {
              return i + 1 + ") " + err.toString();
            }).join('\n  ') : '';
            this.name = 'UnsubscriptionError';
            this.errors = errors;
            return this;
          }
          UnsubscriptionErrorImpl.prototype = /*@__PURE__*/Object.create(Error.prototype);
          return UnsubscriptionErrorImpl;
        }();
        var UnsubscriptionError = UnsubscriptionErrorImpl;
        //# sourceMappingURL=UnsubscriptionError.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/util/canReportError.js": (
      /*!*****************************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/util/canReportError.js ***!
        \*****************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"canReportError": function () {
            return /* binding */canReportError;
          }
          /* harmony export */
        });
        /* harmony import */
        var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */"./node_modules/rxjs/_esm5/internal/Subscriber.js");
        /** PURE_IMPORTS_START _Subscriber PURE_IMPORTS_END */

        function canReportError(observer) {
          while (observer) {
            var _a = observer,
              closed_1 = _a.closed,
              destination = _a.destination,
              isStopped = _a.isStopped;
            if (closed_1 || isStopped) {
              return false;
            } else if (destination && destination instanceof _Subscriber__WEBPACK_IMPORTED_MODULE_0__.Subscriber) {
              observer = destination;
            } else {
              observer = null;
            }
          }
          return true;
        }
        //# sourceMappingURL=canReportError.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/util/hostReportError.js": (
      /*!******************************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/util/hostReportError.js ***!
        \******************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"hostReportError": function () {
            return /* binding */hostReportError;
          }
          /* harmony export */
        });
        /** PURE_IMPORTS_START  PURE_IMPORTS_END */
        function hostReportError(err) {
          setTimeout(function () {
            throw err;
          }, 0);
        }
        //# sourceMappingURL=hostReportError.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/util/identity.js": (
      /*!***********************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/util/identity.js ***!
        \***********************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"identity": function () {
            return /* binding */identity;
          }
          /* harmony export */
        });
        /** PURE_IMPORTS_START  PURE_IMPORTS_END */
        function identity(x) {
          return x;
        }
        //# sourceMappingURL=identity.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/util/isArray.js": (
      /*!**********************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/util/isArray.js ***!
        \**********************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"isArray": function () {
            return /* binding */isArray;
          }
          /* harmony export */
        });
        /** PURE_IMPORTS_START  PURE_IMPORTS_END */
        var isArray = /*@__PURE__*/function () {
          return Array.isArray || function (x) {
            return x && typeof x.length === 'number';
          };
        }();
        //# sourceMappingURL=isArray.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/util/isArrayLike.js": (
      /*!**************************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/util/isArrayLike.js ***!
        \**************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"isArrayLike": function () {
            return /* binding */isArrayLike;
          }
          /* harmony export */
        });
        /** PURE_IMPORTS_START  PURE_IMPORTS_END */
        var isArrayLike = function (x) {
          return x && typeof x.length === 'number' && typeof x !== 'function';
        };
        //# sourceMappingURL=isArrayLike.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/util/isFunction.js": (
      /*!*************************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/util/isFunction.js ***!
        \*************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"isFunction": function () {
            return /* binding */isFunction;
          }
          /* harmony export */
        });
        /** PURE_IMPORTS_START  PURE_IMPORTS_END */
        function isFunction(x) {
          return typeof x === 'function';
        }
        //# sourceMappingURL=isFunction.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/util/isInteropObservable.js": (
      /*!**********************************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/util/isInteropObservable.js ***!
        \**********************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"isInteropObservable": function () {
            return /* binding */isInteropObservable;
          }
          /* harmony export */
        });
        /* harmony import */
        var _symbol_observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../symbol/observable */"./node_modules/rxjs/_esm5/internal/symbol/observable.js");
        /** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */

        function isInteropObservable(input) {
          return input && typeof input[_symbol_observable__WEBPACK_IMPORTED_MODULE_0__.observable] === 'function';
        }
        //# sourceMappingURL=isInteropObservable.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/util/isIterable.js": (
      /*!*************************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/util/isIterable.js ***!
        \*************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"isIterable": function () {
            return /* binding */isIterable;
          }
          /* harmony export */
        });
        /* harmony import */
        var _symbol_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../symbol/iterator */"./node_modules/rxjs/_esm5/internal/symbol/iterator.js");
        /** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */

        function isIterable(input) {
          return input && typeof input[_symbol_iterator__WEBPACK_IMPORTED_MODULE_0__.iterator] === 'function';
        }
        //# sourceMappingURL=isIterable.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/util/isObject.js": (
      /*!***********************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/util/isObject.js ***!
        \***********************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"isObject": function () {
            return /* binding */isObject;
          }
          /* harmony export */
        });
        /** PURE_IMPORTS_START  PURE_IMPORTS_END */
        function isObject(x) {
          return x !== null && typeof x === 'object';
        }
        //# sourceMappingURL=isObject.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/util/isPromise.js": (
      /*!************************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/util/isPromise.js ***!
        \************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"isPromise": function () {
            return /* binding */isPromise;
          }
          /* harmony export */
        });
        /** PURE_IMPORTS_START  PURE_IMPORTS_END */
        function isPromise(value) {
          return !!value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
        }
        //# sourceMappingURL=isPromise.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/util/noop.js": (
      /*!*******************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/util/noop.js ***!
        \*******************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"noop": function () {
            return /* binding */noop;
          }
          /* harmony export */
        });
        /** PURE_IMPORTS_START  PURE_IMPORTS_END */
        function noop() {}
        //# sourceMappingURL=noop.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/util/pipe.js": (
      /*!*******************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/util/pipe.js ***!
        \*******************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"pipe": function () {
            return /* binding */pipe;
          },
          /* harmony export */"pipeFromArray": function () {
            return /* binding */pipeFromArray;
          }
          /* harmony export */
        });
        /* harmony import */
        var _identity__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./identity */"./node_modules/rxjs/_esm5/internal/util/identity.js");
        /** PURE_IMPORTS_START _identity PURE_IMPORTS_END */

        function pipe() {
          var fns = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            fns[_i] = arguments[_i];
          }
          return pipeFromArray(fns);
        }
        function pipeFromArray(fns) {
          if (fns.length === 0) {
            return _identity__WEBPACK_IMPORTED_MODULE_0__.identity;
          }
          if (fns.length === 1) {
            return fns[0];
          }
          return function piped(input) {
            return fns.reduce(function (prev, fn) {
              return fn(prev);
            }, input);
          };
        }
        //# sourceMappingURL=pipe.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/util/subscribeTo.js": (
      /*!**************************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/util/subscribeTo.js ***!
        \**************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"subscribeTo": function () {
            return /* binding */subscribeTo;
          }
          /* harmony export */
        });
        /* harmony import */
        var _subscribeToArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./subscribeToArray */"./node_modules/rxjs/_esm5/internal/util/subscribeToArray.js");
        /* harmony import */
        var _subscribeToPromise__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./subscribeToPromise */"./node_modules/rxjs/_esm5/internal/util/subscribeToPromise.js");
        /* harmony import */
        var _subscribeToIterable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./subscribeToIterable */"./node_modules/rxjs/_esm5/internal/util/subscribeToIterable.js");
        /* harmony import */
        var _subscribeToObservable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./subscribeToObservable */"./node_modules/rxjs/_esm5/internal/util/subscribeToObservable.js");
        /* harmony import */
        var _isArrayLike__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./isArrayLike */"./node_modules/rxjs/_esm5/internal/util/isArrayLike.js");
        /* harmony import */
        var _isPromise__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./isPromise */"./node_modules/rxjs/_esm5/internal/util/isPromise.js");
        /* harmony import */
        var _isObject__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./isObject */"./node_modules/rxjs/_esm5/internal/util/isObject.js");
        /* harmony import */
        var _symbol_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../symbol/iterator */"./node_modules/rxjs/_esm5/internal/symbol/iterator.js");
        /* harmony import */
        var _symbol_observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../symbol/observable */"./node_modules/rxjs/_esm5/internal/symbol/observable.js");
        /** PURE_IMPORTS_START _subscribeToArray,_subscribeToPromise,_subscribeToIterable,_subscribeToObservable,_isArrayLike,_isPromise,_isObject,_symbol_iterator,_symbol_observable PURE_IMPORTS_END */

        var subscribeTo = function (result) {
          if (!!result && typeof result[_symbol_observable__WEBPACK_IMPORTED_MODULE_0__.observable] === 'function') {
            return (0, _subscribeToObservable__WEBPACK_IMPORTED_MODULE_1__.subscribeToObservable)(result);
          } else if ((0, _isArrayLike__WEBPACK_IMPORTED_MODULE_2__.isArrayLike)(result)) {
            return (0, _subscribeToArray__WEBPACK_IMPORTED_MODULE_3__.subscribeToArray)(result);
          } else if ((0, _isPromise__WEBPACK_IMPORTED_MODULE_4__.isPromise)(result)) {
            return (0, _subscribeToPromise__WEBPACK_IMPORTED_MODULE_5__.subscribeToPromise)(result);
          } else if (!!result && typeof result[_symbol_iterator__WEBPACK_IMPORTED_MODULE_6__.iterator] === 'function') {
            return (0, _subscribeToIterable__WEBPACK_IMPORTED_MODULE_7__.subscribeToIterable)(result);
          } else {
            var value = (0, _isObject__WEBPACK_IMPORTED_MODULE_8__.isObject)(result) ? 'an invalid object' : "'" + result + "'";
            var msg = "You provided " + value + " where a stream was expected." + ' You can provide an Observable, Promise, Array, or Iterable.';
            throw new TypeError(msg);
          }
        };
        //# sourceMappingURL=subscribeTo.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/util/subscribeToArray.js": (
      /*!*******************************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/util/subscribeToArray.js ***!
        \*******************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"subscribeToArray": function () {
            return /* binding */subscribeToArray;
          }
          /* harmony export */
        });
        /** PURE_IMPORTS_START  PURE_IMPORTS_END */
        var subscribeToArray = function (array) {
          return function (subscriber) {
            for (var i = 0, len = array.length; i < len && !subscriber.closed; i++) {
              subscriber.next(array[i]);
            }
            subscriber.complete();
          };
        };
        //# sourceMappingURL=subscribeToArray.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/util/subscribeToIterable.js": (
      /*!**********************************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/util/subscribeToIterable.js ***!
        \**********************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"subscribeToIterable": function () {
            return /* binding */subscribeToIterable;
          }
          /* harmony export */
        });
        /* harmony import */
        var _symbol_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../symbol/iterator */"./node_modules/rxjs/_esm5/internal/symbol/iterator.js");
        /** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */

        var subscribeToIterable = function (iterable) {
          return function (subscriber) {
            var iterator = iterable[_symbol_iterator__WEBPACK_IMPORTED_MODULE_0__.iterator]();
            do {
              var item = void 0;
              try {
                item = iterator.next();
              } catch (err) {
                subscriber.error(err);
                return subscriber;
              }
              if (item.done) {
                subscriber.complete();
                break;
              }
              subscriber.next(item.value);
              if (subscriber.closed) {
                break;
              }
            } while (true);
            if (typeof iterator.return === 'function') {
              subscriber.add(function () {
                if (iterator.return) {
                  iterator.return();
                }
              });
            }
            return subscriber;
          };
        };
        //# sourceMappingURL=subscribeToIterable.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/util/subscribeToObservable.js": (
      /*!************************************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/util/subscribeToObservable.js ***!
        \************************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"subscribeToObservable": function () {
            return /* binding */subscribeToObservable;
          }
          /* harmony export */
        });
        /* harmony import */
        var _symbol_observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../symbol/observable */"./node_modules/rxjs/_esm5/internal/symbol/observable.js");
        /** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */

        var subscribeToObservable = function (obj) {
          return function (subscriber) {
            var obs = obj[_symbol_observable__WEBPACK_IMPORTED_MODULE_0__.observable]();
            if (typeof obs.subscribe !== 'function') {
              throw new TypeError('Provided object does not correctly implement Symbol.observable');
            } else {
              return obs.subscribe(subscriber);
            }
          };
        };
        //# sourceMappingURL=subscribeToObservable.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/util/subscribeToPromise.js": (
      /*!*********************************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/util/subscribeToPromise.js ***!
        \*********************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"subscribeToPromise": function () {
            return /* binding */subscribeToPromise;
          }
          /* harmony export */
        });
        /* harmony import */
        var _hostReportError__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./hostReportError */"./node_modules/rxjs/_esm5/internal/util/hostReportError.js");
        /** PURE_IMPORTS_START _hostReportError PURE_IMPORTS_END */

        var subscribeToPromise = function (promise) {
          return function (subscriber) {
            promise.then(function (value) {
              if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
              }
            }, function (err) {
              return subscriber.error(err);
            }).then(null, _hostReportError__WEBPACK_IMPORTED_MODULE_0__.hostReportError);
            return subscriber;
          };
        };
        //# sourceMappingURL=subscribeToPromise.js.map

        /***/
      }),
      /***/"./node_modules/rxjs/_esm5/internal/util/toSubscriber.js": (
      /*!***************************************************************!*\
        !*** ./node_modules/rxjs/_esm5/internal/util/toSubscriber.js ***!
        \***************************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"toSubscriber": function () {
            return /* binding */toSubscriber;
          }
          /* harmony export */
        });
        /* harmony import */
        var _Subscriber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Subscriber */"./node_modules/rxjs/_esm5/internal/Subscriber.js");
        /* harmony import */
        var _symbol_rxSubscriber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../symbol/rxSubscriber */"./node_modules/rxjs/_esm5/internal/symbol/rxSubscriber.js");
        /* harmony import */
        var _Observer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Observer */"./node_modules/rxjs/_esm5/internal/Observer.js");
        /** PURE_IMPORTS_START _Subscriber,_symbol_rxSubscriber,_Observer PURE_IMPORTS_END */

        function toSubscriber(nextOrObserver, error, complete) {
          if (nextOrObserver) {
            if (nextOrObserver instanceof _Subscriber__WEBPACK_IMPORTED_MODULE_0__.Subscriber) {
              return nextOrObserver;
            }
            if (nextOrObserver[_symbol_rxSubscriber__WEBPACK_IMPORTED_MODULE_1__.rxSubscriber]) {
              return nextOrObserver[_symbol_rxSubscriber__WEBPACK_IMPORTED_MODULE_1__.rxSubscriber]();
            }
          }
          if (!nextOrObserver && !error && !complete) {
            return new _Subscriber__WEBPACK_IMPORTED_MODULE_0__.Subscriber(_Observer__WEBPACK_IMPORTED_MODULE_2__.empty);
          }
          return new _Subscriber__WEBPACK_IMPORTED_MODULE_0__.Subscriber(nextOrObserver, error, complete);
        }
        //# sourceMappingURL=toSubscriber.js.map

        /***/
      }),
      /***/"./src/builders/inputFilter.ts": (
      /*!*************************************!*\
        !*** ./src/builders/inputFilter.ts ***!
        \*************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"MASK": function () {
            return /* binding */MASK;
          },
          /* harmony export */"filtrerInput": function () {
            return /* binding */filtrerInput;
          }
          /* harmony export */
        });
        var __spreadArray = undefined && undefined.__spreadArray || function (to, from, pack) {
          if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
              if (!ar) ar = Array.prototype.slice.call(from, 0, i);
              ar[i] = from[i];
            }
          }
          return to.concat(ar || Array.prototype.slice.call(from));
        };
        var filtresDefaut = [/motPasse/, /compteBancaire/, /code/];
        var MASK = '*****';
        function filtrerInput(input, filtresAdditionnels) {
          if (filtresAdditionnels === void 0) {
            filtresAdditionnels = [];
          }
          var newInput = input == null ? input : JSON.parse(JSON.stringify(input));
          var filtres = __spreadArray(__spreadArray([], filtresDefaut, true), filtresAdditionnels.map(function (f) {
            return new RegExp(f);
          }), true);
          cleanObject(newInput, filtres);
          return newInput;
        }
        function cleanObject(obj, filters) {
          if (typeof obj === 'object' && obj != null) {
            Object.keys(obj).forEach(function (key) {
              if (typeof obj[key] === 'object' && obj[key] !== null) {
                cleanObject(obj[key], filters);
              } else {
                if (filters.some(function (regexp) {
                  return regexp.test(key);
                })) {
                  obj[key] = MASK;
                }
              }
            });
          }
        }

        /***/
      }),
      /***/"./src/builders/messageBuilder.ts": (
      /*!****************************************!*\
        !*** ./src/builders/messageBuilder.ts ***!
        \****************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"HEADER_X_SOURCE": function () {
            return /* binding */HEADER_X_SOURCE;
          },
          /* harmony export */"HEADER_TRACKER_ID": function () {
            return /* binding */HEADER_TRACKER_ID;
          },
          /* harmony export */"HEADER_X_REQUEST_ID": function () {
            return /* binding */HEADER_X_REQUEST_ID;
          },
          /* harmony export */"HEADER_X_ACTION_ID": function () {
            return /* binding */HEADER_X_ACTION_ID;
          },
          /* harmony export */"HEADER_X_MESSAGE_ID": function () {
            return /* binding */HEADER_X_MESSAGE_ID;
          },
          /* harmony export */"DATE_FORMAT_PRISME": function () {
            return /* binding */DATE_FORMAT_PRISME;
          },
          /* harmony export */"HEADER_REQUEST_TIME": function () {
            return /* binding */HEADER_REQUEST_TIME;
          },
          /* harmony export */"construireContexte": function () {
            return /* binding */construireContexte;
          },
          /* harmony export */"construireEvenement": function () {
            return /* binding */construireEvenement;
          },
          /* harmony export */"construireExecAppelRest": function () {
            return /* binding */construireExecAppelRest;
          },
          /* harmony export */"construireLog": function () {
            return /* binding */construireLog;
          },
          /* harmony export */"construireHeadersTracabilite": function () {
            return /* binding */construireHeadersTracabilite;
          }
          /* harmony export */
        });
        /* harmony import */
        var date_fns__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! date-fns */"./node_modules/date-fns/esm/format/index.js");
        /* harmony import */
        var urijs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! urijs */"./node_modules/urijs/src/URI.js");
        /* harmony import */
        var urijs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */
        var _helpers_uuid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helpers/uuid */"./src/helpers/uuid.ts");
        /* harmony import */
        var _inputFilter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./inputFilter */"./src/builders/inputFilter.ts");
        /* harmony import */
        var _patternExtractor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./patternExtractor */"./src/builders/patternExtractor.ts");
        var __assign = undefined && undefined.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];
              for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
          };
          return __assign.apply(this, arguments);
        };
        var __rest = undefined && undefined.__rest || function (s, e) {
          var t = {};
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
          if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
          }
          return t;
        };
        var HEADER_X_SOURCE = 'X-Source';
        var HEADER_TRACKER_ID = 'trackerId';
        var HEADER_X_REQUEST_ID = 'X-Request-Id';
        var HEADER_X_ACTION_ID = 'X-Action-Id';
        var HEADER_X_MESSAGE_ID = 'X-Message-Id';
        var DATE_FORMAT_PRISME = "yyyy-MM-dd'T'HH:mm:ss.SSSXX";
        var HEADER_REQUEST_TIME = 'X-Request-Time';
        function construireContexte(prismeConfig, _a) {
          var _b, _c, _d, _e;
          var headers = _a.headers,
            erreur = _a.erreur,
            action = _a.action,
            specifiqueMetier = __rest(_a, ["headers", "erreur", "action"]);
          var ctx = __assign(__assign({
            requestId: getCaseInsensitive(headers, HEADER_X_REQUEST_ID) || (0, _helpers_uuid__WEBPACK_IMPORTED_MODULE_1__.uuid)(),
            actionId: getCaseInsensitive(headers, HEADER_X_ACTION_ID) || (0, _helpers_uuid__WEBPACK_IMPORTED_MODULE_1__.uuid)(),
            messageId: getCaseInsensitive(headers, HEADER_X_MESSAGE_ID) || (0, _helpers_uuid__WEBPACK_IMPORTED_MODULE_1__.uuid)(),
            source: getCaseInsensitive(headers, HEADER_X_SOURCE) || prismeConfig.st,
            trackerId: getCaseInsensitive(headers, HEADER_TRACKER_ID) || prismeConfig.getTrackerId(),
            location_origin: (_b = globalThis === null || globalThis === void 0 ? void 0 : globalThis.location) === null || _b === void 0 ? void 0 : _b.origin,
            location_pathname: (_c = globalThis === null || globalThis === void 0 ? void 0 : globalThis.location) === null || _c === void 0 ? void 0 : _c.pathname,
            location_href: (_d = globalThis === null || globalThis === void 0 ? void 0 : globalThis.location) === null || _d === void 0 ? void 0 : _d.href
          }, (_e = prismeConfig.userInfoProvider) === null || _e === void 0 ? void 0 : _e.call(prismeConfig)), specifiqueMetier);
          return ctx;
        }
        function construireEvenement(prismeConfig, currentTime, enErreur) {
          return {
            idEv: (0, _helpers_uuid__WEBPACK_IMPORTED_MODULE_1__.uuid)(),
            nom: "".concat(prismeConfig.st, "_Evenement"),
            date: (0, date_fns__WEBPACK_IMPORTED_MODULE_4__.default)(currentTime, DATE_FORMAT_PRISME),
            timestamp: currentTime,
            severite: enErreur ? 'ERROR' : 'INFO',
            priorite: enErreur ? '3' : '6',
            emetteur: 'LoggeurPrismeIHM'
          };
        }
        function construireExecAppelRest(prismeConfig, currentTime, headers, url, method, input, status, erreur) {
          var _a;
          var evenement = construireEvenement(prismeConfig, currentTime, !!erreur);
          var requestTime = headers[HEADER_REQUEST_TIME] ? parseInt(headers[HEADER_REQUEST_TIME]) : undefined;
          var nom = "APPELRS";
          var host;
          var port;
          var urlPattern;
          var pathname;
          if (url != null) {
            if (url.startsWith('http')) {
              var urlObj = urijs__WEBPACK_IMPORTED_MODULE_0__(url);
              host = urlObj.hostname();
              port = urlObj.port() ? parseInt(urlObj.port()) : undefined;
              pathname = urlObj.pathname();
            } else {
              host = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.origin;
              pathname = url;
            }
            urlPattern = (0, _patternExtractor__WEBPACK_IMPORTED_MODULE_3__.extrairePatternUrl)(url);
            var pathnamePattern = (0, _patternExtractor__WEBPACK_IMPORTED_MODULE_3__.extrairePatternUrl)(pathname);
            nom += "_".concat(pathnamePattern);
          }
          var inputFinal;
          if (!prismeConfig.disableInput) {
            var inputFinalObj = (0, _inputFilter__WEBPACK_IMPORTED_MODULE_2__.filtrerInput)(input, prismeConfig.filtresInputAdditionnels);
            inputFinal = inputFinalObj == null ? undefined : JSON.stringify(inputFinalObj).substring(0, 31990);
          }
          var execAppelRest = __assign(__assign({}, evenement), {
            typeEv: 'APPELRESS',
            nom: nom,
            debut: requestTime ? (0, date_fns__WEBPACK_IMPORTED_MODULE_4__.default)(requestTime, DATE_FORMAT_PRISME) : undefined,
            fin: (0, date_fns__WEBPACK_IMPORTED_MODULE_4__.default)(currentTime, DATE_FORMAT_PRISME),
            duree: requestTime ? currentTime - requestTime : undefined,
            enErreur: !!erreur,
            erreur: erreur,
            url: url,
            urlPattern: urlPattern,
            headers: masquerHeadersAuthentification(headers),
            host: host,
            port: port,
            httpMethod: method || 'get',
            httpStatus: status === null || status === void 0 ? void 0 : status.toString(),
            input: inputFinal
          });
          return execAppelRest;
        }
        function masquerHeadersAuthentification(headers) {
          var headersFinaux = __assign({}, headers);
          Object.keys(headers).forEach(function (key) {
            if (/authorization/i.test(key)) {
              headersFinaux[key] = headersFinaux[key].substring(0, 14) + '**HIDDEN**';
            }
          });
          return headersFinaux;
        }
        function construireLog(prismeConfig, currentTime, message, erreur, action) {
          var _a;
          var evenement = construireEvenement(prismeConfig, currentTime, !!erreur);
          var erreurFinale;
          if (erreur && erreur instanceof Error) {
            erreurFinale = {
              code: erreur.name,
              description: erreur.message,
              type: 'TECHNIQUE',
              declencheur: erreur.stack,
              origine: (_a = erreur.stack) === null || _a === void 0 ? void 0 : _a.split(/\n/)[0]
            };
          } else {
            erreurFinale = erreur;
          }
          return __assign(__assign({}, evenement), {
            typeEv: 'LOG',
            nom: "LOG",
            message: message,
            erreur: erreurFinale,
            action: action
          });
        }
        function construireHeadersTracabilite(prismeConfig, headersExistants) {
          var headers = headersExistants || {};
          if (!getCaseInsensitive(headers, HEADER_X_SOURCE)) headers[HEADER_X_SOURCE] = prismeConfig.st;
          if (!getCaseInsensitive(headers, HEADER_X_REQUEST_ID)) headers[HEADER_X_REQUEST_ID] = (0, _helpers_uuid__WEBPACK_IMPORTED_MODULE_1__.uuid)();
          if (!getCaseInsensitive(headers, HEADER_X_ACTION_ID)) headers[HEADER_X_ACTION_ID] = (0, _helpers_uuid__WEBPACK_IMPORTED_MODULE_1__.uuid)();
          if (!getCaseInsensitive(headers, HEADER_X_MESSAGE_ID)) headers[HEADER_X_MESSAGE_ID] = (0, _helpers_uuid__WEBPACK_IMPORTED_MODULE_1__.uuid)();
          if (!getCaseInsensitive(headers, HEADER_TRACKER_ID)) headers[HEADER_TRACKER_ID] = prismeConfig.getTrackerId();
          if (!getCaseInsensitive(headers, HEADER_REQUEST_TIME)) headers[HEADER_REQUEST_TIME] = Date.now().toString();
          return headers;
        }
        function getCaseInsensitive(obj, property) {
          return obj === null || obj === void 0 ? void 0 : obj[Object.keys(obj || {}).find(function (prop) {
            return prop.toLowerCase() === property.toLowerCase();
          }) || ''];
        }

        /***/
      }),
      /***/"./src/builders/patternExtractor.ts": (
      /*!******************************************!*\
        !*** ./src/builders/patternExtractor.ts ***!
        \******************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"extrairePatternUrl": function () {
            return /* binding */extrairePatternUrl;
          }
          /* harmony export */
        });
        // Pour ajouter des patterns, se référer à https://b2r-adm-1y.pin.dolmen.bouyguestelecom.fr/b2r_admin/confExtViewer.php
        var patterns = [{
          path: /\/(0|\+33)[1-9]\d{8}(\/|$)/g,
          remplacement: '/{numTel}$2'
        }, {
          path: /\/([a-z0-9][a-z0-9_\.-]*@[a-z][a-z0-9_\.-]*\.[a-z]+)/gi,
          remplacement: '/{email}'
        }, {
          path: /\/\d+[TP]/g,
          remplacement: '/{ligne}'
        }, {
          path: /\/dossierretour\/[A-Z0-9]+/g,
          remplacement: '/dossierretour/{dossier}'
        }, {
          path: /\/tickets\/[A-Z0-9-]+/g,
          remplacement: '/tickets/{ticket}'
        }, {
          path: /\/produits\/[A-Z0-9_]+/g,
          remplacement: '/produits/{produit}'
        }, {
          path: /\/fiches-apres-vente\/[a-z0-9-]+/g,
          remplacement: '/fiches-apres-vente/{fiche}'
        }, {
          path: /\/messageries\/[^/]+/g,
          remplacement: '/messageries/{messagerie}'
        }, {
          path: /\/factures\/[A-Z0-9]+/g,
          remplacement: '/factures/{facture}'
        }, {
          path: /\/factures-manuelles\/[A-Z0-9]+/g,
          remplacement: '/factures-manuelles/{facture}'
        }, {
          path: /\/documents\/[a-z0-9-]+/g,
          remplacement: '/documents/{document}'
        }, {
          path: /\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/gi,
          remplacement: '/{id}'
        }, {
          path: /\/(\d+)/g,
          remplacement: '/{id}'
        }];
        function extrairePatternUrl(url) {
          url = url.replace(/\?.+/, ''); // QueryParams
          patterns.forEach(function (_a) {
            var path = _a.path,
              remplacement = _a.remplacement;
            url = url.replace(path, remplacement);
          });
          return url;
        }

        /***/
      }),
      /***/"./src/config.ts": (
      /*!***********************!*\
        !*** ./src/config.ts ***!
        \***********************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"PrismeConfig": function () {
            return /* binding */PrismeConfig;
          }
          /* harmony export */
        });
        /* harmony import */
        var _helpers_ipHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./helpers/ipHelper */"./src/helpers/ipHelper.ts");
        /* harmony import */
        var _helpers_uuid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./helpers/uuid */"./src/helpers/uuid.ts");
        var NULL_STORAGE = {
          clear: function () {},
          length: 0,
          getItem: function () {
            return null;
          },
          key: function () {
            return null;
          },
          removeItem: function () {},
          setItem: function () {}
        };
        var PrismeConfig = /** @class */function () {
          function PrismeConfig(partialConfig) {
            var _this = this;
            this.urlEndpoint = partialConfig.urlEndpoint;
            this.st = partialConfig.st;
            this.environnement = {
              st: this.st,
              composant: partialConfig.composant,
              compte: partialConfig.compte,
              domaine: partialConfig.domaine,
              serveur: partialConfig.serveur,
              version: partialConfig.version,
              application: partialConfig.application || partialConfig.composant || this.st,
              nom: partialConfig.environnement
            };
            this.filtresInputAdditionnels = partialConfig.filtresInputAdditionnels || [];
            this.disableInput = !!partialConfig.disableInput;
            this.tailleMaxEnvoiQueueMessages = partialConfig.tailleMaxEnvoiQueueMessages || PrismeConfig.DEFAULT_TAILLE_MAX_QUEUE;
            this.timeoutEnvoiQueueMessagesMs = partialConfig.timeoutEnvoiQueueMessagesMs || PrismeConfig.DEFAULT_TIMEOUT_ENVOI_MS;
            if (partialConfig.storageMethod === null) {
              this.storageMethod = NULL_STORAGE;
            } else if (partialConfig.storageMethod === undefined) {
              this.storageMethod = sessionStorage;
            } else {
              this.storageMethod = partialConfig.storageMethod;
            }
            this.trackerIdProvider = partialConfig.trackerIdProvider || this.getTrackerIdStorage;
            this.userInfoProvider = partialConfig.userInfoProvider || function () {
              return {};
            };
            (0, _helpers_ipHelper__WEBPACK_IMPORTED_MODULE_0__.getPublicIp)(this.storageMethod).then(function (ip) {
              return _this.environnement.host = ip;
            });
          }
          PrismeConfig.prototype.getTrackerId = function () {
            return this.trackerIdProvider();
          };
          PrismeConfig.prototype.getTrackerIdStorage = function () {
            var trackerId = this.storageMethod.getItem(PrismeConfig.TRACKERID_KEY);
            if (!trackerId) {
              trackerId = (0, _helpers_uuid__WEBPACK_IMPORTED_MODULE_1__.uuid)();
              this.storageMethod.setItem(PrismeConfig.TRACKERID_KEY, trackerId);
            }
            return trackerId;
          };
          PrismeConfig.prototype.setTrackerId = function (trackerId) {
            this.trackerIdProvider = function () {
              return trackerId;
            };
          };
          PrismeConfig.DEFAULT_TAILLE_MAX_QUEUE = 10;
          PrismeConfig.DEFAULT_TIMEOUT_ENVOI_MS = 1000;
          PrismeConfig.TRACKERID_KEY = '@bytel/prisme-logger_trackerId';
          return PrismeConfig;
        }();

        /***/
      }),
      /***/"./src/handlers/angularRequestHandler.ts": (
      /*!***********************************************!*\
        !*** ./src/handlers/angularRequestHandler.ts ***!
        \***********************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"AngularPrismeLogger": function () {
            return /* binding */AngularPrismeLogger;
          },
          /* harmony export */"getPrismeLoggerInterceptorProvider": function () {
            return /* binding */getPrismeLoggerInterceptorProvider;
          },
          /* harmony export */"PrismeLoggerInterceptor": function () {
            return /* binding */PrismeLoggerInterceptor;
          }
          /* harmony export */
        });
        /* harmony import */
        var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */"./node_modules/@angular/common/fesm2015/http.js");
        /* harmony import */
        var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */"./node_modules/rxjs/_esm5/internal/operators/tap.js");
        /* harmony import */
        var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! .. */"./src/index.ts");
        /* harmony import */
        var _builders_messageBuilder__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../builders/messageBuilder */"./src/builders/messageBuilder.ts");
        var __extends = undefined && undefined.__extends || function () {
          var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
          };
          return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
              this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();
        var AngularPrismeLogger = /** @class */function (_super) {
          __extends(AngularPrismeLogger, _super);
          function AngularPrismeLogger() {
            return _super !== null && _super.apply(this, arguments) || this;
          }
          AngularPrismeLogger.prototype.getInterceptor = function () {
            return new PrismeLoggerInterceptor(this);
          };
          return AngularPrismeLogger;
        }(___WEBPACK_IMPORTED_MODULE_0__.PrismeLogger);
        function getPrismeLoggerInterceptorProvider() {
          return {
            provide: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__.HTTP_INTERCEPTORS,
            useFactory: function (prismeLogger) {
              return prismeLogger.getInterceptor();
            },
            multi: true,
            deps: [AngularPrismeLogger]
          };
        }
        var PrismeLoggerInterceptor = /** @class */function () {
          function PrismeLoggerInterceptor(prismeLogger) {
            this.prismeLogger = prismeLogger;
          }
          PrismeLoggerInterceptor.prototype.intercept = function (request, next) {
            var _this = this;
            var headersAAjouter = (0, _builders_messageBuilder__WEBPACK_IMPORTED_MODULE_1__.construireHeadersTracabilite)(this.prismeLogger.config, {});
            var headers = Object.entries(headersAAjouter).reduce(function (headers, _a) {
              var key = _a[0],
                value = _a[1];
              return headers.set(key, value);
            }, request.headers);
            request = request.clone({
              headers: headers
            });
            return next.handle(request).pipe((0, rxjs_operators__WEBPACK_IMPORTED_MODULE_3__.tap)({
              next: function (event) {
                if (event.type == _angular_common_http__WEBPACK_IMPORTED_MODULE_2__.HttpEventType.Response) {
                  _this.onResponse(request, event);
                }
                return event;
              },
              error: function (err) {
                _this.onResponse(request, err);
              }
            }));
          };
          PrismeLoggerInterceptor.prototype.onResponse = function (request, response) {
            try {
              var currentTime = Date.now();
              var url = request.url;
              var headers_1 = {};
              request.headers.keys().forEach(function (key) {
                return headers_1[key] = request.headers.get(key);
              });
              var execAppelRest = (0, _builders_messageBuilder__WEBPACK_IMPORTED_MODULE_1__.construireExecAppelRest)(this.prismeLogger.config, currentTime, headers_1, url, request.method, request.body, response.status, response instanceof _angular_common_http__WEBPACK_IMPORTED_MODULE_2__.HttpErrorResponse ? construireErreurAngular(response) : undefined);
              var ctx = (0, _builders_messageBuilder__WEBPACK_IMPORTED_MODULE_1__.construireContexte)(this.prismeLogger.config, {
                headers: request.headers
              });
              this.prismeLogger.sender.logMessagePrisme({
                ctx: ctx,
                events: [execAppelRest]
              });
            } catch (error) {
              console.error("Erreur lors de l'envoie des logs de l'appel Rest", error);
            }
          };
          return PrismeLoggerInterceptor;
        }();
        function construireErreurAngular(error) {
          if (error == null) {
            return undefined;
          }
          return {
            code: error.statusText || 'ERREUR_APPEL_RESS',
            type: error.status && error.status >= 400 && error.status < 500 ? 'FONCTIONNELLE' : 'TECHNIQUE',
            description: error.message,
            declencheur: error.url || undefined
          };
        }

        /***/
      }),
      /***/"./src/helpers/ipHelper.ts": (
      /*!*********************************!*\
        !*** ./src/helpers/ipHelper.ts ***!
        \*********************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"getPublicIp": function () {
            return /* binding */getPublicIp;
          }
          /* harmony export */
        });
        /* harmony import */
        var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! regenerator-runtime/runtime */"./node_modules/regenerator-runtime/runtime.js");
        /* harmony import */
        var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */
        var public_ip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! public-ip */"./node_modules/public-ip/browser.js");
        var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
          function adopt(value) {
            return value instanceof P ? value : new P(function (resolve) {
              resolve(value);
            });
          }
          return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
              try {
                step(generator.next(value));
              } catch (e) {
                reject(e);
              }
            }
            function rejected(value) {
              try {
                step(generator["throw"](value));
              } catch (e) {
                reject(e);
              }
            }
            function step(result) {
              result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
          });
        };
        var __generator = undefined && undefined.__generator || function (thisArg, body) {
          var _ = {
              label: 0,
              sent: function () {
                if (t[0] & 1) throw t[1];
                return t[1];
              },
              trys: [],
              ops: []
            },
            f,
            y,
            t,
            g;
          return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
          }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
            return this;
          }), g;
          function verb(n) {
            return function (v) {
              return step([n, v]);
            };
          }
          function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
              if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
              if (y = 0, t) op = [op[0] & 2, t.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t = op;
                  break;
                case 4:
                  _.label++;
                  return {
                    value: op[1],
                    done: false
                  };
                case 5:
                  _.label++;
                  y = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _.ops.pop();
                  _.trys.pop();
                  continue;
                default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _ = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                    _.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _.label < t[1]) {
                    _.label = t[1];
                    t = op;
                    break;
                  }
                  if (t && _.label < t[2]) {
                    _.label = t[2];
                    _.ops.push(op);
                    break;
                  }
                  if (t[2]) _.ops.pop();
                  _.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _);
            } catch (e) {
              op = [6, e];
              y = 0;
            } finally {
              f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
              value: op[0] ? op[1] : void 0,
              done: true
            };
          }
        };
        var IP_STORAGE_KEY = 'current-ip';
        var nbEchec = 0;
        function getPublicIp(storage) {
          return __awaiter(this, void 0, void 0, function () {
            var ipExistante, _publicIp, erreur_1;
            return __generator(this, function (_a) {
              switch (_a.label) {
                case 0:
                  ipExistante = storage.getItem(IP_STORAGE_KEY);
                  if (ipExistante) {
                    return [2 /*return*/, ipExistante];
                  }
                  _a.label = 1;
                case 1:
                  _a.trys.push([1, 3,, 4]);
                  return [4 /*yield*/, public_ip__WEBPACK_IMPORTED_MODULE_1__.v4({
                    timeout: 1000
                  })];
                case 2:
                  _publicIp = _a.sent();
                  storage.setItem(IP_STORAGE_KEY, _publicIp);
                  return [3 /*break*/, 4];
                case 3:
                  erreur_1 = _a.sent();
                  _publicIp = '';
                  nbEchec++;
                  if (nbEchec >= 5) {
                    storage.setItem(IP_STORAGE_KEY, _publicIp);
                  }
                  return [3 /*break*/, 4];
                case 4:
                  return [2 /*return*/, _publicIp];
              }
            });
          });
        }

        /***/
      }),
      /***/"./src/helpers/uuid.ts": (
      /*!*****************************!*\
        !*** ./src/helpers/uuid.ts ***!
        \*****************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"uuid": function () {
            return /* reexport safe */uuid__WEBPACK_IMPORTED_MODULE_0__.default;
          }
          /* harmony export */
        });
        /* harmony import */
        var uuid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! uuid */"./node_modules/uuid/dist/esm-browser/v4.js");

        /***/
      }),
      /***/"./src/index.ts": (
      /*!**********************!*\
        !*** ./src/index.ts ***!
        \**********************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"PrismeLogger": function () {
            return /* binding */PrismeLogger;
          },
          /* harmony export */"PrismeConfig": function () {
            return /* reexport safe */_config__WEBPACK_IMPORTED_MODULE_1__.PrismeConfig;
          }
          /* harmony export */
        });
        /* harmony import */
        var _builders_messageBuilder__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./builders/messageBuilder */"./src/builders/messageBuilder.ts");
        /* harmony import */
        var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./config */"./src/config.ts");
        /* harmony import */
        var _sender__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./sender */"./src/sender.ts");
        var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
          function adopt(value) {
            return value instanceof P ? value : new P(function (resolve) {
              resolve(value);
            });
          }
          return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
              try {
                step(generator.next(value));
              } catch (e) {
                reject(e);
              }
            }
            function rejected(value) {
              try {
                step(generator["throw"](value));
              } catch (e) {
                reject(e);
              }
            }
            function step(result) {
              result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
          });
        };
        var __generator = undefined && undefined.__generator || function (thisArg, body) {
          var _ = {
              label: 0,
              sent: function () {
                if (t[0] & 1) throw t[1];
                return t[1];
              },
              trys: [],
              ops: []
            },
            f,
            y,
            t,
            g;
          return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
          }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
            return this;
          }), g;
          function verb(n) {
            return function (v) {
              return step([n, v]);
            };
          }
          function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
              if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
              if (y = 0, t) op = [op[0] & 2, t.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t = op;
                  break;
                case 4:
                  _.label++;
                  return {
                    value: op[1],
                    done: false
                  };
                case 5:
                  _.label++;
                  y = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _.ops.pop();
                  _.trys.pop();
                  continue;
                default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _ = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                    _.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _.label < t[1]) {
                    _.label = t[1];
                    t = op;
                    break;
                  }
                  if (t && _.label < t[2]) {
                    _.label = t[2];
                    _.ops.push(op);
                    break;
                  }
                  if (t[2]) _.ops.pop();
                  _.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _);
            } catch (e) {
              op = [6, e];
              y = 0;
            } finally {
              f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
              value: op[0] ? op[1] : void 0,
              done: true
            };
          }
        };
        var __rest = undefined && undefined.__rest || function (s, e) {
          var t = {};
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
          if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
          }
          return t;
        };
        var PrismeLogger = /** @class */function () {
          function PrismeLogger(config) {
            this.config = new _config__WEBPACK_IMPORTED_MODULE_1__.PrismeConfig(config);
            this.sender = new _sender__WEBPACK_IMPORTED_MODULE_2__.SenderPrisme(this.config);
          }
          PrismeLogger.prototype.logToPrisme = function (message, _a) {
            if (_a === void 0) {
              _a = {};
            }
            var erreur = _a.erreur,
              action = _a.action,
              specifiqueMetier = __rest(_a, ["erreur", "action"]);
            return __awaiter(this, void 0, void 0, function () {
              var currentTime, ctx, log;
              return __generator(this, function (_b) {
                try {
                  currentTime = Date.now();
                  ctx = (0, _builders_messageBuilder__WEBPACK_IMPORTED_MODULE_0__.construireContexte)(this.config, specifiqueMetier);
                  log = (0, _builders_messageBuilder__WEBPACK_IMPORTED_MODULE_0__.construireLog)(this.config, currentTime, message, erreur, action);
                  this.sender.logMessagePrisme({
                    ctx: ctx,
                    events: [log]
                  });
                } catch (error) {
                  console.error("Erreur lors de l'envoie du message dans prisme", error);
                }
                return [2 /*return*/];
              });
            });
          };
          PrismeLogger.prototype.forcerEnvoiQueueMessages = function () {
            return this.sender.forcerEnvoiQueueMessages();
          };
          PrismeLogger.prototype.setTrackerId = function (trackerId) {
            return this.config.setTrackerId(trackerId);
          };
          return PrismeLogger;
        }();

        /***/
      }),
      /***/"./src/sender.ts": (
      /*!***********************!*\
        !*** ./src/sender.ts ***!
        \***********************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"SenderPrisme": function () {
            return /* binding */SenderPrisme;
          }
          /* harmony export */
        });
        /* harmony import */
        var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! axios */"axios");
        /* harmony import */
        var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */
        var _builders_messageBuilder__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./builders/messageBuilder */"./src/builders/messageBuilder.ts");
        var __assign = undefined && undefined.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];
              for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
          };
          return __assign.apply(this, arguments);
        };
        var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
          function adopt(value) {
            return value instanceof P ? value : new P(function (resolve) {
              resolve(value);
            });
          }
          return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
              try {
                step(generator.next(value));
              } catch (e) {
                reject(e);
              }
            }
            function rejected(value) {
              try {
                step(generator["throw"](value));
              } catch (e) {
                reject(e);
              }
            }
            function step(result) {
              result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
          });
        };
        var __generator = undefined && undefined.__generator || function (thisArg, body) {
          var _ = {
              label: 0,
              sent: function () {
                if (t[0] & 1) throw t[1];
                return t[1];
              },
              trys: [],
              ops: []
            },
            f,
            y,
            t,
            g;
          return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
          }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
            return this;
          }), g;
          function verb(n) {
            return function (v) {
              return step([n, v]);
            };
          }
          function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
              if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
              if (y = 0, t) op = [op[0] & 2, t.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t = op;
                  break;
                case 4:
                  _.label++;
                  return {
                    value: op[1],
                    done: false
                  };
                case 5:
                  _.label++;
                  y = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _.ops.pop();
                  _.trys.pop();
                  continue;
                default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _ = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                    _.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _.label < t[1]) {
                    _.label = t[1];
                    t = op;
                    break;
                  }
                  if (t && _.label < t[2]) {
                    _.label = t[2];
                    _.ops.push(op);
                    break;
                  }
                  if (t[2]) _.ops.pop();
                  _.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _);
            } catch (e) {
              op = [6, e];
              y = 0;
            } finally {
              f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
              value: op[0] ? op[1] : void 0,
              done: true
            };
          }
        };
        var SenderPrisme = /** @class */function () {
          function SenderPrisme(config) {
            this.envoieEnCours = false;
            this.lockQueue = Promise.resolve();
            this.timeoutEnvoi = null;
            this.axiosInstance = axios__WEBPACK_IMPORTED_MODULE_0___default().create();
            this.queueEnvoies = [];
            this.config = config;
          }
          SenderPrisme.prototype.forcerEnvoiQueueMessages = function () {
            return __awaiter(this, void 0, void 0, function () {
              var e_1;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    if (!!this.envoieEnCours) return [3 /*break*/, 5];
                    this.envoieEnCours = true;
                    _a.label = 1;
                  case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, this.envoyerMessages()];
                  case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                  case 3:
                    e_1 = _a.sent();
                    console.error("Erreur lors de l'envoie des logs prisme", e_1);
                    return [3 /*break*/, 5];
                  case 4:
                    this.envoieEnCours = false;
                    return [7 /*endfinally*/];
                  case 5:
                    return [2 /*return*/];
                }
              });
            });
          };
          SenderPrisme.prototype.logMessagePrisme = function (messagePrisme) {
            return __awaiter(this, void 0, void 0, function () {
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    return [4 /*yield*/, this.lockQueue];
                  case 1:
                    _a.sent();
                    this.queueEnvoies.push(messagePrisme);
                    return [4 /*yield*/, this.envoyerSiNecessaire()];
                  case 2:
                    _a.sent();
                    return [2 /*return*/];
                }
              });
            });
          };
          SenderPrisme.prototype.enrichirMessage = function (messagePartiel) {
            return __assign({
              st: this.config.st,
              env: this.config.environnement
            }, messagePartiel);
          };
          SenderPrisme.prototype.envoyerSiNecessaire = function () {
            return __awaiter(this, void 0, void 0, function () {
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    this.resetTimeout();
                    if (!(this.queueEnvoies.length > 0 && this.queueEnvoies.length >= this.config.tailleMaxEnvoiQueueMessages)) return [3 /*break*/, 2];
                    return [4 /*yield*/, this.envoyerMessages()];
                  case 1:
                    _a.sent();
                    _a.label = 2;
                  case 2:
                    return [2 /*return*/];
                }
              });
            });
          };
          SenderPrisme.prototype.envoyerMessages = function () {
            return __awaiter(this, void 0, void 0, function () {
              var _this = this;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    return [4 /*yield*/, this.lockQueue];
                  case 1:
                    _a.sent();
                    if (this.queueEnvoies.length > 0) {
                      this.resetTimeout();
                      this.lockQueue = new Promise(function (resolve, _) {
                        return __awaiter(_this, void 0, void 0, function () {
                          var messagesPrisme, e_2;
                          var _this = this;
                          return __generator(this, function (_a) {
                            switch (_a.label) {
                              case 0:
                                return [4 /*yield*/, Promise.all(this.queueEnvoies.map(function (m) {
                                  return _this.enrichirMessage(m);
                                }))];
                              case 1:
                                messagesPrisme = _a.sent();
                                _a.label = 2;
                              case 2:
                                _a.trys.push([2, 4, 5, 6]);
                                return [4 /*yield*/, this.axiosInstance.post(this.config.urlEndpoint, messagesPrisme, {
                                  headers: __assign({
                                    Accept: 'application/json',
                                    'Content-Type': 'application/json'
                                  }, (0, _builders_messageBuilder__WEBPACK_IMPORTED_MODULE_1__.construireHeadersTracabilite)(this.config))
                                })];
                              case 3:
                                _a.sent();
                                return [3 /*break*/, 6];
                              case 4:
                                e_2 = _a.sent();
                                console.error("[prisme-logger] Erreur lors de l'envoie des logs à LOGAPI", e_2);
                                return [3 /*break*/, 6];
                              case 5:
                                this.queueEnvoies = [];
                                resolve();
                                return [7 /*endfinally*/];
                              case 6:
                                return [2 /*return*/];
                            }
                          });
                        });
                      });
                    }
                    return [2 /*return*/, this.lockQueue];
                }
              });
            });
          };
          SenderPrisme.prototype.resetTimeout = function () {
            var _this = this;
            if (this.timeoutEnvoi) {
              clearTimeout(this.timeoutEnvoi);
            }
            this.timeoutEnvoi = setTimeout(function () {
              return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, this.envoyerMessages()];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            }, this.config.timeoutEnvoiQueueMessagesMs);
          };
          return SenderPrisme;
        }();

        /***/
      }),
      /***/"./node_modules/tslib/tslib.es6.js": (
      /*!*****************************************!*\
        !*** ./node_modules/tslib/tslib.es6.js ***!
        \*****************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"__extends": function () {
            return /* binding */__extends;
          },
          /* harmony export */"__assign": function () {
            return /* binding */__assign;
          },
          /* harmony export */"__rest": function () {
            return /* binding */__rest;
          },
          /* harmony export */"__decorate": function () {
            return /* binding */__decorate;
          },
          /* harmony export */"__param": function () {
            return /* binding */__param;
          },
          /* harmony export */"__metadata": function () {
            return /* binding */__metadata;
          },
          /* harmony export */"__awaiter": function () {
            return /* binding */__awaiter;
          },
          /* harmony export */"__generator": function () {
            return /* binding */__generator;
          },
          /* harmony export */"__createBinding": function () {
            return /* binding */__createBinding;
          },
          /* harmony export */"__exportStar": function () {
            return /* binding */__exportStar;
          },
          /* harmony export */"__values": function () {
            return /* binding */__values;
          },
          /* harmony export */"__read": function () {
            return /* binding */__read;
          },
          /* harmony export */"__spread": function () {
            return /* binding */__spread;
          },
          /* harmony export */"__spreadArrays": function () {
            return /* binding */__spreadArrays;
          },
          /* harmony export */"__await": function () {
            return /* binding */__await;
          },
          /* harmony export */"__asyncGenerator": function () {
            return /* binding */__asyncGenerator;
          },
          /* harmony export */"__asyncDelegator": function () {
            return /* binding */__asyncDelegator;
          },
          /* harmony export */"__asyncValues": function () {
            return /* binding */__asyncValues;
          },
          /* harmony export */"__makeTemplateObject": function () {
            return /* binding */__makeTemplateObject;
          },
          /* harmony export */"__importStar": function () {
            return /* binding */__importStar;
          },
          /* harmony export */"__importDefault": function () {
            return /* binding */__importDefault;
          },
          /* harmony export */"__classPrivateFieldGet": function () {
            return /* binding */__classPrivateFieldGet;
          },
          /* harmony export */"__classPrivateFieldSet": function () {
            return /* binding */__classPrivateFieldSet;
          }
          /* harmony export */
        });
        /*! *****************************************************************************
        Copyright (c) Microsoft Corporation.
        
        Permission to use, copy, modify, and/or distribute this software for any
        purpose with or without fee is hereby granted.
        
        THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
        REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
        AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
        INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
        LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
        OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
        PERFORMANCE OF THIS SOFTWARE.
        ***************************************************************************** */
        /* global Reflect, Promise */

        var extendStatics = function (d, b) {
          extendStatics = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (d, b) {
            d.__proto__ = b;
          } || function (d, b) {
            for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
          };
          return extendStatics(d, b);
        };
        function __extends(d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        }
        var __assign = function () {
          __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];
              for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
          };
          return __assign.apply(this, arguments);
        };
        function __rest(s, e) {
          var t = {};
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
          if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
          }
          return t;
        }
        function __decorate(decorators, target, key, desc) {
          var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
          if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
          return c > 3 && r && Object.defineProperty(target, key, r), r;
        }
        function __param(paramIndex, decorator) {
          return function (target, key) {
            decorator(target, key, paramIndex);
          };
        }
        function __metadata(metadataKey, metadataValue) {
          if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
        }
        function __awaiter(thisArg, _arguments, P, generator) {
          function adopt(value) {
            return value instanceof P ? value : new P(function (resolve) {
              resolve(value);
            });
          }
          return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
              try {
                step(generator.next(value));
              } catch (e) {
                reject(e);
              }
            }
            function rejected(value) {
              try {
                step(generator["throw"](value));
              } catch (e) {
                reject(e);
              }
            }
            function step(result) {
              result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
          });
        }
        function __generator(thisArg, body) {
          var _ = {
              label: 0,
              sent: function () {
                if (t[0] & 1) throw t[1];
                return t[1];
              },
              trys: [],
              ops: []
            },
            f,
            y,
            t,
            g;
          return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
          }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
            return this;
          }), g;
          function verb(n) {
            return function (v) {
              return step([n, v]);
            };
          }
          function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
              if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
              if (y = 0, t) op = [op[0] & 2, t.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t = op;
                  break;
                case 4:
                  _.label++;
                  return {
                    value: op[1],
                    done: false
                  };
                case 5:
                  _.label++;
                  y = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _.ops.pop();
                  _.trys.pop();
                  continue;
                default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _ = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                    _.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _.label < t[1]) {
                    _.label = t[1];
                    t = op;
                    break;
                  }
                  if (t && _.label < t[2]) {
                    _.label = t[2];
                    _.ops.push(op);
                    break;
                  }
                  if (t[2]) _.ops.pop();
                  _.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _);
            } catch (e) {
              op = [6, e];
              y = 0;
            } finally {
              f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
              value: op[0] ? op[1] : void 0,
              done: true
            };
          }
        }
        function __createBinding(o, m, k, k2) {
          if (k2 === undefined) k2 = k;
          o[k2] = m[k];
        }
        function __exportStar(m, exports) {
          for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
        }
        function __values(o) {
          var s = typeof Symbol === "function" && Symbol.iterator,
            m = s && o[s],
            i = 0;
          if (m) return m.call(o);
          if (o && typeof o.length === "number") return {
            next: function () {
              if (o && i >= o.length) o = void 0;
              return {
                value: o && o[i++],
                done: !o
              };
            }
          };
          throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
        }
        function __read(o, n) {
          var m = typeof Symbol === "function" && o[Symbol.iterator];
          if (!m) return o;
          var i = m.call(o),
            r,
            ar = [],
            e;
          try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
          } catch (error) {
            e = {
              error: error
            };
          } finally {
            try {
              if (r && !r.done && (m = i["return"])) m.call(i);
            } finally {
              if (e) throw e.error;
            }
          }
          return ar;
        }
        function __spread() {
          for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
          return ar;
        }
        function __spreadArrays() {
          for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
          for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
          return r;
        }
        ;
        function __await(v) {
          return this instanceof __await ? (this.v = v, this) : new __await(v);
        }
        function __asyncGenerator(thisArg, _arguments, generator) {
          if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
          var g = generator.apply(thisArg, _arguments || []),
            i,
            q = [];
          return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
            return this;
          }, i;
          function verb(n) {
            if (g[n]) i[n] = function (v) {
              return new Promise(function (a, b) {
                q.push([n, v, a, b]) > 1 || resume(n, v);
              });
            };
          }
          function resume(n, v) {
            try {
              step(g[n](v));
            } catch (e) {
              settle(q[0][3], e);
            }
          }
          function step(r) {
            r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
          }
          function fulfill(value) {
            resume("next", value);
          }
          function reject(value) {
            resume("throw", value);
          }
          function settle(f, v) {
            if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
          }
        }
        function __asyncDelegator(o) {
          var i, p;
          return i = {}, verb("next"), verb("throw", function (e) {
            throw e;
          }), verb("return"), i[Symbol.iterator] = function () {
            return this;
          }, i;
          function verb(n, f) {
            i[n] = o[n] ? function (v) {
              return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
              } : f ? f(v) : v;
            } : f;
          }
        }
        function __asyncValues(o) {
          if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
          var m = o[Symbol.asyncIterator],
            i;
          return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
            return this;
          }, i);
          function verb(n) {
            i[n] = o[n] && function (v) {
              return new Promise(function (resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
              });
            };
          }
          function settle(resolve, reject, d, v) {
            Promise.resolve(v).then(function (v) {
              resolve({
                value: v,
                done: d
              });
            }, reject);
          }
        }
        function __makeTemplateObject(cooked, raw) {
          if (Object.defineProperty) {
            Object.defineProperty(cooked, "raw", {
              value: raw
            });
          } else {
            cooked.raw = raw;
          }
          return cooked;
        }
        ;
        function __importStar(mod) {
          if (mod && mod.__esModule) return mod;
          var result = {};
          if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
          result.default = mod;
          return result;
        }
        function __importDefault(mod) {
          return mod && mod.__esModule ? mod : {
            default: mod
          };
        }
        function __classPrivateFieldGet(receiver, privateMap) {
          if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to get private field on non-instance");
          }
          return privateMap.get(receiver);
        }
        function __classPrivateFieldSet(receiver, privateMap, value) {
          if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to set private field on non-instance");
          }
          privateMap.set(receiver, value);
          return value;
        }

        /***/
      }),
      /***/"./node_modules/urijs/src/IPv6.js": (
      /*!****************************************!*\
        !*** ./node_modules/urijs/src/IPv6.js ***!
        \****************************************/
      /***/
      function (module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__; /*!
                                                                           * URI.js - Mutating URLs
                                                                           * IPv6 Support
                                                                           *
                                                                           * Version: 1.19.7
                                                                           *
                                                                           * Author: Rodney Rehm
                                                                           * Web: http://medialize.github.io/URI.js/
                                                                           *
                                                                           * Licensed under
                                                                           *   MIT License http://www.opensource.org/licenses/mit-license
                                                                           *
                                                                           */

        (function (root, factory) {
          'use strict';

          // https://github.com/umdjs/umd/blob/master/returnExports.js
          if (true && module.exports) {
            // Node
            module.exports = factory();
          } else if (true) {
            // AMD. Register as an anonymous module.
            !(__WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
          } else {}
        })(this, function (root) {
          'use strict';

          /*
          var _in = "fe80:0000:0000:0000:0204:61ff:fe9d:f156";
          var _out = IPv6.best(_in);
          var _expected = "fe80::204:61ff:fe9d:f156";
           console.log(_in, _out, _expected, _out === _expected);
          */

          // save current IPv6 variable, if any
          var _IPv6 = root && root.IPv6;
          function bestPresentation(address) {
            // based on:
            // Javascript to test an IPv6 address for proper format, and to
            // present the "best text representation" according to IETF Draft RFC at
            // http://tools.ietf.org/html/draft-ietf-6man-text-addr-representation-04
            // 8 Feb 2010 Rich Brown, Dartware, LLC
            // Please feel free to use this code as long as you provide a link to
            // http://www.intermapper.com
            // http://intermapper.com/support/tools/IPV6-Validator.aspx
            // http://download.dartware.com/thirdparty/ipv6validator.js

            var _address = address.toLowerCase();
            var segments = _address.split(':');
            var length = segments.length;
            var total = 8;

            // trim colons (:: or ::a:b:c… or …a:b:c::)
            if (segments[0] === '' && segments[1] === '' && segments[2] === '') {
              // must have been ::
              // remove first two items
              segments.shift();
              segments.shift();
            } else if (segments[0] === '' && segments[1] === '') {
              // must have been ::xxxx
              // remove the first item
              segments.shift();
            } else if (segments[length - 1] === '' && segments[length - 2] === '') {
              // must have been xxxx::
              segments.pop();
            }
            length = segments.length;

            // adjust total segments for IPv4 trailer
            if (segments[length - 1].indexOf('.') !== -1) {
              // found a "." which means IPv4
              total = 7;
            }

            // fill empty segments them with "0000"
            var pos;
            for (pos = 0; pos < length; pos++) {
              if (segments[pos] === '') {
                break;
              }
            }
            if (pos < total) {
              segments.splice(pos, 1, '0000');
              while (segments.length < total) {
                segments.splice(pos, 0, '0000');
              }
            }

            // strip leading zeros
            var _segments;
            for (var i = 0; i < total; i++) {
              _segments = segments[i].split('');
              for (var j = 0; j < 3; j++) {
                if (_segments[0] === '0' && _segments.length > 1) {
                  _segments.splice(0, 1);
                } else {
                  break;
                }
              }
              segments[i] = _segments.join('');
            }

            // find longest sequence of zeroes and coalesce them into one segment
            var best = -1;
            var _best = 0;
            var _current = 0;
            var current = -1;
            var inzeroes = false;
            // i; already declared

            for (i = 0; i < total; i++) {
              if (inzeroes) {
                if (segments[i] === '0') {
                  _current += 1;
                } else {
                  inzeroes = false;
                  if (_current > _best) {
                    best = current;
                    _best = _current;
                  }
                }
              } else {
                if (segments[i] === '0') {
                  inzeroes = true;
                  current = i;
                  _current = 1;
                }
              }
            }
            if (_current > _best) {
              best = current;
              _best = _current;
            }
            if (_best > 1) {
              segments.splice(best, _best, '');
            }
            length = segments.length;

            // assemble remaining segments
            var result = '';
            if (segments[0] === '') {
              result = ':';
            }
            for (i = 0; i < length; i++) {
              result += segments[i];
              if (i === length - 1) {
                break;
              }
              result += ':';
            }
            if (segments[length - 1] === '') {
              result += ':';
            }
            return result;
          }
          function noConflict() {
            /*jshint validthis: true */
            if (root.IPv6 === this) {
              root.IPv6 = _IPv6;
            }
            return this;
          }
          return {
            best: bestPresentation,
            noConflict: noConflict
          };
        });

        /***/
      }),
      /***/"./node_modules/urijs/src/SecondLevelDomains.js": (
      /*!******************************************************!*\
        !*** ./node_modules/urijs/src/SecondLevelDomains.js ***!
        \******************************************************/
      /***/
      function (module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__; /*!
                                                                           * URI.js - Mutating URLs
                                                                           * Second Level Domain (SLD) Support
                                                                           *
                                                                           * Version: 1.19.7
                                                                           *
                                                                           * Author: Rodney Rehm
                                                                           * Web: http://medialize.github.io/URI.js/
                                                                           *
                                                                           * Licensed under
                                                                           *   MIT License http://www.opensource.org/licenses/mit-license
                                                                           *
                                                                           */

        (function (root, factory) {
          'use strict';

          // https://github.com/umdjs/umd/blob/master/returnExports.js
          if (true && module.exports) {
            // Node
            module.exports = factory();
          } else if (true) {
            // AMD. Register as an anonymous module.
            !(__WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
          } else {}
        })(this, function (root) {
          'use strict';

          // save current SecondLevelDomains variable, if any
          var _SecondLevelDomains = root && root.SecondLevelDomains;
          var SLD = {
            // list of known Second Level Domains
            // converted list of SLDs from https://github.com/gavingmiller/second-level-domains
            // ----
            // publicsuffix.org is more current and actually used by a couple of browsers internally.
            // downside is it also contains domains like "dyndns.org" - which is fine for the security
            // issues browser have to deal with (SOP for cookies, etc) - but is way overboard for URI.js
            // ----
            list: {
              'ac': ' com gov mil net org ',
              'ae': ' ac co gov mil name net org pro sch ',
              'af': ' com edu gov net org ',
              'al': ' com edu gov mil net org ',
              'ao': ' co ed gv it og pb ',
              'ar': ' com edu gob gov int mil net org tur ',
              'at': ' ac co gv or ',
              'au': ' asn com csiro edu gov id net org ',
              'ba': ' co com edu gov mil net org rs unbi unmo unsa untz unze ',
              'bb': ' biz co com edu gov info net org store tv ',
              'bh': ' biz cc com edu gov info net org ',
              'bn': ' com edu gov net org ',
              'bo': ' com edu gob gov int mil net org tv ',
              'br': ' adm adv agr am arq art ato b bio blog bmd cim cng cnt com coop ecn edu eng esp etc eti far flog fm fnd fot fst g12 ggf gov imb ind inf jor jus lel mat med mil mus net nom not ntr odo org ppg pro psc psi qsl rec slg srv tmp trd tur tv vet vlog wiki zlg ',
              'bs': ' com edu gov net org ',
              'bz': ' du et om ov rg ',
              'ca': ' ab bc mb nb nf nl ns nt nu on pe qc sk yk ',
              'ck': ' biz co edu gen gov info net org ',
              'cn': ' ac ah bj com cq edu fj gd gov gs gx gz ha hb he hi hl hn jl js jx ln mil net nm nx org qh sc sd sh sn sx tj tw xj xz yn zj ',
              'co': ' com edu gov mil net nom org ',
              'cr': ' ac c co ed fi go or sa ',
              'cy': ' ac biz com ekloges gov ltd name net org parliament press pro tm ',
              'do': ' art com edu gob gov mil net org sld web ',
              'dz': ' art asso com edu gov net org pol ',
              'ec': ' com edu fin gov info med mil net org pro ',
              'eg': ' com edu eun gov mil name net org sci ',
              'er': ' com edu gov ind mil net org rochest w ',
              'es': ' com edu gob nom org ',
              'et': ' biz com edu gov info name net org ',
              'fj': ' ac biz com info mil name net org pro ',
              'fk': ' ac co gov net nom org ',
              'fr': ' asso com f gouv nom prd presse tm ',
              'gg': ' co net org ',
              'gh': ' com edu gov mil org ',
              'gn': ' ac com gov net org ',
              'gr': ' com edu gov mil net org ',
              'gt': ' com edu gob ind mil net org ',
              'gu': ' com edu gov net org ',
              'hk': ' com edu gov idv net org ',
              'hu': ' 2000 agrar bolt casino city co erotica erotika film forum games hotel info ingatlan jogasz konyvelo lakas media news org priv reklam sex shop sport suli szex tm tozsde utazas video ',
              'id': ' ac co go mil net or sch web ',
              'il': ' ac co gov idf k12 muni net org ',
              'in': ' ac co edu ernet firm gen gov i ind mil net nic org res ',
              'iq': ' com edu gov i mil net org ',
              'ir': ' ac co dnssec gov i id net org sch ',
              'it': ' edu gov ',
              'je': ' co net org ',
              'jo': ' com edu gov mil name net org sch ',
              'jp': ' ac ad co ed go gr lg ne or ',
              'ke': ' ac co go info me mobi ne or sc ',
              'kh': ' com edu gov mil net org per ',
              'ki': ' biz com de edu gov info mob net org tel ',
              'km': ' asso com coop edu gouv k medecin mil nom notaires pharmaciens presse tm veterinaire ',
              'kn': ' edu gov net org ',
              'kr': ' ac busan chungbuk chungnam co daegu daejeon es gangwon go gwangju gyeongbuk gyeonggi gyeongnam hs incheon jeju jeonbuk jeonnam k kg mil ms ne or pe re sc seoul ulsan ',
              'kw': ' com edu gov net org ',
              'ky': ' com edu gov net org ',
              'kz': ' com edu gov mil net org ',
              'lb': ' com edu gov net org ',
              'lk': ' assn com edu gov grp hotel int ltd net ngo org sch soc web ',
              'lr': ' com edu gov net org ',
              'lv': ' asn com conf edu gov id mil net org ',
              'ly': ' com edu gov id med net org plc sch ',
              'ma': ' ac co gov m net org press ',
              'mc': ' asso tm ',
              'me': ' ac co edu gov its net org priv ',
              'mg': ' com edu gov mil nom org prd tm ',
              'mk': ' com edu gov inf name net org pro ',
              'ml': ' com edu gov net org presse ',
              'mn': ' edu gov org ',
              'mo': ' com edu gov net org ',
              'mt': ' com edu gov net org ',
              'mv': ' aero biz com coop edu gov info int mil museum name net org pro ',
              'mw': ' ac co com coop edu gov int museum net org ',
              'mx': ' com edu gob net org ',
              'my': ' com edu gov mil name net org sch ',
              'nf': ' arts com firm info net other per rec store web ',
              'ng': ' biz com edu gov mil mobi name net org sch ',
              'ni': ' ac co com edu gob mil net nom org ',
              'np': ' com edu gov mil net org ',
              'nr': ' biz com edu gov info net org ',
              'om': ' ac biz co com edu gov med mil museum net org pro sch ',
              'pe': ' com edu gob mil net nom org sld ',
              'ph': ' com edu gov i mil net ngo org ',
              'pk': ' biz com edu fam gob gok gon gop gos gov net org web ',
              'pl': ' art bialystok biz com edu gda gdansk gorzow gov info katowice krakow lodz lublin mil net ngo olsztyn org poznan pwr radom slupsk szczecin torun warszawa waw wroc wroclaw zgora ',
              'pr': ' ac biz com edu est gov info isla name net org pro prof ',
              'ps': ' com edu gov net org plo sec ',
              'pw': ' belau co ed go ne or ',
              'ro': ' arts com firm info nom nt org rec store tm www ',
              'rs': ' ac co edu gov in org ',
              'sb': ' com edu gov net org ',
              'sc': ' com edu gov net org ',
              'sh': ' co com edu gov net nom org ',
              'sl': ' com edu gov net org ',
              'st': ' co com consulado edu embaixada gov mil net org principe saotome store ',
              'sv': ' com edu gob org red ',
              'sz': ' ac co org ',
              'tr': ' av bbs bel biz com dr edu gen gov info k12 name net org pol tel tsk tv web ',
              'tt': ' aero biz cat co com coop edu gov info int jobs mil mobi museum name net org pro tel travel ',
              'tw': ' club com ebiz edu game gov idv mil net org ',
              'mu': ' ac co com gov net or org ',
              'mz': ' ac co edu gov org ',
              'na': ' co com ',
              'nz': ' ac co cri geek gen govt health iwi maori mil net org parliament school ',
              'pa': ' abo ac com edu gob ing med net nom org sld ',
              'pt': ' com edu gov int net nome org publ ',
              'py': ' com edu gov mil net org ',
              'qa': ' com edu gov mil net org ',
              're': ' asso com nom ',
              'ru': ' ac adygeya altai amur arkhangelsk astrakhan bashkiria belgorod bir bryansk buryatia cbg chel chelyabinsk chita chukotka chuvashia com dagestan e-burg edu gov grozny int irkutsk ivanovo izhevsk jar joshkar-ola kalmykia kaluga kamchatka karelia kazan kchr kemerovo khabarovsk khakassia khv kirov koenig komi kostroma kranoyarsk kuban kurgan kursk lipetsk magadan mari mari-el marine mil mordovia mosreg msk murmansk nalchik net nnov nov novosibirsk nsk omsk orenburg org oryol penza perm pp pskov ptz rnd ryazan sakhalin samara saratov simbirsk smolensk spb stavropol stv surgut tambov tatarstan tom tomsk tsaritsyn tsk tula tuva tver tyumen udm udmurtia ulan-ude vladikavkaz vladimir vladivostok volgograd vologda voronezh vrn vyatka yakutia yamal yekaterinburg yuzhno-sakhalinsk ',
              'rw': ' ac co com edu gouv gov int mil net ',
              'sa': ' com edu gov med net org pub sch ',
              'sd': ' com edu gov info med net org tv ',
              'se': ' a ac b bd c d e f g h i k l m n o org p parti pp press r s t tm u w x y z ',
              'sg': ' com edu gov idn net org per ',
              'sn': ' art com edu gouv org perso univ ',
              'sy': ' com edu gov mil net news org ',
              'th': ' ac co go in mi net or ',
              'tj': ' ac biz co com edu go gov info int mil name net nic org test web ',
              'tn': ' agrinet com defense edunet ens fin gov ind info intl mincom nat net org perso rnrt rns rnu tourism ',
              'tz': ' ac co go ne or ',
              'ua': ' biz cherkassy chernigov chernovtsy ck cn co com crimea cv dn dnepropetrovsk donetsk dp edu gov if in ivano-frankivsk kh kharkov kherson khmelnitskiy kiev kirovograd km kr ks kv lg lugansk lutsk lviv me mk net nikolaev od odessa org pl poltava pp rovno rv sebastopol sumy te ternopil uzhgorod vinnica vn zaporizhzhe zhitomir zp zt ',
              'ug': ' ac co go ne or org sc ',
              'uk': ' ac bl british-library co cym gov govt icnet jet lea ltd me mil mod national-library-scotland nel net nhs nic nls org orgn parliament plc police sch scot soc ',
              'us': ' dni fed isa kids nsn ',
              'uy': ' com edu gub mil net org ',
              've': ' co com edu gob info mil net org web ',
              'vi': ' co com k12 net org ',
              'vn': ' ac biz com edu gov health info int name net org pro ',
              'ye': ' co com gov ltd me net org plc ',
              'yu': ' ac co edu gov org ',
              'za': ' ac agric alt bourse city co cybernet db edu gov grondar iaccess imt inca landesign law mil net ngo nis nom olivetti org pix school tm web ',
              'zm': ' ac co com edu gov net org sch ',
              // https://en.wikipedia.org/wiki/CentralNic#Second-level_domains
              'com': 'ar br cn de eu gb gr hu jpn kr no qc ru sa se uk us uy za ',
              'net': 'gb jp se uk ',
              'org': 'ae',
              'de': 'com '
            },
            // gorhill 2013-10-25: Using indexOf() instead Regexp(). Significant boost
            // in both performance and memory footprint. No initialization required.
            // http://jsperf.com/uri-js-sld-regex-vs-binary-search/4
            // Following methods use lastIndexOf() rather than array.split() in order
            // to avoid any memory allocations.
            has: function (domain) {
              var tldOffset = domain.lastIndexOf('.');
              if (tldOffset <= 0 || tldOffset >= domain.length - 1) {
                return false;
              }
              var sldOffset = domain.lastIndexOf('.', tldOffset - 1);
              if (sldOffset <= 0 || sldOffset >= tldOffset - 1) {
                return false;
              }
              var sldList = SLD.list[domain.slice(tldOffset + 1)];
              if (!sldList) {
                return false;
              }
              return sldList.indexOf(' ' + domain.slice(sldOffset + 1, tldOffset) + ' ') >= 0;
            },
            is: function (domain) {
              var tldOffset = domain.lastIndexOf('.');
              if (tldOffset <= 0 || tldOffset >= domain.length - 1) {
                return false;
              }
              var sldOffset = domain.lastIndexOf('.', tldOffset - 1);
              if (sldOffset >= 0) {
                return false;
              }
              var sldList = SLD.list[domain.slice(tldOffset + 1)];
              if (!sldList) {
                return false;
              }
              return sldList.indexOf(' ' + domain.slice(0, tldOffset) + ' ') >= 0;
            },
            get: function (domain) {
              var tldOffset = domain.lastIndexOf('.');
              if (tldOffset <= 0 || tldOffset >= domain.length - 1) {
                return null;
              }
              var sldOffset = domain.lastIndexOf('.', tldOffset - 1);
              if (sldOffset <= 0 || sldOffset >= tldOffset - 1) {
                return null;
              }
              var sldList = SLD.list[domain.slice(tldOffset + 1)];
              if (!sldList) {
                return null;
              }
              if (sldList.indexOf(' ' + domain.slice(sldOffset + 1, tldOffset) + ' ') < 0) {
                return null;
              }
              return domain.slice(sldOffset + 1);
            },
            noConflict: function () {
              if (root.SecondLevelDomains === this) {
                root.SecondLevelDomains = _SecondLevelDomains;
              }
              return this;
            }
          };
          return SLD;
        });

        /***/
      }),
      /***/"./node_modules/urijs/src/URI.js": (
      /*!***************************************!*\
        !*** ./node_modules/urijs/src/URI.js ***!
        \***************************************/
      /***/
      function (module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; /*!
                                                                                                         * URI.js - Mutating URLs
                                                                                                         *
                                                                                                         * Version: 1.19.7
                                                                                                         *
                                                                                                         * Author: Rodney Rehm
                                                                                                         * Web: http://medialize.github.io/URI.js/
                                                                                                         *
                                                                                                         * Licensed under
                                                                                                         *   MIT License http://www.opensource.org/licenses/mit-license
                                                                                                         *
                                                                                                         */
        (function (root, factory) {
          'use strict';

          // https://github.com/umdjs/umd/blob/master/returnExports.js
          if (true && module.exports) {
            // Node
            module.exports = factory(__webpack_require__(/*! ./punycode */"./node_modules/urijs/src/punycode.js"), __webpack_require__(/*! ./IPv6 */"./node_modules/urijs/src/IPv6.js"), __webpack_require__(/*! ./SecondLevelDomains */"./node_modules/urijs/src/SecondLevelDomains.js"));
          } else if (true) {
            // AMD. Register as an anonymous module.
            !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! ./punycode */"./node_modules/urijs/src/punycode.js"), __webpack_require__(/*! ./IPv6 */"./node_modules/urijs/src/IPv6.js"), __webpack_require__(/*! ./SecondLevelDomains */"./node_modules/urijs/src/SecondLevelDomains.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
          } else {}
        })(this, function (punycode, IPv6, SLD, root) {
          'use strict';

          /*global location, escape, unescape */
          // FIXME: v2.0.0 renamce non-camelCase properties to uppercase
          /*jshint camelcase: false */

          // save current URI variable, if any
          var _URI = root && root.URI;
          function URI(url, base) {
            var _urlSupplied = arguments.length >= 1;
            var _baseSupplied = arguments.length >= 2;

            // Allow instantiation without the 'new' keyword
            if (!(this instanceof URI)) {
              if (_urlSupplied) {
                if (_baseSupplied) {
                  return new URI(url, base);
                }
                return new URI(url);
              }
              return new URI();
            }
            if (url === undefined) {
              if (_urlSupplied) {
                throw new TypeError('undefined is not a valid argument for URI');
              }
              if (typeof location !== 'undefined') {
                url = location.href + '';
              } else {
                url = '';
              }
            }
            if (url === null) {
              if (_urlSupplied) {
                throw new TypeError('null is not a valid argument for URI');
              }
            }
            this.href(url);

            // resolve to base according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#constructor
            if (base !== undefined) {
              return this.absoluteTo(base);
            }
            return this;
          }
          function isInteger(value) {
            return /^[0-9]+$/.test(value);
          }
          URI.version = '1.19.7';
          var p = URI.prototype;
          var hasOwn = Object.prototype.hasOwnProperty;
          function escapeRegEx(string) {
            // https://github.com/medialize/URI.js/commit/85ac21783c11f8ccab06106dba9735a31a86924d#commitcomment-821963
            return string.replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
          }
          function getType(value) {
            // IE8 doesn't return [Object Undefined] but [Object Object] for undefined value
            if (value === undefined) {
              return 'Undefined';
            }
            return String(Object.prototype.toString.call(value)).slice(8, -1);
          }
          function isArray(obj) {
            return getType(obj) === 'Array';
          }
          function filterArrayValues(data, value) {
            var lookup = {};
            var i, length;
            if (getType(value) === 'RegExp') {
              lookup = null;
            } else if (isArray(value)) {
              for (i = 0, length = value.length; i < length; i++) {
                lookup[value[i]] = true;
              }
            } else {
              lookup[value] = true;
            }
            for (i = 0, length = data.length; i < length; i++) {
              /*jshint laxbreak: true */
              var _match = lookup && lookup[data[i]] !== undefined || !lookup && value.test(data[i]);
              /*jshint laxbreak: false */
              if (_match) {
                data.splice(i, 1);
                length--;
                i--;
              }
            }
            return data;
          }
          function arrayContains(list, value) {
            var i, length;

            // value may be string, number, array, regexp
            if (isArray(value)) {
              // Note: this can be optimized to O(n) (instead of current O(m * n))
              for (i = 0, length = value.length; i < length; i++) {
                if (!arrayContains(list, value[i])) {
                  return false;
                }
              }
              return true;
            }
            var _type = getType(value);
            for (i = 0, length = list.length; i < length; i++) {
              if (_type === 'RegExp') {
                if (typeof list[i] === 'string' && list[i].match(value)) {
                  return true;
                }
              } else if (list[i] === value) {
                return true;
              }
            }
            return false;
          }
          function arraysEqual(one, two) {
            if (!isArray(one) || !isArray(two)) {
              return false;
            }

            // arrays can't be equal if they have different amount of content
            if (one.length !== two.length) {
              return false;
            }
            one.sort();
            two.sort();
            for (var i = 0, l = one.length; i < l; i++) {
              if (one[i] !== two[i]) {
                return false;
              }
            }
            return true;
          }
          function trimSlashes(text) {
            var trim_expression = /^\/+|\/+$/g;
            return text.replace(trim_expression, '');
          }
          URI._parts = function () {
            return {
              protocol: null,
              username: null,
              password: null,
              hostname: null,
              urn: null,
              port: null,
              path: null,
              query: null,
              fragment: null,
              // state
              preventInvalidHostname: URI.preventInvalidHostname,
              duplicateQueryParameters: URI.duplicateQueryParameters,
              escapeQuerySpace: URI.escapeQuerySpace
            };
          };
          // state: throw on invalid hostname
          // see https://github.com/medialize/URI.js/pull/345
          // and https://github.com/medialize/URI.js/issues/354
          URI.preventInvalidHostname = false;
          // state: allow duplicate query parameters (a=1&a=1)
          URI.duplicateQueryParameters = false;
          // state: replaces + with %20 (space in query strings)
          URI.escapeQuerySpace = true;
          // static properties
          URI.protocol_expression = /^[a-z][a-z0-9.+-]*$/i;
          URI.idn_expression = /[^a-z0-9\._-]/i;
          URI.punycode_expression = /(xn--)/i;
          // well, 333.444.555.666 matches, but it sure ain't no IPv4 - do we care?
          URI.ip4_expression = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
          // credits to Rich Brown
          // source: http://forums.intermapper.com/viewtopic.php?p=1096#1096
          // specification: http://www.ietf.org/rfc/rfc4291.txt
          URI.ip6_expression = /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/;
          // expression used is "gruber revised" (@gruber v2) determined to be the
          // best solution in a regex-golf we did a couple of ages ago at
          // * http://mathiasbynens.be/demo/url-regex
          // * http://rodneyrehm.de/t/url-regex.html
          URI.find_uri_expression = /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/ig;
          URI.findUri = {
            // valid "scheme://" or "www."
            start: /\b(?:([a-z][a-z0-9.+-]*:\/\/)|www\.)/gi,
            // everything up to the next whitespace
            end: /[\s\r\n]|$/,
            // trim trailing punctuation captured by end RegExp
            trim: /[`!()\[\]{};:'".,<>?«»“”„‘’]+$/,
            // balanced parens inclusion (), [], {}, <>
            parens: /(\([^\)]*\)|\[[^\]]*\]|\{[^}]*\}|<[^>]*>)/g
          };
          // http://www.iana.org/assignments/uri-schemes.html
          // http://en.wikipedia.org/wiki/List_of_TCP_and_UDP_port_numbers#Well-known_ports
          URI.defaultPorts = {
            http: '80',
            https: '443',
            ftp: '21',
            gopher: '70',
            ws: '80',
            wss: '443'
          };
          // list of protocols which always require a hostname
          URI.hostProtocols = ['http', 'https'];

          // allowed hostname characters according to RFC 3986
          // ALPHA DIGIT "-" "." "_" "~" "!" "$" "&" "'" "(" ")" "*" "+" "," ";" "=" %encoded
          // I've never seen a (non-IDN) hostname other than: ALPHA DIGIT . - _
          URI.invalid_hostname_characters = /[^a-zA-Z0-9\.\-:_]/;
          // map DOM Elements to their URI attribute
          URI.domAttributes = {
            'a': 'href',
            'blockquote': 'cite',
            'link': 'href',
            'base': 'href',
            'script': 'src',
            'form': 'action',
            'img': 'src',
            'area': 'href',
            'iframe': 'src',
            'embed': 'src',
            'source': 'src',
            'track': 'src',
            'input': 'src',
            // but only if type="image"
            'audio': 'src',
            'video': 'src'
          };
          URI.getDomAttribute = function (node) {
            if (!node || !node.nodeName) {
              return undefined;
            }
            var nodeName = node.nodeName.toLowerCase();
            // <input> should only expose src for type="image"
            if (nodeName === 'input' && node.type !== 'image') {
              return undefined;
            }
            return URI.domAttributes[nodeName];
          };
          function escapeForDumbFirefox36(value) {
            // https://github.com/medialize/URI.js/issues/91
            return escape(value);
          }

          // encoding / decoding according to RFC3986
          function strictEncodeURIComponent(string) {
            // see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/encodeURIComponent
            return encodeURIComponent(string).replace(/[!'()*]/g, escapeForDumbFirefox36).replace(/\*/g, '%2A');
          }
          URI.encode = strictEncodeURIComponent;
          URI.decode = decodeURIComponent;
          URI.iso8859 = function () {
            URI.encode = escape;
            URI.decode = unescape;
          };
          URI.unicode = function () {
            URI.encode = strictEncodeURIComponent;
            URI.decode = decodeURIComponent;
          };
          URI.characters = {
            pathname: {
              encode: {
                // RFC3986 2.1: For consistency, URI producers and normalizers should
                // use uppercase hexadecimal digits for all percent-encodings.
                expression: /%(24|26|2B|2C|3B|3D|3A|40)/ig,
                map: {
                  // -._~!'()*
                  '%24': '$',
                  '%26': '&',
                  '%2B': '+',
                  '%2C': ',',
                  '%3B': ';',
                  '%3D': '=',
                  '%3A': ':',
                  '%40': '@'
                }
              },
              decode: {
                expression: /[\/\?#]/g,
                map: {
                  '/': '%2F',
                  '?': '%3F',
                  '#': '%23'
                }
              }
            },
            reserved: {
              encode: {
                // RFC3986 2.1: For consistency, URI producers and normalizers should
                // use uppercase hexadecimal digits for all percent-encodings.
                expression: /%(21|23|24|26|27|28|29|2A|2B|2C|2F|3A|3B|3D|3F|40|5B|5D)/ig,
                map: {
                  // gen-delims
                  '%3A': ':',
                  '%2F': '/',
                  '%3F': '?',
                  '%23': '#',
                  '%5B': '[',
                  '%5D': ']',
                  '%40': '@',
                  // sub-delims
                  '%21': '!',
                  '%24': '$',
                  '%26': '&',
                  '%27': '\'',
                  '%28': '(',
                  '%29': ')',
                  '%2A': '*',
                  '%2B': '+',
                  '%2C': ',',
                  '%3B': ';',
                  '%3D': '='
                }
              }
            },
            urnpath: {
              // The characters under `encode` are the characters called out by RFC 2141 as being acceptable
              // for usage in a URN. RFC2141 also calls out "-", ".", and "_" as acceptable characters, but
              // these aren't encoded by encodeURIComponent, so we don't have to call them out here. Also
              // note that the colon character is not featured in the encoding map; this is because URI.js
              // gives the colons in URNs semantic meaning as the delimiters of path segements, and so it
              // should not appear unencoded in a segment itself.
              // See also the note above about RFC3986 and capitalalized hex digits.
              encode: {
                expression: /%(21|24|27|28|29|2A|2B|2C|3B|3D|40)/ig,
                map: {
                  '%21': '!',
                  '%24': '$',
                  '%27': '\'',
                  '%28': '(',
                  '%29': ')',
                  '%2A': '*',
                  '%2B': '+',
                  '%2C': ',',
                  '%3B': ';',
                  '%3D': '=',
                  '%40': '@'
                }
              },
              // These characters are the characters called out by RFC2141 as "reserved" characters that
              // should never appear in a URN, plus the colon character (see note above).
              decode: {
                expression: /[\/\?#:]/g,
                map: {
                  '/': '%2F',
                  '?': '%3F',
                  '#': '%23',
                  ':': '%3A'
                }
              }
            }
          };
          URI.encodeQuery = function (string, escapeQuerySpace) {
            var escaped = URI.encode(string + '');
            if (escapeQuerySpace === undefined) {
              escapeQuerySpace = URI.escapeQuerySpace;
            }
            return escapeQuerySpace ? escaped.replace(/%20/g, '+') : escaped;
          };
          URI.decodeQuery = function (string, escapeQuerySpace) {
            string += '';
            if (escapeQuerySpace === undefined) {
              escapeQuerySpace = URI.escapeQuerySpace;
            }
            try {
              return URI.decode(escapeQuerySpace ? string.replace(/\+/g, '%20') : string);
            } catch (e) {
              // we're not going to mess with weird encodings,
              // give up and return the undecoded original string
              // see https://github.com/medialize/URI.js/issues/87
              // see https://github.com/medialize/URI.js/issues/92
              return string;
            }
          };
          // generate encode/decode path functions
          var _parts = {
            'encode': 'encode',
            'decode': 'decode'
          };
          var _part;
          var generateAccessor = function (_group, _part) {
            return function (string) {
              try {
                return URI[_part](string + '').replace(URI.characters[_group][_part].expression, function (c) {
                  return URI.characters[_group][_part].map[c];
                });
              } catch (e) {
                // we're not going to mess with weird encodings,
                // give up and return the undecoded original string
                // see https://github.com/medialize/URI.js/issues/87
                // see https://github.com/medialize/URI.js/issues/92
                return string;
              }
            };
          };
          for (_part in _parts) {
            URI[_part + 'PathSegment'] = generateAccessor('pathname', _parts[_part]);
            URI[_part + 'UrnPathSegment'] = generateAccessor('urnpath', _parts[_part]);
          }
          var generateSegmentedPathFunction = function (_sep, _codingFuncName, _innerCodingFuncName) {
            return function (string) {
              // Why pass in names of functions, rather than the function objects themselves? The
              // definitions of some functions (but in particular, URI.decode) will occasionally change due
              // to URI.js having ISO8859 and Unicode modes. Passing in the name and getting it will ensure
              // that the functions we use here are "fresh".
              var actualCodingFunc;
              if (!_innerCodingFuncName) {
                actualCodingFunc = URI[_codingFuncName];
              } else {
                actualCodingFunc = function (string) {
                  return URI[_codingFuncName](URI[_innerCodingFuncName](string));
                };
              }
              var segments = (string + '').split(_sep);
              for (var i = 0, length = segments.length; i < length; i++) {
                segments[i] = actualCodingFunc(segments[i]);
              }
              return segments.join(_sep);
            };
          };

          // This takes place outside the above loop because we don't want, e.g., encodeUrnPath functions.
          URI.decodePath = generateSegmentedPathFunction('/', 'decodePathSegment');
          URI.decodeUrnPath = generateSegmentedPathFunction(':', 'decodeUrnPathSegment');
          URI.recodePath = generateSegmentedPathFunction('/', 'encodePathSegment', 'decode');
          URI.recodeUrnPath = generateSegmentedPathFunction(':', 'encodeUrnPathSegment', 'decode');
          URI.encodeReserved = generateAccessor('reserved', 'encode');
          URI.parse = function (string, parts) {
            var pos;
            if (!parts) {
              parts = {
                preventInvalidHostname: URI.preventInvalidHostname
              };
            }
            // [protocol"://"[username[":"password]"@"]hostname[":"port]"/"?][path]["?"querystring]["#"fragment]

            // extract fragment
            pos = string.indexOf('#');
            if (pos > -1) {
              // escaping?
              parts.fragment = string.substring(pos + 1) || null;
              string = string.substring(0, pos);
            }

            // extract query
            pos = string.indexOf('?');
            if (pos > -1) {
              // escaping?
              parts.query = string.substring(pos + 1) || null;
              string = string.substring(0, pos);
            }

            // slashes and backslashes have lost all meaning for the web protocols (https, http, wss, ws)
            string = string.replace(/^(https?|ftp|wss?)?:[/\\]*/, '$1://');

            // extract protocol
            if (string.substring(0, 2) === '//') {
              // relative-scheme
              parts.protocol = null;
              string = string.substring(2);
              // extract "user:pass@host:port"
              string = URI.parseAuthority(string, parts);
            } else {
              pos = string.indexOf(':');
              if (pos > -1) {
                parts.protocol = string.substring(0, pos) || null;
                if (parts.protocol && !parts.protocol.match(URI.protocol_expression)) {
                  // : may be within the path
                  parts.protocol = undefined;
                } else if (string.substring(pos + 1, pos + 3).replace(/\\/g, '/') === '//') {
                  string = string.substring(pos + 3);

                  // extract "user:pass@host:port"
                  string = URI.parseAuthority(string, parts);
                } else {
                  string = string.substring(pos + 1);
                  parts.urn = true;
                }
              }
            }

            // what's left must be the path
            parts.path = string;

            // and we're done
            return parts;
          };
          URI.parseHost = function (string, parts) {
            if (!string) {
              string = '';
            }

            // Copy chrome, IE, opera backslash-handling behavior.
            // Back slashes before the query string get converted to forward slashes
            // See: https://github.com/joyent/node/blob/386fd24f49b0e9d1a8a076592a404168faeecc34/lib/url.js#L115-L124
            // See: https://code.google.com/p/chromium/issues/detail?id=25916
            // https://github.com/medialize/URI.js/pull/233
            string = string.replace(/\\/g, '/');

            // extract host:port
            var pos = string.indexOf('/');
            var bracketPos;
            var t;
            if (pos === -1) {
              pos = string.length;
            }
            if (string.charAt(0) === '[') {
              // IPv6 host - http://tools.ietf.org/html/draft-ietf-6man-text-addr-representation-04#section-6
              // I claim most client software breaks on IPv6 anyways. To simplify things, URI only accepts
              // IPv6+port in the format [2001:db8::1]:80 (for the time being)
              bracketPos = string.indexOf(']');
              parts.hostname = string.substring(1, bracketPos) || null;
              parts.port = string.substring(bracketPos + 2, pos) || null;
              if (parts.port === '/') {
                parts.port = null;
              }
            } else {
              var firstColon = string.indexOf(':');
              var firstSlash = string.indexOf('/');
              var nextColon = string.indexOf(':', firstColon + 1);
              if (nextColon !== -1 && (firstSlash === -1 || nextColon < firstSlash)) {
                // IPv6 host contains multiple colons - but no port
                // this notation is actually not allowed by RFC 3986, but we're a liberal parser
                parts.hostname = string.substring(0, pos) || null;
                parts.port = null;
              } else {
                t = string.substring(0, pos).split(':');
                parts.hostname = t[0] || null;
                parts.port = t[1] || null;
              }
            }
            if (parts.hostname && string.substring(pos).charAt(0) !== '/') {
              pos++;
              string = '/' + string;
            }
            if (parts.preventInvalidHostname) {
              URI.ensureValidHostname(parts.hostname, parts.protocol);
            }
            if (parts.port) {
              URI.ensureValidPort(parts.port);
            }
            return string.substring(pos) || '/';
          };
          URI.parseAuthority = function (string, parts) {
            string = URI.parseUserinfo(string, parts);
            return URI.parseHost(string, parts);
          };
          URI.parseUserinfo = function (string, parts) {
            // extract username:password
            var _string = string;
            var firstBackSlash = string.indexOf('\\');
            if (firstBackSlash !== -1) {
              string = string.replace(/\\/g, '/');
            }
            var firstSlash = string.indexOf('/');
            var pos = string.lastIndexOf('@', firstSlash > -1 ? firstSlash : string.length - 1);
            var t;

            // authority@ must come before /path or \path
            if (pos > -1 && (firstSlash === -1 || pos < firstSlash)) {
              t = string.substring(0, pos).split(':');
              parts.username = t[0] ? URI.decode(t[0]) : null;
              t.shift();
              parts.password = t[0] ? URI.decode(t.join(':')) : null;
              string = _string.substring(pos + 1);
            } else {
              parts.username = null;
              parts.password = null;
            }
            return string;
          };
          URI.parseQuery = function (string, escapeQuerySpace) {
            if (!string) {
              return {};
            }

            // throw out the funky business - "?"[name"="value"&"]+
            string = string.replace(/&+/g, '&').replace(/^\?*&*|&+$/g, '');
            if (!string) {
              return {};
            }
            var items = {};
            var splits = string.split('&');
            var length = splits.length;
            var v, name, value;
            for (var i = 0; i < length; i++) {
              v = splits[i].split('=');
              name = URI.decodeQuery(v.shift(), escapeQuerySpace);
              // no "=" is null according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#collect-url-parameters
              value = v.length ? URI.decodeQuery(v.join('='), escapeQuerySpace) : null;
              if (name === '__proto__') {
                // ignore attempt at exploiting JavaScript internals
                continue;
              } else if (hasOwn.call(items, name)) {
                if (typeof items[name] === 'string' || items[name] === null) {
                  items[name] = [items[name]];
                }
                items[name].push(value);
              } else {
                items[name] = value;
              }
            }
            return items;
          };
          URI.build = function (parts) {
            var t = '';
            var requireAbsolutePath = false;
            if (parts.protocol) {
              t += parts.protocol + ':';
            }
            if (!parts.urn && (t || parts.hostname)) {
              t += '//';
              requireAbsolutePath = true;
            }
            t += URI.buildAuthority(parts) || '';
            if (typeof parts.path === 'string') {
              if (parts.path.charAt(0) !== '/' && requireAbsolutePath) {
                t += '/';
              }
              t += parts.path;
            }
            if (typeof parts.query === 'string' && parts.query) {
              t += '?' + parts.query;
            }
            if (typeof parts.fragment === 'string' && parts.fragment) {
              t += '#' + parts.fragment;
            }
            return t;
          };
          URI.buildHost = function (parts) {
            var t = '';
            if (!parts.hostname) {
              return '';
            } else if (URI.ip6_expression.test(parts.hostname)) {
              t += '[' + parts.hostname + ']';
            } else {
              t += parts.hostname;
            }
            if (parts.port) {
              t += ':' + parts.port;
            }
            return t;
          };
          URI.buildAuthority = function (parts) {
            return URI.buildUserinfo(parts) + URI.buildHost(parts);
          };
          URI.buildUserinfo = function (parts) {
            var t = '';
            if (parts.username) {
              t += URI.encode(parts.username);
            }
            if (parts.password) {
              t += ':' + URI.encode(parts.password);
            }
            if (t) {
              t += '@';
            }
            return t;
          };
          URI.buildQuery = function (data, duplicateQueryParameters, escapeQuerySpace) {
            // according to http://tools.ietf.org/html/rfc3986 or http://labs.apache.org/webarch/uri/rfc/rfc3986.html
            // being »-._~!$&'()*+,;=:@/?« %HEX and alnum are allowed
            // the RFC explicitly states ?/foo being a valid use case, no mention of parameter syntax!
            // URI.js treats the query string as being application/x-www-form-urlencoded
            // see http://www.w3.org/TR/REC-html40/interact/forms.html#form-content-type

            var t = '';
            var unique, key, i, length;
            for (key in data) {
              if (key === '__proto__') {
                // ignore attempt at exploiting JavaScript internals
                continue;
              } else if (hasOwn.call(data, key)) {
                if (isArray(data[key])) {
                  unique = {};
                  for (i = 0, length = data[key].length; i < length; i++) {
                    if (data[key][i] !== undefined && unique[data[key][i] + ''] === undefined) {
                      t += '&' + URI.buildQueryParameter(key, data[key][i], escapeQuerySpace);
                      if (duplicateQueryParameters !== true) {
                        unique[data[key][i] + ''] = true;
                      }
                    }
                  }
                } else if (data[key] !== undefined) {
                  t += '&' + URI.buildQueryParameter(key, data[key], escapeQuerySpace);
                }
              }
            }
            return t.substring(1);
          };
          URI.buildQueryParameter = function (name, value, escapeQuerySpace) {
            // http://www.w3.org/TR/REC-html40/interact/forms.html#form-content-type -- application/x-www-form-urlencoded
            // don't append "=" for null values, according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#url-parameter-serialization
            return URI.encodeQuery(name, escapeQuerySpace) + (value !== null ? '=' + URI.encodeQuery(value, escapeQuerySpace) : '');
          };
          URI.addQuery = function (data, name, value) {
            if (typeof name === 'object') {
              for (var key in name) {
                if (hasOwn.call(name, key)) {
                  URI.addQuery(data, key, name[key]);
                }
              }
            } else if (typeof name === 'string') {
              if (data[name] === undefined) {
                data[name] = value;
                return;
              } else if (typeof data[name] === 'string') {
                data[name] = [data[name]];
              }
              if (!isArray(value)) {
                value = [value];
              }
              data[name] = (data[name] || []).concat(value);
            } else {
              throw new TypeError('URI.addQuery() accepts an object, string as the name parameter');
            }
          };
          URI.setQuery = function (data, name, value) {
            if (typeof name === 'object') {
              for (var key in name) {
                if (hasOwn.call(name, key)) {
                  URI.setQuery(data, key, name[key]);
                }
              }
            } else if (typeof name === 'string') {
              data[name] = value === undefined ? null : value;
            } else {
              throw new TypeError('URI.setQuery() accepts an object, string as the name parameter');
            }
          };
          URI.removeQuery = function (data, name, value) {
            var i, length, key;
            if (isArray(name)) {
              for (i = 0, length = name.length; i < length; i++) {
                data[name[i]] = undefined;
              }
            } else if (getType(name) === 'RegExp') {
              for (key in data) {
                if (name.test(key)) {
                  data[key] = undefined;
                }
              }
            } else if (typeof name === 'object') {
              for (key in name) {
                if (hasOwn.call(name, key)) {
                  URI.removeQuery(data, key, name[key]);
                }
              }
            } else if (typeof name === 'string') {
              if (value !== undefined) {
                if (getType(value) === 'RegExp') {
                  if (!isArray(data[name]) && value.test(data[name])) {
                    data[name] = undefined;
                  } else {
                    data[name] = filterArrayValues(data[name], value);
                  }
                } else if (data[name] === String(value) && (!isArray(value) || value.length === 1)) {
                  data[name] = undefined;
                } else if (isArray(data[name])) {
                  data[name] = filterArrayValues(data[name], value);
                }
              } else {
                data[name] = undefined;
              }
            } else {
              throw new TypeError('URI.removeQuery() accepts an object, string, RegExp as the first parameter');
            }
          };
          URI.hasQuery = function (data, name, value, withinArray) {
            switch (getType(name)) {
              case 'String':
                // Nothing to do here
                break;
              case 'RegExp':
                for (var key in data) {
                  if (hasOwn.call(data, key)) {
                    if (name.test(key) && (value === undefined || URI.hasQuery(data, key, value))) {
                      return true;
                    }
                  }
                }
                return false;
              case 'Object':
                for (var _key in name) {
                  if (hasOwn.call(name, _key)) {
                    if (!URI.hasQuery(data, _key, name[_key])) {
                      return false;
                    }
                  }
                }
                return true;
              default:
                throw new TypeError('URI.hasQuery() accepts a string, regular expression or object as the name parameter');
            }
            switch (getType(value)) {
              case 'Undefined':
                // true if exists (but may be empty)
                return name in data;
              // data[name] !== undefined;

              case 'Boolean':
                // true if exists and non-empty
                var _booly = Boolean(isArray(data[name]) ? data[name].length : data[name]);
                return value === _booly;
              case 'Function':
                // allow complex comparison
                return !!value(data[name], name, data);
              case 'Array':
                if (!isArray(data[name])) {
                  return false;
                }
                var op = withinArray ? arrayContains : arraysEqual;
                return op(data[name], value);
              case 'RegExp':
                if (!isArray(data[name])) {
                  return Boolean(data[name] && data[name].match(value));
                }
                if (!withinArray) {
                  return false;
                }
                return arrayContains(data[name], value);
              case 'Number':
                value = String(value);
              /* falls through */
              case 'String':
                if (!isArray(data[name])) {
                  return data[name] === value;
                }
                if (!withinArray) {
                  return false;
                }
                return arrayContains(data[name], value);
              default:
                throw new TypeError('URI.hasQuery() accepts undefined, boolean, string, number, RegExp, Function as the value parameter');
            }
          };
          URI.joinPaths = function () {
            var input = [];
            var segments = [];
            var nonEmptySegments = 0;
            for (var i = 0; i < arguments.length; i++) {
              var url = new URI(arguments[i]);
              input.push(url);
              var _segments = url.segment();
              for (var s = 0; s < _segments.length; s++) {
                if (typeof _segments[s] === 'string') {
                  segments.push(_segments[s]);
                }
                if (_segments[s]) {
                  nonEmptySegments++;
                }
              }
            }
            if (!segments.length || !nonEmptySegments) {
              return new URI('');
            }
            var uri = new URI('').segment(segments);
            if (input[0].path() === '' || input[0].path().slice(0, 1) === '/') {
              uri.path('/' + uri.path());
            }
            return uri.normalize();
          };
          URI.commonPath = function (one, two) {
            var length = Math.min(one.length, two.length);
            var pos;

            // find first non-matching character
            for (pos = 0; pos < length; pos++) {
              if (one.charAt(pos) !== two.charAt(pos)) {
                pos--;
                break;
              }
            }
            if (pos < 1) {
              return one.charAt(0) === two.charAt(0) && one.charAt(0) === '/' ? '/' : '';
            }

            // revert to last /
            if (one.charAt(pos) !== '/' || two.charAt(pos) !== '/') {
              pos = one.substring(0, pos).lastIndexOf('/');
            }
            return one.substring(0, pos + 1);
          };
          URI.withinString = function (string, callback, options) {
            options || (options = {});
            var _start = options.start || URI.findUri.start;
            var _end = options.end || URI.findUri.end;
            var _trim = options.trim || URI.findUri.trim;
            var _parens = options.parens || URI.findUri.parens;
            var _attributeOpen = /[a-z0-9-]=["']?$/i;
            _start.lastIndex = 0;
            while (true) {
              var match = _start.exec(string);
              if (!match) {
                break;
              }
              var start = match.index;
              if (options.ignoreHtml) {
                // attribut(e=["']?$)
                var attributeOpen = string.slice(Math.max(start - 3, 0), start);
                if (attributeOpen && _attributeOpen.test(attributeOpen)) {
                  continue;
                }
              }
              var end = start + string.slice(start).search(_end);
              var slice = string.slice(start, end);
              // make sure we include well balanced parens
              var parensEnd = -1;
              while (true) {
                var parensMatch = _parens.exec(slice);
                if (!parensMatch) {
                  break;
                }
                var parensMatchEnd = parensMatch.index + parensMatch[0].length;
                parensEnd = Math.max(parensEnd, parensMatchEnd);
              }
              if (parensEnd > -1) {
                slice = slice.slice(0, parensEnd) + slice.slice(parensEnd).replace(_trim, '');
              } else {
                slice = slice.replace(_trim, '');
              }
              if (slice.length <= match[0].length) {
                // the extract only contains the starting marker of a URI,
                // e.g. "www" or "http://"
                continue;
              }
              if (options.ignore && options.ignore.test(slice)) {
                continue;
              }
              end = start + slice.length;
              var result = callback(slice, start, end, string);
              if (result === undefined) {
                _start.lastIndex = end;
                continue;
              }
              result = String(result);
              string = string.slice(0, start) + result + string.slice(end);
              _start.lastIndex = start + result.length;
            }
            _start.lastIndex = 0;
            return string;
          };
          URI.ensureValidHostname = function (v, protocol) {
            // Theoretically URIs allow percent-encoding in Hostnames (according to RFC 3986)
            // they are not part of DNS and therefore ignored by URI.js

            var hasHostname = !!v; // not null and not an empty string
            var hasProtocol = !!protocol;
            var rejectEmptyHostname = false;
            if (hasProtocol) {
              rejectEmptyHostname = arrayContains(URI.hostProtocols, protocol);
            }
            if (rejectEmptyHostname && !hasHostname) {
              throw new TypeError('Hostname cannot be empty, if protocol is ' + protocol);
            } else if (v && v.match(URI.invalid_hostname_characters)) {
              // test punycode
              if (!punycode) {
                throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-:_] and Punycode.js is not available');
              }
              if (punycode.toASCII(v).match(URI.invalid_hostname_characters)) {
                throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-:_]');
              }
            }
          };
          URI.ensureValidPort = function (v) {
            if (!v) {
              return;
            }
            var port = Number(v);
            if (isInteger(port) && port > 0 && port < 65536) {
              return;
            }
            throw new TypeError('Port "' + v + '" is not a valid port');
          };

          // noConflict
          URI.noConflict = function (removeAll) {
            if (removeAll) {
              var unconflicted = {
                URI: this.noConflict()
              };
              if (root.URITemplate && typeof root.URITemplate.noConflict === 'function') {
                unconflicted.URITemplate = root.URITemplate.noConflict();
              }
              if (root.IPv6 && typeof root.IPv6.noConflict === 'function') {
                unconflicted.IPv6 = root.IPv6.noConflict();
              }
              if (root.SecondLevelDomains && typeof root.SecondLevelDomains.noConflict === 'function') {
                unconflicted.SecondLevelDomains = root.SecondLevelDomains.noConflict();
              }
              return unconflicted;
            } else if (root.URI === this) {
              root.URI = _URI;
            }
            return this;
          };
          p.build = function (deferBuild) {
            if (deferBuild === true) {
              this._deferred_build = true;
            } else if (deferBuild === undefined || this._deferred_build) {
              this._string = URI.build(this._parts);
              this._deferred_build = false;
            }
            return this;
          };
          p.clone = function () {
            return new URI(this);
          };
          p.valueOf = p.toString = function () {
            return this.build(false)._string;
          };
          function generateSimpleAccessor(_part) {
            return function (v, build) {
              if (v === undefined) {
                return this._parts[_part] || '';
              } else {
                this._parts[_part] = v || null;
                this.build(!build);
                return this;
              }
            };
          }
          function generatePrefixAccessor(_part, _key) {
            return function (v, build) {
              if (v === undefined) {
                return this._parts[_part] || '';
              } else {
                if (v !== null) {
                  v = v + '';
                  if (v.charAt(0) === _key) {
                    v = v.substring(1);
                  }
                }
                this._parts[_part] = v;
                this.build(!build);
                return this;
              }
            };
          }
          p.protocol = generateSimpleAccessor('protocol');
          p.username = generateSimpleAccessor('username');
          p.password = generateSimpleAccessor('password');
          p.hostname = generateSimpleAccessor('hostname');
          p.port = generateSimpleAccessor('port');
          p.query = generatePrefixAccessor('query', '?');
          p.fragment = generatePrefixAccessor('fragment', '#');
          p.search = function (v, build) {
            var t = this.query(v, build);
            return typeof t === 'string' && t.length ? '?' + t : t;
          };
          p.hash = function (v, build) {
            var t = this.fragment(v, build);
            return typeof t === 'string' && t.length ? '#' + t : t;
          };
          p.pathname = function (v, build) {
            if (v === undefined || v === true) {
              var res = this._parts.path || (this._parts.hostname ? '/' : '');
              return v ? (this._parts.urn ? URI.decodeUrnPath : URI.decodePath)(res) : res;
            } else {
              if (this._parts.urn) {
                this._parts.path = v ? URI.recodeUrnPath(v) : '';
              } else {
                this._parts.path = v ? URI.recodePath(v) : '/';
              }
              this.build(!build);
              return this;
            }
          };
          p.path = p.pathname;
          p.href = function (href, build) {
            var key;
            if (href === undefined) {
              return this.toString();
            }
            this._string = '';
            this._parts = URI._parts();
            var _URI = href instanceof URI;
            var _object = typeof href === 'object' && (href.hostname || href.path || href.pathname);
            if (href.nodeName) {
              var attribute = URI.getDomAttribute(href);
              href = href[attribute] || '';
              _object = false;
            }

            // window.location is reported to be an object, but it's not the sort
            // of object we're looking for:
            // * location.protocol ends with a colon
            // * location.query != object.search
            // * location.hash != object.fragment
            // simply serializing the unknown object should do the trick
            // (for location, not for everything...)
            if (!_URI && _object && href.pathname !== undefined) {
              href = href.toString();
            }
            if (typeof href === 'string' || href instanceof String) {
              this._parts = URI.parse(String(href), this._parts);
            } else if (_URI || _object) {
              var src = _URI ? href._parts : href;
              for (key in src) {
                if (key === 'query') {
                  continue;
                }
                if (hasOwn.call(this._parts, key)) {
                  this._parts[key] = src[key];
                }
              }
              if (src.query) {
                this.query(src.query, false);
              }
            } else {
              throw new TypeError('invalid input');
            }
            this.build(!build);
            return this;
          };

          // identification accessors
          p.is = function (what) {
            var ip = false;
            var ip4 = false;
            var ip6 = false;
            var name = false;
            var sld = false;
            var idn = false;
            var punycode = false;
            var relative = !this._parts.urn;
            if (this._parts.hostname) {
              relative = false;
              ip4 = URI.ip4_expression.test(this._parts.hostname);
              ip6 = URI.ip6_expression.test(this._parts.hostname);
              ip = ip4 || ip6;
              name = !ip;
              sld = name && SLD && SLD.has(this._parts.hostname);
              idn = name && URI.idn_expression.test(this._parts.hostname);
              punycode = name && URI.punycode_expression.test(this._parts.hostname);
            }
            switch (what.toLowerCase()) {
              case 'relative':
                return relative;
              case 'absolute':
                return !relative;

              // hostname identification
              case 'domain':
              case 'name':
                return name;
              case 'sld':
                return sld;
              case 'ip':
                return ip;
              case 'ip4':
              case 'ipv4':
              case 'inet4':
                return ip4;
              case 'ip6':
              case 'ipv6':
              case 'inet6':
                return ip6;
              case 'idn':
                return idn;
              case 'url':
                return !this._parts.urn;
              case 'urn':
                return !!this._parts.urn;
              case 'punycode':
                return punycode;
            }
            return null;
          };

          // component specific input validation
          var _protocol = p.protocol;
          var _port = p.port;
          var _hostname = p.hostname;
          p.protocol = function (v, build) {
            if (v) {
              // accept trailing ://
              v = v.replace(/:(\/\/)?$/, '');
              if (!v.match(URI.protocol_expression)) {
                throw new TypeError('Protocol "' + v + '" contains characters other than [A-Z0-9.+-] or doesn\'t start with [A-Z]');
              }
            }
            return _protocol.call(this, v, build);
          };
          p.scheme = p.protocol;
          p.port = function (v, build) {
            if (this._parts.urn) {
              return v === undefined ? '' : this;
            }
            if (v !== undefined) {
              if (v === 0) {
                v = null;
              }
              if (v) {
                v += '';
                if (v.charAt(0) === ':') {
                  v = v.substring(1);
                }
                URI.ensureValidPort(v);
              }
            }
            return _port.call(this, v, build);
          };
          p.hostname = function (v, build) {
            if (this._parts.urn) {
              return v === undefined ? '' : this;
            }
            if (v !== undefined) {
              var x = {
                preventInvalidHostname: this._parts.preventInvalidHostname
              };
              var res = URI.parseHost(v, x);
              if (res !== '/') {
                throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
              }
              v = x.hostname;
              if (this._parts.preventInvalidHostname) {
                URI.ensureValidHostname(v, this._parts.protocol);
              }
            }
            return _hostname.call(this, v, build);
          };

          // compound accessors
          p.origin = function (v, build) {
            if (this._parts.urn) {
              return v === undefined ? '' : this;
            }
            if (v === undefined) {
              var protocol = this.protocol();
              var authority = this.authority();
              if (!authority) {
                return '';
              }
              return (protocol ? protocol + '://' : '') + this.authority();
            } else {
              var origin = URI(v);
              this.protocol(origin.protocol()).authority(origin.authority()).build(!build);
              return this;
            }
          };
          p.host = function (v, build) {
            if (this._parts.urn) {
              return v === undefined ? '' : this;
            }
            if (v === undefined) {
              return this._parts.hostname ? URI.buildHost(this._parts) : '';
            } else {
              var res = URI.parseHost(v, this._parts);
              if (res !== '/') {
                throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
              }
              this.build(!build);
              return this;
            }
          };
          p.authority = function (v, build) {
            if (this._parts.urn) {
              return v === undefined ? '' : this;
            }
            if (v === undefined) {
              return this._parts.hostname ? URI.buildAuthority(this._parts) : '';
            } else {
              var res = URI.parseAuthority(v, this._parts);
              if (res !== '/') {
                throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
              }
              this.build(!build);
              return this;
            }
          };
          p.userinfo = function (v, build) {
            if (this._parts.urn) {
              return v === undefined ? '' : this;
            }
            if (v === undefined) {
              var t = URI.buildUserinfo(this._parts);
              return t ? t.substring(0, t.length - 1) : t;
            } else {
              if (v[v.length - 1] !== '@') {
                v += '@';
              }
              URI.parseUserinfo(v, this._parts);
              this.build(!build);
              return this;
            }
          };
          p.resource = function (v, build) {
            var parts;
            if (v === undefined) {
              return this.path() + this.search() + this.hash();
            }
            parts = URI.parse(v);
            this._parts.path = parts.path;
            this._parts.query = parts.query;
            this._parts.fragment = parts.fragment;
            this.build(!build);
            return this;
          };

          // fraction accessors
          p.subdomain = function (v, build) {
            if (this._parts.urn) {
              return v === undefined ? '' : this;
            }

            // convenience, return "www" from "www.example.org"
            if (v === undefined) {
              if (!this._parts.hostname || this.is('IP')) {
                return '';
              }

              // grab domain and add another segment
              var end = this._parts.hostname.length - this.domain().length - 1;
              return this._parts.hostname.substring(0, end) || '';
            } else {
              var e = this._parts.hostname.length - this.domain().length;
              var sub = this._parts.hostname.substring(0, e);
              var replace = new RegExp('^' + escapeRegEx(sub));
              if (v && v.charAt(v.length - 1) !== '.') {
                v += '.';
              }
              if (v.indexOf(':') !== -1) {
                throw new TypeError('Domains cannot contain colons');
              }
              if (v) {
                URI.ensureValidHostname(v, this._parts.protocol);
              }
              this._parts.hostname = this._parts.hostname.replace(replace, v);
              this.build(!build);
              return this;
            }
          };
          p.domain = function (v, build) {
            if (this._parts.urn) {
              return v === undefined ? '' : this;
            }
            if (typeof v === 'boolean') {
              build = v;
              v = undefined;
            }

            // convenience, return "example.org" from "www.example.org"
            if (v === undefined) {
              if (!this._parts.hostname || this.is('IP')) {
                return '';
              }

              // if hostname consists of 1 or 2 segments, it must be the domain
              var t = this._parts.hostname.match(/\./g);
              if (t && t.length < 2) {
                return this._parts.hostname;
              }

              // grab tld and add another segment
              var end = this._parts.hostname.length - this.tld(build).length - 1;
              end = this._parts.hostname.lastIndexOf('.', end - 1) + 1;
              return this._parts.hostname.substring(end) || '';
            } else {
              if (!v) {
                throw new TypeError('cannot set domain empty');
              }
              if (v.indexOf(':') !== -1) {
                throw new TypeError('Domains cannot contain colons');
              }
              URI.ensureValidHostname(v, this._parts.protocol);
              if (!this._parts.hostname || this.is('IP')) {
                this._parts.hostname = v;
              } else {
                var replace = new RegExp(escapeRegEx(this.domain()) + '$');
                this._parts.hostname = this._parts.hostname.replace(replace, v);
              }
              this.build(!build);
              return this;
            }
          };
          p.tld = function (v, build) {
            if (this._parts.urn) {
              return v === undefined ? '' : this;
            }
            if (typeof v === 'boolean') {
              build = v;
              v = undefined;
            }

            // return "org" from "www.example.org"
            if (v === undefined) {
              if (!this._parts.hostname || this.is('IP')) {
                return '';
              }
              var pos = this._parts.hostname.lastIndexOf('.');
              var tld = this._parts.hostname.substring(pos + 1);
              if (build !== true && SLD && SLD.list[tld.toLowerCase()]) {
                return SLD.get(this._parts.hostname) || tld;
              }
              return tld;
            } else {
              var replace;
              if (!v) {
                throw new TypeError('cannot set TLD empty');
              } else if (v.match(/[^a-zA-Z0-9-]/)) {
                if (SLD && SLD.is(v)) {
                  replace = new RegExp(escapeRegEx(this.tld()) + '$');
                  this._parts.hostname = this._parts.hostname.replace(replace, v);
                } else {
                  throw new TypeError('TLD "' + v + '" contains characters other than [A-Z0-9]');
                }
              } else if (!this._parts.hostname || this.is('IP')) {
                throw new ReferenceError('cannot set TLD on non-domain host');
              } else {
                replace = new RegExp(escapeRegEx(this.tld()) + '$');
                this._parts.hostname = this._parts.hostname.replace(replace, v);
              }
              this.build(!build);
              return this;
            }
          };
          p.directory = function (v, build) {
            if (this._parts.urn) {
              return v === undefined ? '' : this;
            }
            if (v === undefined || v === true) {
              if (!this._parts.path && !this._parts.hostname) {
                return '';
              }
              if (this._parts.path === '/') {
                return '/';
              }
              var end = this._parts.path.length - this.filename().length - 1;
              var res = this._parts.path.substring(0, end) || (this._parts.hostname ? '/' : '');
              return v ? URI.decodePath(res) : res;
            } else {
              var e = this._parts.path.length - this.filename().length;
              var directory = this._parts.path.substring(0, e);
              var replace = new RegExp('^' + escapeRegEx(directory));

              // fully qualifier directories begin with a slash
              if (!this.is('relative')) {
                if (!v) {
                  v = '/';
                }
                if (v.charAt(0) !== '/') {
                  v = '/' + v;
                }
              }

              // directories always end with a slash
              if (v && v.charAt(v.length - 1) !== '/') {
                v += '/';
              }
              v = URI.recodePath(v);
              this._parts.path = this._parts.path.replace(replace, v);
              this.build(!build);
              return this;
            }
          };
          p.filename = function (v, build) {
            if (this._parts.urn) {
              return v === undefined ? '' : this;
            }
            if (typeof v !== 'string') {
              if (!this._parts.path || this._parts.path === '/') {
                return '';
              }
              var pos = this._parts.path.lastIndexOf('/');
              var res = this._parts.path.substring(pos + 1);
              return v ? URI.decodePathSegment(res) : res;
            } else {
              var mutatedDirectory = false;
              if (v.charAt(0) === '/') {
                v = v.substring(1);
              }
              if (v.match(/\.?\//)) {
                mutatedDirectory = true;
              }
              var replace = new RegExp(escapeRegEx(this.filename()) + '$');
              v = URI.recodePath(v);
              this._parts.path = this._parts.path.replace(replace, v);
              if (mutatedDirectory) {
                this.normalizePath(build);
              } else {
                this.build(!build);
              }
              return this;
            }
          };
          p.suffix = function (v, build) {
            if (this._parts.urn) {
              return v === undefined ? '' : this;
            }
            if (v === undefined || v === true) {
              if (!this._parts.path || this._parts.path === '/') {
                return '';
              }
              var filename = this.filename();
              var pos = filename.lastIndexOf('.');
              var s, res;
              if (pos === -1) {
                return '';
              }

              // suffix may only contain alnum characters (yup, I made this up.)
              s = filename.substring(pos + 1);
              res = /^[a-z0-9%]+$/i.test(s) ? s : '';
              return v ? URI.decodePathSegment(res) : res;
            } else {
              if (v.charAt(0) === '.') {
                v = v.substring(1);
              }
              var suffix = this.suffix();
              var replace;
              if (!suffix) {
                if (!v) {
                  return this;
                }
                this._parts.path += '.' + URI.recodePath(v);
              } else if (!v) {
                replace = new RegExp(escapeRegEx('.' + suffix) + '$');
              } else {
                replace = new RegExp(escapeRegEx(suffix) + '$');
              }
              if (replace) {
                v = URI.recodePath(v);
                this._parts.path = this._parts.path.replace(replace, v);
              }
              this.build(!build);
              return this;
            }
          };
          p.segment = function (segment, v, build) {
            var separator = this._parts.urn ? ':' : '/';
            var path = this.path();
            var absolute = path.substring(0, 1) === '/';
            var segments = path.split(separator);
            if (segment !== undefined && typeof segment !== 'number') {
              build = v;
              v = segment;
              segment = undefined;
            }
            if (segment !== undefined && typeof segment !== 'number') {
              throw new Error('Bad segment "' + segment + '", must be 0-based integer');
            }
            if (absolute) {
              segments.shift();
            }
            if (segment < 0) {
              // allow negative indexes to address from the end
              segment = Math.max(segments.length + segment, 0);
            }
            if (v === undefined) {
              /*jshint laxbreak: true */
              return segment === undefined ? segments : segments[segment];
              /*jshint laxbreak: false */
            } else if (segment === null || segments[segment] === undefined) {
              if (isArray(v)) {
                segments = [];
                // collapse empty elements within array
                for (var i = 0, l = v.length; i < l; i++) {
                  if (!v[i].length && (!segments.length || !segments[segments.length - 1].length)) {
                    continue;
                  }
                  if (segments.length && !segments[segments.length - 1].length) {
                    segments.pop();
                  }
                  segments.push(trimSlashes(v[i]));
                }
              } else if (v || typeof v === 'string') {
                v = trimSlashes(v);
                if (segments[segments.length - 1] === '') {
                  // empty trailing elements have to be overwritten
                  // to prevent results such as /foo//bar
                  segments[segments.length - 1] = v;
                } else {
                  segments.push(v);
                }
              }
            } else {
              if (v) {
                segments[segment] = trimSlashes(v);
              } else {
                segments.splice(segment, 1);
              }
            }
            if (absolute) {
              segments.unshift('');
            }
            return this.path(segments.join(separator), build);
          };
          p.segmentCoded = function (segment, v, build) {
            var segments, i, l;
            if (typeof segment !== 'number') {
              build = v;
              v = segment;
              segment = undefined;
            }
            if (v === undefined) {
              segments = this.segment(segment, v, build);
              if (!isArray(segments)) {
                segments = segments !== undefined ? URI.decode(segments) : undefined;
              } else {
                for (i = 0, l = segments.length; i < l; i++) {
                  segments[i] = URI.decode(segments[i]);
                }
              }
              return segments;
            }
            if (!isArray(v)) {
              v = typeof v === 'string' || v instanceof String ? URI.encode(v) : v;
            } else {
              for (i = 0, l = v.length; i < l; i++) {
                v[i] = URI.encode(v[i]);
              }
            }
            return this.segment(segment, v, build);
          };

          // mutating query string
          var q = p.query;
          p.query = function (v, build) {
            if (v === true) {
              return URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
            } else if (typeof v === 'function') {
              var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
              var result = v.call(this, data);
              this._parts.query = URI.buildQuery(result || data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
              this.build(!build);
              return this;
            } else if (v !== undefined && typeof v !== 'string') {
              this._parts.query = URI.buildQuery(v, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
              this.build(!build);
              return this;
            } else {
              return q.call(this, v, build);
            }
          };
          p.setQuery = function (name, value, build) {
            var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
            if (typeof name === 'string' || name instanceof String) {
              data[name] = value !== undefined ? value : null;
            } else if (typeof name === 'object') {
              for (var key in name) {
                if (hasOwn.call(name, key)) {
                  data[key] = name[key];
                }
              }
            } else {
              throw new TypeError('URI.addQuery() accepts an object, string as the name parameter');
            }
            this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
            if (typeof name !== 'string') {
              build = value;
            }
            this.build(!build);
            return this;
          };
          p.addQuery = function (name, value, build) {
            var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
            URI.addQuery(data, name, value === undefined ? null : value);
            this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
            if (typeof name !== 'string') {
              build = value;
            }
            this.build(!build);
            return this;
          };
          p.removeQuery = function (name, value, build) {
            var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
            URI.removeQuery(data, name, value);
            this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
            if (typeof name !== 'string') {
              build = value;
            }
            this.build(!build);
            return this;
          };
          p.hasQuery = function (name, value, withinArray) {
            var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
            return URI.hasQuery(data, name, value, withinArray);
          };
          p.setSearch = p.setQuery;
          p.addSearch = p.addQuery;
          p.removeSearch = p.removeQuery;
          p.hasSearch = p.hasQuery;

          // sanitizing URLs
          p.normalize = function () {
            if (this._parts.urn) {
              return this.normalizeProtocol(false).normalizePath(false).normalizeQuery(false).normalizeFragment(false).build();
            }
            return this.normalizeProtocol(false).normalizeHostname(false).normalizePort(false).normalizePath(false).normalizeQuery(false).normalizeFragment(false).build();
          };
          p.normalizeProtocol = function (build) {
            if (typeof this._parts.protocol === 'string') {
              this._parts.protocol = this._parts.protocol.toLowerCase();
              this.build(!build);
            }
            return this;
          };
          p.normalizeHostname = function (build) {
            if (this._parts.hostname) {
              if (this.is('IDN') && punycode) {
                this._parts.hostname = punycode.toASCII(this._parts.hostname);
              } else if (this.is('IPv6') && IPv6) {
                this._parts.hostname = IPv6.best(this._parts.hostname);
              }
              this._parts.hostname = this._parts.hostname.toLowerCase();
              this.build(!build);
            }
            return this;
          };
          p.normalizePort = function (build) {
            // remove port of it's the protocol's default
            if (typeof this._parts.protocol === 'string' && this._parts.port === URI.defaultPorts[this._parts.protocol]) {
              this._parts.port = null;
              this.build(!build);
            }
            return this;
          };
          p.normalizePath = function (build) {
            var _path = this._parts.path;
            if (!_path) {
              return this;
            }
            if (this._parts.urn) {
              this._parts.path = URI.recodeUrnPath(this._parts.path);
              this.build(!build);
              return this;
            }
            if (this._parts.path === '/') {
              return this;
            }
            _path = URI.recodePath(_path);
            var _was_relative;
            var _leadingParents = '';
            var _parent, _pos;

            // handle relative paths
            if (_path.charAt(0) !== '/') {
              _was_relative = true;
              _path = '/' + _path;
            }

            // handle relative files (as opposed to directories)
            if (_path.slice(-3) === '/..' || _path.slice(-2) === '/.') {
              _path += '/';
            }

            // resolve simples
            _path = _path.replace(/(\/(\.\/)+)|(\/\.$)/g, '/').replace(/\/{2,}/g, '/');

            // remember leading parents
            if (_was_relative) {
              _leadingParents = _path.substring(1).match(/^(\.\.\/)+/) || '';
              if (_leadingParents) {
                _leadingParents = _leadingParents[0];
              }
            }

            // resolve parents
            while (true) {
              _parent = _path.search(/\/\.\.(\/|$)/);
              if (_parent === -1) {
                // no more ../ to resolve
                break;
              } else if (_parent === 0) {
                // top level cannot be relative, skip it
                _path = _path.substring(3);
                continue;
              }
              _pos = _path.substring(0, _parent).lastIndexOf('/');
              if (_pos === -1) {
                _pos = _parent;
              }
              _path = _path.substring(0, _pos) + _path.substring(_parent + 3);
            }

            // revert to relative
            if (_was_relative && this.is('relative')) {
              _path = _leadingParents + _path.substring(1);
            }
            this._parts.path = _path;
            this.build(!build);
            return this;
          };
          p.normalizePathname = p.normalizePath;
          p.normalizeQuery = function (build) {
            if (typeof this._parts.query === 'string') {
              if (!this._parts.query.length) {
                this._parts.query = null;
              } else {
                this.query(URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace));
              }
              this.build(!build);
            }
            return this;
          };
          p.normalizeFragment = function (build) {
            if (!this._parts.fragment) {
              this._parts.fragment = null;
              this.build(!build);
            }
            return this;
          };
          p.normalizeSearch = p.normalizeQuery;
          p.normalizeHash = p.normalizeFragment;
          p.iso8859 = function () {
            // expect unicode input, iso8859 output
            var e = URI.encode;
            var d = URI.decode;
            URI.encode = escape;
            URI.decode = decodeURIComponent;
            try {
              this.normalize();
            } finally {
              URI.encode = e;
              URI.decode = d;
            }
            return this;
          };
          p.unicode = function () {
            // expect iso8859 input, unicode output
            var e = URI.encode;
            var d = URI.decode;
            URI.encode = strictEncodeURIComponent;
            URI.decode = unescape;
            try {
              this.normalize();
            } finally {
              URI.encode = e;
              URI.decode = d;
            }
            return this;
          };
          p.readable = function () {
            var uri = this.clone();
            // removing username, password, because they shouldn't be displayed according to RFC 3986
            uri.username('').password('').normalize();
            var t = '';
            if (uri._parts.protocol) {
              t += uri._parts.protocol + '://';
            }
            if (uri._parts.hostname) {
              if (uri.is('punycode') && punycode) {
                t += punycode.toUnicode(uri._parts.hostname);
                if (uri._parts.port) {
                  t += ':' + uri._parts.port;
                }
              } else {
                t += uri.host();
              }
            }
            if (uri._parts.hostname && uri._parts.path && uri._parts.path.charAt(0) !== '/') {
              t += '/';
            }
            t += uri.path(true);
            if (uri._parts.query) {
              var q = '';
              for (var i = 0, qp = uri._parts.query.split('&'), l = qp.length; i < l; i++) {
                var kv = (qp[i] || '').split('=');
                q += '&' + URI.decodeQuery(kv[0], this._parts.escapeQuerySpace).replace(/&/g, '%26');
                if (kv[1] !== undefined) {
                  q += '=' + URI.decodeQuery(kv[1], this._parts.escapeQuerySpace).replace(/&/g, '%26');
                }
              }
              t += '?' + q.substring(1);
            }
            t += URI.decodeQuery(uri.hash(), true);
            return t;
          };

          // resolving relative and absolute URLs
          p.absoluteTo = function (base) {
            var resolved = this.clone();
            var properties = ['protocol', 'username', 'password', 'hostname', 'port'];
            var basedir, i, p;
            if (this._parts.urn) {
              throw new Error('URNs do not have any generally defined hierarchical components');
            }
            if (!(base instanceof URI)) {
              base = new URI(base);
            }
            if (resolved._parts.protocol) {
              // Directly returns even if this._parts.hostname is empty.
              return resolved;
            } else {
              resolved._parts.protocol = base._parts.protocol;
            }
            if (this._parts.hostname) {
              return resolved;
            }
            for (i = 0; p = properties[i]; i++) {
              resolved._parts[p] = base._parts[p];
            }
            if (!resolved._parts.path) {
              resolved._parts.path = base._parts.path;
              if (!resolved._parts.query) {
                resolved._parts.query = base._parts.query;
              }
            } else {
              if (resolved._parts.path.substring(-2) === '..') {
                resolved._parts.path += '/';
              }
              if (resolved.path().charAt(0) !== '/') {
                basedir = base.directory();
                basedir = basedir ? basedir : base.path().indexOf('/') === 0 ? '/' : '';
                resolved._parts.path = (basedir ? basedir + '/' : '') + resolved._parts.path;
                resolved.normalizePath();
              }
            }
            resolved.build();
            return resolved;
          };
          p.relativeTo = function (base) {
            var relative = this.clone().normalize();
            var relativeParts, baseParts, common, relativePath, basePath;
            if (relative._parts.urn) {
              throw new Error('URNs do not have any generally defined hierarchical components');
            }
            base = new URI(base).normalize();
            relativeParts = relative._parts;
            baseParts = base._parts;
            relativePath = relative.path();
            basePath = base.path();
            if (relativePath.charAt(0) !== '/') {
              throw new Error('URI is already relative');
            }
            if (basePath.charAt(0) !== '/') {
              throw new Error('Cannot calculate a URI relative to another relative URI');
            }
            if (relativeParts.protocol === baseParts.protocol) {
              relativeParts.protocol = null;
            }
            if (relativeParts.username !== baseParts.username || relativeParts.password !== baseParts.password) {
              return relative.build();
            }
            if (relativeParts.protocol !== null || relativeParts.username !== null || relativeParts.password !== null) {
              return relative.build();
            }
            if (relativeParts.hostname === baseParts.hostname && relativeParts.port === baseParts.port) {
              relativeParts.hostname = null;
              relativeParts.port = null;
            } else {
              return relative.build();
            }
            if (relativePath === basePath) {
              relativeParts.path = '';
              return relative.build();
            }

            // determine common sub path
            common = URI.commonPath(relativePath, basePath);

            // If the paths have nothing in common, return a relative URL with the absolute path.
            if (!common) {
              return relative.build();
            }
            var parents = baseParts.path.substring(common.length).replace(/[^\/]*$/, '').replace(/.*?\//g, '../');
            relativeParts.path = parents + relativeParts.path.substring(common.length) || './';
            return relative.build();
          };

          // comparing URIs
          p.equals = function (uri) {
            var one = this.clone();
            var two = new URI(uri);
            var one_map = {};
            var two_map = {};
            var checked = {};
            var one_query, two_query, key;
            one.normalize();
            two.normalize();

            // exact match
            if (one.toString() === two.toString()) {
              return true;
            }

            // extract query string
            one_query = one.query();
            two_query = two.query();
            one.query('');
            two.query('');

            // definitely not equal if not even non-query parts match
            if (one.toString() !== two.toString()) {
              return false;
            }

            // query parameters have the same length, even if they're permuted
            if (one_query.length !== two_query.length) {
              return false;
            }
            one_map = URI.parseQuery(one_query, this._parts.escapeQuerySpace);
            two_map = URI.parseQuery(two_query, this._parts.escapeQuerySpace);
            for (key in one_map) {
              if (hasOwn.call(one_map, key)) {
                if (!isArray(one_map[key])) {
                  if (one_map[key] !== two_map[key]) {
                    return false;
                  }
                } else if (!arraysEqual(one_map[key], two_map[key])) {
                  return false;
                }
                checked[key] = true;
              }
            }
            for (key in two_map) {
              if (hasOwn.call(two_map, key)) {
                if (!checked[key]) {
                  // two contains a parameter not present in one
                  return false;
                }
              }
            }
            return true;
          };

          // state
          p.preventInvalidHostname = function (v) {
            this._parts.preventInvalidHostname = !!v;
            return this;
          };
          p.duplicateQueryParameters = function (v) {
            this._parts.duplicateQueryParameters = !!v;
            return this;
          };
          p.escapeQuerySpace = function (v) {
            this._parts.escapeQuerySpace = !!v;
            return this;
          };
          return URI;
        });

        /***/
      }),
      /***/"./node_modules/urijs/src/punycode.js": (
      /*!********************************************!*\
        !*** ./node_modules/urijs/src/punycode.js ***!
        \********************************************/
      /***/
      function (module, exports, __webpack_require__) {
        /* module decorator */module = __webpack_require__.nmd(module);
        var __WEBPACK_AMD_DEFINE_RESULT__; /*! https://mths.be/punycode v1.4.0 by @mathias */
        ;
        (function (root) {
          /** Detect free variables */
          var freeExports = true && exports && !exports.nodeType && exports;
          var freeModule = true && module && !module.nodeType && module;
          var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g;
          if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) {
            root = freeGlobal;
          }

          /**
           * The `punycode` object.
           * @name punycode
           * @type Object
           */
          var punycode,
            /** Highest positive signed 32-bit float value */
            maxInt = 2147483647,
            // aka. 0x7FFFFFFF or 2^31-1

            /** Bootstring parameters */
            base = 36,
            tMin = 1,
            tMax = 26,
            skew = 38,
            damp = 700,
            initialBias = 72,
            initialN = 128,
            // 0x80
            delimiter = '-',
            // '\x2D'

            /** Regular expressions */
            regexPunycode = /^xn--/,
            regexNonASCII = /[^\x20-\x7E]/,
            // unprintable ASCII chars + non-ASCII chars
            regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g,
            // RFC 3490 separators

            /** Error messages */
            errors = {
              'overflow': 'Overflow: input needs wider integers to process',
              'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
              'invalid-input': 'Invalid input'
            },
            /** Convenience shortcuts */
            baseMinusTMin = base - tMin,
            floor = Math.floor,
            stringFromCharCode = String.fromCharCode,
            /** Temporary variable */
            key;

          /*--------------------------------------------------------------------------*/

          /**
           * A generic error utility function.
           * @private
           * @param {String} type The error type.
           * @returns {Error} Throws a `RangeError` with the applicable error message.
           */
          function error(type) {
            throw new RangeError(errors[type]);
          }

          /**
           * A generic `Array#map` utility function.
           * @private
           * @param {Array} array The array to iterate over.
           * @param {Function} callback The function that gets called for every array
           * item.
           * @returns {Array} A new array of values returned by the callback function.
           */
          function map(array, fn) {
            var length = array.length;
            var result = [];
            while (length--) {
              result[length] = fn(array[length]);
            }
            return result;
          }

          /**
           * A simple `Array#map`-like wrapper to work with domain name strings or email
           * addresses.
           * @private
           * @param {String} domain The domain name or email address.
           * @param {Function} callback The function that gets called for every
           * character.
           * @returns {Array} A new string of characters returned by the callback
           * function.
           */
          function mapDomain(string, fn) {
            var parts = string.split('@');
            var result = '';
            if (parts.length > 1) {
              // In email addresses, only the domain name should be punycoded. Leave
              // the local part (i.e. everything up to `@`) intact.
              result = parts[0] + '@';
              string = parts[1];
            }
            // Avoid `split(regex)` for IE8 compatibility. See #17.
            string = string.replace(regexSeparators, '\x2E');
            var labels = string.split('.');
            var encoded = map(labels, fn).join('.');
            return result + encoded;
          }

          /**
           * Creates an array containing the numeric code points of each Unicode
           * character in the string. While JavaScript uses UCS-2 internally,
           * this function will convert a pair of surrogate halves (each of which
           * UCS-2 exposes as separate characters) into a single code point,
           * matching UTF-16.
           * @see `punycode.ucs2.encode`
           * @see <https://mathiasbynens.be/notes/javascript-encoding>
           * @memberOf punycode.ucs2
           * @name decode
           * @param {String} string The Unicode input string (UCS-2).
           * @returns {Array} The new array of code points.
           */
          function ucs2decode(string) {
            var output = [],
              counter = 0,
              length = string.length,
              value,
              extra;
            while (counter < length) {
              value = string.charCodeAt(counter++);
              if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) {
                  // low surrogate
                  output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                } else {
                  // unmatched surrogate; only append this code unit, in case the next
                  // code unit is the high surrogate of a surrogate pair
                  output.push(value);
                  counter--;
                }
              } else {
                output.push(value);
              }
            }
            return output;
          }

          /**
           * Creates a string based on an array of numeric code points.
           * @see `punycode.ucs2.decode`
           * @memberOf punycode.ucs2
           * @name encode
           * @param {Array} codePoints The array of numeric code points.
           * @returns {String} The new Unicode string (UCS-2).
           */
          function ucs2encode(array) {
            return map(array, function (value) {
              var output = '';
              if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
              }
              output += stringFromCharCode(value);
              return output;
            }).join('');
          }

          /**
           * Converts a basic code point into a digit/integer.
           * @see `digitToBasic()`
           * @private
           * @param {Number} codePoint The basic numeric code point value.
           * @returns {Number} The numeric value of a basic code point (for use in
           * representing integers) in the range `0` to `base - 1`, or `base` if
           * the code point does not represent a value.
           */
          function basicToDigit(codePoint) {
            if (codePoint - 48 < 10) {
              return codePoint - 22;
            }
            if (codePoint - 65 < 26) {
              return codePoint - 65;
            }
            if (codePoint - 97 < 26) {
              return codePoint - 97;
            }
            return base;
          }

          /**
           * Converts a digit/integer into a basic code point.
           * @see `basicToDigit()`
           * @private
           * @param {Number} digit The numeric value of a basic code point.
           * @returns {Number} The basic code point whose value (when used for
           * representing integers) is `digit`, which needs to be in the range
           * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
           * used; else, the lowercase form is used. The behavior is undefined
           * if `flag` is non-zero and `digit` has no uppercase form.
           */
          function digitToBasic(digit, flag) {
            //  0..25 map to ASCII a..z or A..Z
            // 26..35 map to ASCII 0..9
            return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
          }

          /**
           * Bias adaptation function as per section 3.4 of RFC 3492.
           * https://tools.ietf.org/html/rfc3492#section-3.4
           * @private
           */
          function adapt(delta, numPoints, firstTime) {
            var k = 0;
            delta = firstTime ? floor(delta / damp) : delta >> 1;
            delta += floor(delta / numPoints);
            for /* no initialization */
            (; delta > baseMinusTMin * tMax >> 1; k += base) {
              delta = floor(delta / baseMinusTMin);
            }
            return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
          }

          /**
           * Converts a Punycode string of ASCII-only symbols to a string of Unicode
           * symbols.
           * @memberOf punycode
           * @param {String} input The Punycode string of ASCII-only symbols.
           * @returns {String} The resulting string of Unicode symbols.
           */
          function decode(input) {
            // Don't use UCS-2
            var output = [],
              inputLength = input.length,
              out,
              i = 0,
              n = initialN,
              bias = initialBias,
              basic,
              j,
              index,
              oldi,
              w,
              k,
              digit,
              t,
              /** Cached calculation results */
              baseMinusT;

            // Handle the basic code points: let `basic` be the number of input code
            // points before the last delimiter, or `0` if there is none, then copy
            // the first basic code points to the output.

            basic = input.lastIndexOf(delimiter);
            if (basic < 0) {
              basic = 0;
            }
            for (j = 0; j < basic; ++j) {
              // if it's not a basic code point
              if (input.charCodeAt(j) >= 0x80) {
                error('not-basic');
              }
              output.push(input.charCodeAt(j));
            }

            // Main decoding loop: start just after the last delimiter if any basic code
            // points were copied; start at the beginning otherwise.

            for /* no final expression */
            (index = basic > 0 ? basic + 1 : 0; index < inputLength;) {
              // `index` is the index of the next character to be consumed.
              // Decode a generalized variable-length integer into `delta`,
              // which gets added to `i`. The overflow checking is easier
              // if we increase `i` as we go, then subtract off its starting
              // value at the end to obtain `delta`.
              for /* no condition */
              (oldi = i, w = 1, k = base;; k += base) {
                if (index >= inputLength) {
                  error('invalid-input');
                }
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) {
                  error('overflow');
                }
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) {
                  break;
                }
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) {
                  error('overflow');
                }
                w *= baseMinusT;
              }
              out = output.length + 1;
              bias = adapt(i - oldi, out, oldi == 0);

              // `i` was supposed to wrap around from `out` to `0`,
              // incrementing `n` each time, so we'll fix that now:
              if (floor(i / out) > maxInt - n) {
                error('overflow');
              }
              n += floor(i / out);
              i %= out;

              // Insert `n` at position `i` of the output
              output.splice(i++, 0, n);
            }
            return ucs2encode(output);
          }

          /**
           * Converts a string of Unicode symbols (e.g. a domain name label) to a
           * Punycode string of ASCII-only symbols.
           * @memberOf punycode
           * @param {String} input The string of Unicode symbols.
           * @returns {String} The resulting Punycode string of ASCII-only symbols.
           */
          function encode(input) {
            var n,
              delta,
              handledCPCount,
              basicLength,
              bias,
              j,
              m,
              q,
              k,
              t,
              currentValue,
              output = [],
              /** `inputLength` will hold the number of code points in `input`. */
              inputLength,
              /** Cached calculation results */
              handledCPCountPlusOne,
              baseMinusT,
              qMinusT;

            // Convert the input in UCS-2 to Unicode
            input = ucs2decode(input);

            // Cache the length
            inputLength = input.length;

            // Initialize the state
            n = initialN;
            delta = 0;
            bias = initialBias;

            // Handle the basic code points
            for (j = 0; j < inputLength; ++j) {
              currentValue = input[j];
              if (currentValue < 0x80) {
                output.push(stringFromCharCode(currentValue));
              }
            }
            handledCPCount = basicLength = output.length;

            // `handledCPCount` is the number of code points that have been handled;
            // `basicLength` is the number of basic code points.

            // Finish the basic string - if it is not empty - with a delimiter
            if (basicLength) {
              output.push(delimiter);
            }

            // Main encoding loop:
            while (handledCPCount < inputLength) {
              // All non-basic code points < n have been handled already. Find the next
              // larger one:
              for (m = maxInt, j = 0; j < inputLength; ++j) {
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) {
                  m = currentValue;
                }
              }

              // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
              // but guard against overflow
              handledCPCountPlusOne = handledCPCount + 1;
              if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
                error('overflow');
              }
              delta += (m - n) * handledCPCountPlusOne;
              n = m;
              for (j = 0; j < inputLength; ++j) {
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) {
                  error('overflow');
                }
                if (currentValue == n) {
                  // Represent delta as a generalized variable-length integer
                  for /* no condition */
                  (q = delta, k = base;; k += base) {
                    t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                    if (q < t) {
                      break;
                    }
                    qMinusT = q - t;
                    baseMinusT = base - t;
                    output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                    q = floor(qMinusT / baseMinusT);
                  }
                  output.push(stringFromCharCode(digitToBasic(q, 0)));
                  bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                  delta = 0;
                  ++handledCPCount;
                }
              }
              ++delta;
              ++n;
            }
            return output.join('');
          }

          /**
           * Converts a Punycode string representing a domain name or an email address
           * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
           * it doesn't matter if you call it on a string that has already been
           * converted to Unicode.
           * @memberOf punycode
           * @param {String} input The Punycoded domain name or email address to
           * convert to Unicode.
           * @returns {String} The Unicode representation of the given Punycode
           * string.
           */
          function toUnicode(input) {
            return mapDomain(input, function (string) {
              return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
            });
          }

          /**
           * Converts a Unicode string representing a domain name or an email address to
           * Punycode. Only the non-ASCII parts of the domain name will be converted,
           * i.e. it doesn't matter if you call it with a domain that's already in
           * ASCII.
           * @memberOf punycode
           * @param {String} input The domain name or email address to convert, as a
           * Unicode string.
           * @returns {String} The Punycode representation of the given domain name or
           * email address.
           */
          function toASCII(input) {
            return mapDomain(input, function (string) {
              return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
            });
          }

          /*--------------------------------------------------------------------------*/

          /** Define the public API */
          punycode = {
            /**
             * A string representing the current Punycode.js version number.
             * @memberOf punycode
             * @type String
             */
            'version': '1.3.2',
            /**
             * An object of methods to convert from JavaScript's internal character
             * representation (UCS-2) to Unicode code points, and back.
             * @see <https://mathiasbynens.be/notes/javascript-encoding>
             * @memberOf punycode
             * @type Object
             */
            'ucs2': {
              'decode': ucs2decode,
              'encode': ucs2encode
            },
            'decode': decode,
            'encode': encode,
            'toASCII': toASCII,
            'toUnicode': toUnicode
          };

          /** Expose `punycode` */
          // Some AMD build optimizers, like r.js, check for specific condition patterns
          // like the following:
          if (true) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
              return punycode;
            }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
          } else {}
        })(this);

        /***/
      }),
      /***/"./node_modules/uuid/dist/esm-browser/regex.js": (
      /*!*****************************************************!*\
        !*** ./node_modules/uuid/dist/esm-browser/regex.js ***!
        \*****************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony default export */
        __webpack_exports__["default"] = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

        /***/
      }),
      /***/"./node_modules/uuid/dist/esm-browser/rng.js": (
      /*!***************************************************!*\
        !*** ./node_modules/uuid/dist/esm-browser/rng.js ***!
        \***************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": function () {
            return /* binding */rng;
          }
          /* harmony export */
        });
        // Unique ID creation requires a high quality random # generator. In the browser we therefore
        // require the crypto API and do not support built-in fallback to lower quality random number
        // generators (like Math.random()).
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        var getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);
        var rnds8 = new Uint8Array(16);
        function rng() {
          if (!getRandomValues) {
            throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
          }
          return getRandomValues(rnds8);
        }

        /***/
      }),
      /***/"./node_modules/uuid/dist/esm-browser/stringify.js": (
      /*!*********************************************************!*\
        !*** ./node_modules/uuid/dist/esm-browser/stringify.js ***!
        \*********************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */
        var _validate_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./validate.js */"./node_modules/uuid/dist/esm-browser/validate.js");

        /**
         * Convert array of 16 byte values to UUID string format of the form:
         * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
         */

        var byteToHex = [];
        for (var i = 0; i < 256; ++i) {
          byteToHex.push((i + 0x100).toString(16).substr(1));
        }
        function stringify(arr) {
          var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          // Note: Be careful editing this code!  It's been tuned for performance
          // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
          var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
          // of the following:
          // - One or more input array values don't map to a hex octet (leading to
          // "undefined" in the uuid)
          // - Invalid input values for the RFC `version` or `variant` fields

          if (!(0, _validate_js__WEBPACK_IMPORTED_MODULE_0__.default)(uuid)) {
            throw TypeError('Stringified UUID is invalid');
          }
          return uuid;
        }

        /* harmony default export */
        __webpack_exports__["default"] = stringify;

        /***/
      }),
      /***/"./node_modules/uuid/dist/esm-browser/v4.js": (
      /*!**************************************************!*\
        !*** ./node_modules/uuid/dist/esm-browser/v4.js ***!
        \**************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */
        var _rng_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./rng.js */"./node_modules/uuid/dist/esm-browser/rng.js");
        /* harmony import */
        var _stringify_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./stringify.js */"./node_modules/uuid/dist/esm-browser/stringify.js");
        function v4(options, buf, offset) {
          options = options || {};
          var rnds = options.random || (options.rng || _rng_js__WEBPACK_IMPORTED_MODULE_0__.default)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

          rnds[6] = rnds[6] & 0x0f | 0x40;
          rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

          if (buf) {
            offset = offset || 0;
            for (var i = 0; i < 16; ++i) {
              buf[offset + i] = rnds[i];
            }
            return buf;
          }
          return (0, _stringify_js__WEBPACK_IMPORTED_MODULE_1__.default)(rnds);
        }

        /* harmony default export */
        __webpack_exports__["default"] = v4;

        /***/
      }),
      /***/"./node_modules/uuid/dist/esm-browser/validate.js": (
      /*!********************************************************!*\
        !*** ./node_modules/uuid/dist/esm-browser/validate.js ***!
        \********************************************************/
      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */
        var _regex_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./regex.js */"./node_modules/uuid/dist/esm-browser/regex.js");
        function validate(uuid) {
          return typeof uuid === 'string' && _regex_js__WEBPACK_IMPORTED_MODULE_0__.default.test(uuid);
        }

        /* harmony default export */
        __webpack_exports__["default"] = validate;

        /***/
      }),
      /***/"@angular/common": (
      /*!**********************************!*\
        !*** external "@angular/common" ***!
        \**********************************/
      /***/
      function (module) {
        "use strict";

        module.exports = __WEBPACK_EXTERNAL_MODULE__angular_common__;

        /***/
      }),
      /***/"@angular/core": (
      /*!********************************!*\
        !*** external "@angular/core" ***!
        \********************************/
      /***/
      function (module) {
        "use strict";

        module.exports = __WEBPACK_EXTERNAL_MODULE__angular_core__;

        /***/
      }),
      /***/"axios": (
      /*!************************!*\
        !*** external "axios" ***!
        \************************/
      /***/
      function (module) {
        "use strict";

        module.exports = __WEBPACK_EXTERNAL_MODULE_axios__;

        /***/
      }),
      /***/"rxjs": (
      /*!***********************!*\
        !*** external "rxjs" ***!
        \***********************/
      /***/
      function (module) {
        "use strict";

        module.exports = __WEBPACK_EXTERNAL_MODULE_rxjs__;

        /***/
      })

      /******/
    };
    /************************************************************************/
    /******/ // The module cache
    /******/
    var __webpack_module_cache__ = {};
    /******/
    /******/ // The require function
    /******/
    function __webpack_require__(moduleId) {
      /******/ // Check if module is in cache
      /******/var cachedModule = __webpack_module_cache__[moduleId];
      /******/
      if (cachedModule !== undefined) {
        /******/return cachedModule.exports;
        /******/
      }
      /******/ // Create a new module (and put it into the cache)
      /******/
      var module = __webpack_module_cache__[moduleId] = {
        /******/id: moduleId,
        /******/loaded: false,
        /******/exports: {}
        /******/
      };
      /******/
      /******/ // Execute the module function
      /******/
      __webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
      /******/
      /******/ // Flag the module as loaded
      /******/
      module.loaded = true;
      /******/
      /******/ // Return the exports of the module
      /******/
      return module.exports;
      /******/
    }
    /******/
    /************************************************************************/
    /******/ /* webpack/runtime/compat get default export */
    /******/
    !function () {
      /******/ // getDefaultExport function for compatibility with non-harmony modules
      /******/__webpack_require__.n = function (module) {
        /******/var getter = module && module.__esModule ? /******/function () {
          return module['default'];
        } : /******/function () {
          return module;
        };
        /******/
        __webpack_require__.d(getter, {
          a: getter
        });
        /******/
        return getter;
        /******/
      };
      /******/
    }();
    /******/
    /******/ /* webpack/runtime/define property getters */
    /******/
    !function () {
      /******/ // define getter functions for harmony exports
      /******/__webpack_require__.d = function (exports, definition) {
        /******/for (var key in definition) {
          /******/if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
            /******/Object.defineProperty(exports, key, {
              enumerable: true,
              get: definition[key]
            });
            /******/
          }
          /******/
        }
        /******/
      };
      /******/
    }();
    /******/
    /******/ /* webpack/runtime/global */
    /******/
    !function () {
      /******/__webpack_require__.g = function () {
        /******/if (typeof globalThis === 'object') return globalThis;
        /******/
        try {
          /******/return this || new Function('return this')();
          /******/
        } catch (e) {
          /******/if (typeof window === 'object') return window;
          /******/
        }
        /******/
      }();
      /******/
    }();
    /******/
    /******/ /* webpack/runtime/hasOwnProperty shorthand */
    /******/
    !function () {
      /******/__webpack_require__.o = function (obj, prop) {
        return Object.prototype.hasOwnProperty.call(obj, prop);
      };
      /******/
    }();
    /******/
    /******/ /* webpack/runtime/make namespace object */
    /******/
    !function () {
      /******/ // define __esModule on exports
      /******/__webpack_require__.r = function (exports) {
        /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
          /******/Object.defineProperty(exports, Symbol.toStringTag, {
            value: 'Module'
          });
          /******/
        }
        /******/
        Object.defineProperty(exports, '__esModule', {
          value: true
        });
        /******/
      };
      /******/
    }();
    /******/
    /******/ /* webpack/runtime/node module decorator */
    /******/
    !function () {
      /******/__webpack_require__.nmd = function (module) {
        /******/module.paths = [];
        /******/
        if (!module.children) module.children = [];
        /******/
        return module;
        /******/
      };
      /******/
    }();
    /******/
    /************************************************************************/
    var __webpack_exports__ = {};
    // This entry need to be wrapped in an IIFE because it need to be in strict mode.
    !function () {
      "use strict";

      /*!************************!*\
        !*** ./src/angular.ts ***!
        \************************/
      __webpack_require__.r(__webpack_exports__);
      /* harmony export */
      __webpack_require__.d(__webpack_exports__, {
        /* harmony export */"AngularPrismeLogger": function () {
          return /* reexport safe */_handlers_angularRequestHandler__WEBPACK_IMPORTED_MODULE_0__.AngularPrismeLogger;
        },
        /* harmony export */"PrismeLoggerInterceptor": function () {
          return /* reexport safe */_handlers_angularRequestHandler__WEBPACK_IMPORTED_MODULE_0__.PrismeLoggerInterceptor;
        },
        /* harmony export */"getPrismeLoggerInterceptorProvider": function () {
          return /* reexport safe */_handlers_angularRequestHandler__WEBPACK_IMPORTED_MODULE_0__.getPrismeLoggerInterceptorProvider;
        }
        /* harmony export */
      });
      /* harmony import */
      var _handlers_angularRequestHandler__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./handlers/angularRequestHandler */"./src/handlers/angularRequestHandler.ts");
    }();
    /******/
    return __webpack_exports__;
    /******/
  }();
});
